/* eslint-disable no-unused-vars, jsx-a11y/anchor-is-valid, jsx-a11y/alt-text, eqeqeq */
/* eslint-disable no-unused-vars, jsx-a11y/anchor-is-valid, jsx-a11y/alt-text, eqeqeq */
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import FullCalendar from "@fullcalendar/react";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import Select from "react-select";
import DOMPurify from "dompurify";
import { useTranslation } from 'react-i18next';
import { parseDateStringToLocalDate } from "./dateUtils";

import Close from "../../assets/images/icons/close.svg";
import PlusButton from "../../assets/images/icons/white-plus.svg";
import zoomOutIcon from "../../assets/images/icons/zoomOut.svg";
import zoomInIcon from "../../assets/images/icons/zoomIn.svg";

import GrayStar from "../../assets/images/icons/gray-star.svg"

import ParkingIcon from "../../assets/images/parking-booking.png"
import DeskIcon from "../../assets/images/desk-booking.png"
import Informationicon from "../../assets/images/icons/informationicon.svg"
import InformationIconGray from "../../assets/images/icons/informationicongray.svg"
import InformationEyeIcon from "../../assets/images/icons/informationEyeicon.svg"
import InformationCloseIcon from "../../assets/images/icons/InformationCloseIcon.svg"
import LeaveQueueIcon from "../../assets/images/icons/user-booking.svg"
import JoinQueueIcon from "../../assets/images/icons/user-in-join-queue.svg"
import { Images } from "../Common/Images"
import { formatDateToEEEddMMM, formatReactString, getDisplayRefundCreditValue } from "../../utils/CommonUtils"
import CheckInIcon from "../../assets/images/icons/checkin-checkout.svg"
import EditSquare from "../../assets/images/icons/edit-square.svg"
import closeIcon from "../../assets/images/icons/black-cancel-icon.svg"
import {
    BASE_URL,
    App_version,
    OsVersion,
    DeviceId,
    ManufactureModel,
    fetchWithTokenRefresh2,
    MeetingRoom_api,
    MapCanvas_api,
    MapBasedBooking_api,
    MakeBooking_api,
    MeetingRoomListAndInfo,
    GetParticipantsForMeeting,
    CancelBooking_API_Map,
    CancelBooking_API_LeaveQueue,
    CheckInUser_API,
    CheckOutUser_API
} from "../apiUtils";


import { MapBasedBooking_apiBookingStatus, PostBookingQuestion_api, BookingStatus_api } from "../WeeklyCalendar/WeeklyCalendarAPI"
import { get } from "jquery";
import NewMeetingModal from "../Common/NewMeetingModal";

import PostbookingQueModal from "../Common/PostbookingQueModal";
import CustomSearchableDropdown from "../Common/CustomSearchableDropdown";
import NotificationMessage from "../Common/NotificationMessage.jsx";
import { handleApiResponse } from "../../hooks/notificationHelper.js";
import { handleApiResponsemap } from "../../hooks/mapnotificationHelper.js";
import { AppConstant } from "../../config/AppConstants.js";
import { useApiUiResponse } from "../../hooks/apiUiResponseHelper.js";
import CustomDatePicker from "../Common/CustomDatePicker.jsx";
// import * as authMemory from '../../services/authMemory';

export default function MapCanvasZone({ zoneData,
    selectedZone,
    bookingDate,
    setBookingDate,
    startDate,
    changeddate,
    setStartDate,
    setchangeddate,
    teamLeadFlag,
    vehicleIds = [],
    bookingtimeSlots = [],
    vehicleMap,
    teamMemberGuId,
    LoaderFull,
    safeTeamId,
    safeIsGuest,
    GuestVehicle,
    zoneCreditValue,
    individualDayCost,
    refreshZoneAfterBooking,
    showRoleIcons,
    showBookingForStaff,
    showAvailabilityColour,
    mapFontSize,
    preBookinQueCanvas,
    parkingInformationImage,
    zoneTypeforUserIcon,

    leaveQueueParam,
    joinQueuueParam,
    queuePositoin,

    checkInBtn,
    checkOutBtn,
    checkInFlag,
    syncZoneUiFlagsFromRecords,
    selectedName,
    selectedMemberData,
    CellLoader,
    mapZoomLevel,
    WarningIcon,
    WarningcloseIcon,
    isHoliday,
    guestConfirmation
}) {
    const { t } = useTranslation()
    const [spots, setSpots] = useState([]);
    const [isLoadingMap, setIsLoadingMap] = useState(true);
    const [selectedSpot, setSelectedSpot] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [showTags, setShowTags] = useState(false);
    const meetingCreatedDateRef = useRef(null);
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [pickerMonth, setPickerMonth] = useState(new Date());
    const getGuId = () => sessionStorage.getItem("guId");
    const getUserId = () => sessionStorage.getItem("id");

    const getLastName = () => sessionStorage.getItem("lastname");
    const getFirstName = () => sessionStorage.getItem("firstname");
    const getEmail = () => sessionStorage.getItem("email");
    const getLicensePlateID = () => sessionStorage.getItem("LicensePlateID");
    // const getGuId = () => authMemory.getGuId(); //reactmemory version
    // const getUserId = () => authMemory.getUserId(); //reactmemory version

    // Time selection states
    const [meetingName, setMeetingName] = useState("");
    const [selectedFrom, setSelectedFrom] = useState("");
    const [selectedTo, setSelectedTo] = useState("");
    const [showSlots, setShowSlots] = useState(false);
    const [timeSlots, setTimeSlots] = useState([]);

    const [showGuestForm, setShowGuestForm] = useState(false);
    const [GuestParticipants, setGuestParticipants] = useState([]);

    const [events, setEvents] = useState([]); // FullCalendar events
    const [timeIntervals, setTimeIntervals] = useState({
        start: "09:00:00",
        end: "19:00:00",
        RepeatOptionByLiftRestriction: 1,
    });
    const [meetingRoomData, setMeetingRoomData] = useState([]);

    const [participantsList, setParticipantsList] = useState([]);
    const [selectedParticipants, setSelectedParticipants] = useState([]);
    const [selectedOption, setSelectedOption] = useState(null);
    const [currentStep, setCurrentStep] = useState(1);
    const [check_IsUserApprover, setcheck_IsUserApprover] = useState(null);
    const [searchText, setSearchText] = useState("");
    const [selectedVehiclePrimaryKey, setSelectedVehiclePrimaryKey] = useState("");
    const [selectedVehicle, setSelectedVehicle] = useState(null);

    const [guestVehicleOpen, setGuestVehicleOpen] = useState(false);
    const [guestFuelOpen, setGuestFuelOpen] = useState(false);

    const [selectedGuestVehicleType, setSelectedGuestVehicleType] = useState(null);
    const [selectedGuestFuelType, setSelectedGuestFuelType] = useState(null);
    const [selectedGuestAccessibleType, setSelectedGuestAccessibleType] = useState(null);
    const [selectedGuestShareableType, setSelectedGuestShareableType] = useState(null);

    const [showCancelModal, setShowCancelModal] = useState(false);
    const [selectedSlot, setSelectedSlot] = useState("");
    const [selectedSlotValues, setSelectedSlotValues] = useState([]);
    const [slotRangeAnchor, setSlotRangeAnchor] = useState("");

    const [showCancelModalfor30mit, setShowCancelModalfor30mit] = useState(false)

    const [showLeaveQueueModal, setShowLeaveQueueModal] = useState(false)
    const [showJoinQueueModal, setShowJoinQueueModal] = useState(false)
    const [showReleaseAdditionalBooking, setShowReleaseAdditionalBooking] = useState(false);
    const [releaseIs30MinSpot, setReleaseIs30MinSpot] = useState(false);
    const [isThirtyMinuteModalReadOnly, setIsThirtyMinuteModalReadOnly] = useState(false);
    const [roleInfoSpot, setRoleInfoSpot] = useState(null);
    const [meetingInfoSpot, setMeetingInfoSpot] = useState(null);

    const [showAdditionalBooking, setShowAdditionalBooking] = useState(false);

    const [vehicleOpen, setVehicleOpen] = useState(false);
    const [slotOpen, setSlotOpen] = useState(false);
    const [repeatOpen, setRepeatOpen] = useState(false);

    const [requiredFields, setRequiredFields] = useState({});
    // Fix: Add missing loadingDates state
    const [loadingDates, setLoadingDates] = useState([]);
    // Fix: Add missing timeOutTime (default 1000ms)
    const timeOutTime = 1000;

    const [note, setNote] = useState("");
    const [maxDate, setMaxDate] = useState(null);

    const calendarRef = useRef(null);
    const autoDisabledManualSlotsRef = useRef(false);
    const autoSelectedSpotSlotRef = useRef(null);
    const slotContainerRef = useRef(null);


    const [dateforfullday, setDateforfullday] = useState("");
    const [monthforfullday, setMonthforfullday] = useState("");
    const [yearforfullday, setYearforfullday] = useState("");

    // Repeat options
    const [repeatType, setRepeatType] = useState(0);
    const [monthlyRepeatOption, setMonthlyRepeatOption] = useState(0);
    const [endDate, setEndDate] = useState(null);
    const [weeklyRepeatOption, setWeeklyRepeatOption] = useState([]);

    // Guest option
    const [showGuestPopupFullday, setshowGuestPopupFullday] = useState(false);
    const [guestName, setGuestName] = useState("");
    const [guestLastName, setGuestLastName] = useState("")
    const [guestEmail, setGuestEmail] = useState("");
    const [identificatoin, setIdentification] = useState("")
    const [vehicleRegistrationNumber, setVehicleRegistrationNumber] = useState("")

    const [showGuestPopup30mit, setShowGuestPopup30mit] = useState(false);
    const [guestName30mit, setGuestName30mit] = useState("")
    const [guestLastName30mit, setGuestLastName30mit] = useState("")
    const [guestEmail30mit, setGuestEmail30mit] = useState("");
    const [identificatoin30mit, setIdentification30mit] = useState("")
    const [vehicleRegistrationNumber30mit, setVehicleRegistrationNumber30mit] = useState("")

    const [showGuestPopupHourly, setShowGuestPopupHourly] = useState(false);
    const [guestNameHourly, setGuestNameHourly] = useState("")
    const [guestLastNameHourly, setGuestLastNameHourly] = useState("")
    const [guestEmailHourly, setGuestEmailHourly] = useState("");
    const [identificatoinHourly, setIdentificationHourly] = useState("")
    const [vehicleRegistrationNumberHourly, setVehicleRegistrationNumberHourly] = useState("")
    const [guestErrors, setGuestErrors] = useState({
        fullDay: {
            firstname: "",
            lastname: "",
            email: ""
        },
        thirtyMin: {
            firstname: "",
            lastname: "",
            email: ""
        },
        hourly: {
            firstname: "",
            lastname: "",
            email: ""
        }
    });

    const [showPostbookingQueModal, setShowPostbookingQueModal] = useState(false);
    const [postbookingQueModalData, setPostbookingQueModalData] = useState([]);
    const [guestBookingConfirmation, setGuestBookingConfirmation] = useState(null);
    const [postRequestParams, setPostRequestParams] = useState(null);

    const [checkedPreBookingQue, setCheckedPreBookingQue] = useState(false);

    const [showParkingOptions, setShowParkingOptions] = useState(false);

    const [notification, setNotification] = useState(null);
    const [showBookingProcess, setShowBookingProcess] = useState(false);
    const { handleApiUiResponse, renderApiUi } = useApiUiResponse(t);
    const bookingModalParticipantName = safeIsGuest === 1
        ? selectedSpot?.GuestName || t("guest")
        : selectedMemberData?.FullName || selectedName || getFirstName() + " " + getLastName();
    const closeGuestBookingConfirmation = () => setGuestBookingConfirmation(null);
    const openGuestBookingConfirmation = (mapResponse, reqParams = {}) => {
        if (Number(reqParams?.IsGuest) !== 1) {
            return;
        }

        const records = mapResponse?.Data?.Records || {};
        const bookedDate =
            reqParams?.BookingDateStr ||
            reqParams?.BookingDate ||
            "";
        const zoneName =
            records?.ZoneName ||
            records?.Zone?.ZoneName ||
            records?.Layout?.[0]?.ZoneName ||
            selectedZone?.ZoneName ||
            selectedZone?.Name ||
            "";
        const name =
            [
                reqParams?.GuestFirstName,
                reqParams?.GuestLastName,
            ]
                .filter(Boolean)
                .join(" ")
                .trim() ||
            records?.GuestName ||
            records?.Name ||
            records?.FullName ||
            t("guest");

        setGuestBookingConfirmation({
            name,
            zoneName,
            bookedDate,
            spotName: reqParams?.SpotName || "",
            startTime: reqParams?.BookingStartTime || "",
            endTime: reqParams?.BookingEndTime || "",
        });
    };
    const emailPattern = /^[a-zA-Z0-9_.\-^'`?=]+@([a-zA-Z0-9-]+\.)+([a-zA-Z0-9]{2,4})$/;

    const clearGuestErrors = (section) => {
        setGuestErrors((prev) => ({
            ...prev,
            [section]: {
                firstname: "",
                lastname: "",
                email: ""
            }
        }));
    };

    const clearGuestFieldError = (section, field) => {
        setGuestErrors((prev) => ({
            ...prev,
            [section]: {
                ...prev[section],
                [field]: ""
            }
        }));
    };

    const validateGuestFields = ({ name, surname, email }, section) => {
        const newErrors = {
            firstname: "",
            lastname: "",
            email: ""
        };

        let isValid = true;

        if (!(name || "").trim()) {
            newErrors.firstname = t("please_enter_valid_firstname");
            isValid = false;
        }

        if (!(surname || "").trim()) {
            newErrors.lastname = t("enter_lastname");
            isValid = false;
        }

        const trimmedEmail = (email || "").trim();
        if (!trimmedEmail || !emailPattern.test(trimmedEmail)) {
            newErrors.email = t("enter_your_valid_email_address");
            isValid = false;
        }

        setGuestErrors((prev) => ({
            ...prev,
            [section]: newErrors
        }));

        return isValid;
    };

    // const [scale, setScale] = useState(1);
    // const [step, setStep] = useState(2);

    // const total = 20 + step * 20;
    // const scale = 0.5 + step * 0.5;

    // // const zoomIn = () => setScale(s => Math.min(s + 0.1, 3));
    // // const zoomOut = () => setScale(s => Math.max(s - 0.1, 0.5));
    // // const resetZoom = () => setScale(1);

    // const zoomIn = () => {
    //     setStep(prev => Math.min(prev + 1, 4)); // max 5 steps
    // };

    // const zoomOut = () => {
    //     setStep(prev => Math.max(prev - 1, 0));
    // };
    const [zoom, setZoom] = useState(mapZoomLevel || 50); // 50 default
    const scale = zoom / 100;   // 50 → 0.5
    const total = zoom;         // for UI
    const zoomIn = () => {
        setZoom(prev => Math.min(prev + 10, 100)); // max 100
    };

    const zoomOut = () => {
        setZoom(prev => Math.max(prev - 10, 10)); // min 10 (or 20 if needed)
    };

    const options = participantsList.map(p => ({
        value: p.Id,
        label: `${p.FirstName} ${p.LastName} (${p.PrimaryEmail})`,
        data: p
    }));

    // Get slots for the selected spot
    const spotBookingSlots =
        selectedSpot?.BookingTimeSlots && Array.isArray(selectedSpot.BookingTimeSlots)
            ? selectedSpot.BookingTimeSlots
            : [];
    console.log("spotBookingSlots:", spotBookingSlots)

    const buildSlotRange = (slots = []) => {
        if (!slots.length) return "";

        const sortedSlots = [...slots].sort(
            (a, b) => spotBookingSlots.indexOf(a) - spotBookingSlots.indexOf(b)
        );
        const [firstStart] = sortedSlots[0].split("-").map((part) => part.trim());
        const [, lastEnd = ""] = sortedSlots[sortedSlots.length - 1].split("-").map((part) => part.trim());

        return lastEnd ? `${firstStart} - ${lastEnd}` : sortedSlots[0];
    };

    const handleSpotBookingSlotToggle = (slot) => {
        const clickedIndex = spotBookingSlots.indexOf(slot);
        if (clickedIndex < 0) return;

        let updatedSlots = [];
        const selectedStartIndex =
            selectedSlotValues.length > 0
                ? spotBookingSlots.indexOf(selectedSlotValues[0])
                : -1;
        const selectedEndIndex =
            selectedSlotValues.length > 0
                ? spotBookingSlots.indexOf(selectedSlotValues[selectedSlotValues.length - 1])
                : -1;

        if (selectedSlotValues.length === 0 || selectedStartIndex < 0 || selectedEndIndex < 0) {
            updatedSlots = [slot];
            setSlotRangeAnchor(slot);
            setSelectedSlotValues(updatedSlots);
            setSelectedSlot(buildSlotRange(updatedSlots));
            setRequiredFields((prev) => ({
                ...prev,
                spot: ""
            }));
            return;
        }

        if (clickedIndex >= selectedStartIndex && clickedIndex <= selectedEndIndex) {
            if (selectedSlotValues.length === 1) {
                updatedSlots = [];
            } else if (clickedIndex === selectedStartIndex) {
                updatedSlots = [spotBookingSlots[selectedStartIndex]];
            } else {
                updatedSlots = spotBookingSlots.slice(selectedStartIndex, clickedIndex);
            }
            setSelectedSlotValues(updatedSlots);
            setSelectedSlot(buildSlotRange(updatedSlots));
            setSlotRangeAnchor(updatedSlots[0] || "");
            setRequiredFields((prev) => ({
                ...prev,
                spot: ""
            }));
            return;
        }

        const anchorIndex = spotBookingSlots.indexOf(slotRangeAnchor);

        if (!slotRangeAnchor || anchorIndex < 0 || anchorIndex === clickedIndex) {
            updatedSlots = [slot];
            setSlotRangeAnchor(slot);
        } else {
            const startIndex = Math.min(anchorIndex, clickedIndex);
            const endIndex = Math.max(anchorIndex, clickedIndex);
            updatedSlots = spotBookingSlots.slice(startIndex, endIndex + 1);
        }

        setSelectedSlotValues(updatedSlots);
        setSelectedSlot(buildSlotRange(updatedSlots));
        setRequiredFields((prev) => ({
            ...prev,
            spot: ""
        }));
    };

    useEffect(() => {
        if (!slotOpen || !spotBookingSlots.length || !slotContainerRef.current) {
            return;
        }

        slotContainerRef.current.scrollIntoView({
            behavior: "smooth",
            block: "nearest"
        });
    }, [slotOpen, spotBookingSlots]);

    useEffect(() => {
        if (zoneData) {
            setSpots(zoneData.Layout || []);
            setIsLoadingMap(false);
            handleDateFormat()
        } else {
            setIsLoadingMap(true);
        }
    }, [zoneData]);

    useEffect(() => {
        if (!changeddate || !selectedSpot) return;

        const slotWiseTypes = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
        const shouldCallAPI =
            (
                selectedSpot.SpotType === 3 ||
                selectedSpot.HourlySpot === 1 &&
                selectedSpot.ClaimFlag === 1 &&
                selectedSpot.BookingTimeType === 0
            )
            &&
            !slotWiseTypes.includes(selectedSpot.BookingTimeType);

        if (shouldCallAPI) {
            MeetingRoomListInfo();
        }
    }, [changeddate, selectedSpot]);

    // const handleSpotClick = (spot) => {
    //     if (!isSpotClickable(spot)) return;
    //     setSelectedSpot(spot);
    //     setShowModal(true);

    //     const slotWiseTypes = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
    //     const shouldCallAPI =
    //         !(
    //             spot.SpotType === 2 ||
    //             slotWiseTypes.includes(spot.BookingTimeType)
    //         );
    //     if (shouldCallAPI) {
    //         MeetingRoomListInfo();
    //         fetchParticipants(spot.SpotId);
    //     }
    // };

    //    useEffect(() => {
    //         if (selectedDate && selectedSpot) {
    //             MeetingRoomListInfo();
    //         }
    //     }, [selectedDate, selectedSpot]);

    //     const handleSpotClick = (spot) => {
    //         if (isSpotClickable(spot)) {
    //             setSelectedSpot(spot);
    //             setShowModal(true);
    //             MeetingRoomListInfo();
    //             fetchParticipants(spot.SpotId);
    //         }
    //     };


    const handleDateFormat = () => {
        // 1. Split the string by the hyphen
        // If changeddate is "2026-01-12", this creates an array: ["2026", "01", "12"]
        const dateParts = bookingDate.split('-');

        // 2. Destructure the array into individual variables
        setYearforfullday(dateParts[0]);
        // const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        const monthNames = [
            t("January"), t("February"), t("March"), t("April"),
            t("May"), t("June"), t("July"), t("August"),
            t("September"), t("October"), t("November"), t("December")
        ];
        const monthName = monthNames[parseInt(dateParts[1]) - 1];
        setMonthforfullday(monthName);
        setDateforfullday(dateParts[2]);

        // console.log("Formatted Date:", `${day}-${month}`);
        // return `${day}-${month}-${year}`;
    };

    const openReleaseCancelModal = (spot, { showAdditionalBookingTime = false, is30MinSpot = false, readOnly30Min = false } = {}) => {
        setSelectedSpot(spot);
        setShowModal(false);
        setShowLeaveQueueModal(false);
        setShowJoinQueueModal(false);
        setShowAdditionalBooking(false);
        setShowReleaseAdditionalBooking(false);
        setReleaseIs30MinSpot(is30MinSpot);
        setIsThirtyMinuteModalReadOnly(Boolean(readOnly30Min && is30MinSpot));

        if (showAdditionalBookingTime) {
            setShowCancelModal(false);
            setShowCancelModalfor30mit(false);
            setShowReleaseAdditionalBooking(true);
            return;
        }

        setShowCancelModalfor30mit(is30MinSpot);
        setShowCancelModal(!is30MinSpot);
    };

    const openHourlyGridBookingModal = async (spot, { readOnly = false, loadRoomInfo = false } = {}) => {
        resetDraftBookingDate(bookingDate);
        setSelectedSpot(spot);
        setShowLeaveQueueModal(false);
        setShowJoinQueueModal(false);
        setShowCancelModal(false);
        setShowCancelModalfor30mit(false);
        setShowAdditionalBooking(false);
        setShowReleaseAdditionalBooking(false);
        setReleaseIs30MinSpot(false);
        setIsThirtyMinuteModalReadOnly(readOnly);
        setShowModal(true);

        if (loadRoomInfo) {
            await MeetingRoomListInfo(spot);
        }
    };

    const openStandardBookingModal = (spot) => {
        resetDraftBookingDate(bookingDate);
        setSelectedSpot(spot);
        setShowLeaveQueueModal(false);
        setShowJoinQueueModal(false);
        setShowCancelModal(false);
        setShowCancelModalfor30mit(false);
        setShowReleaseAdditionalBooking(false);
        setIsThirtyMinuteModalReadOnly(false);
        setShowModal(true);
    };

    const handleSpotClick = (spot) => {
        console.warn("CANVASCLICK")
        const bookingTimeSlots = Array.isArray(spot?.BookingTimeSlots)
            ? spot.BookingTimeSlots
            : [];
        const guestVehicleTypes = Array.isArray(spot?.GuestVehicleTypes)
            ? spot.GuestVehicleTypes
            : [];
        const guestFuelTypes = Array.isArray(spot?.GuestFuelTypes)
            ? spot.GuestFuelTypes
            : [];
        const employeeVehicleType = Array.isArray(spot?.EmployeeVehicleType)
            ? spot.EmployeeVehicleType
            : [];
        const queueEmployeeVehicleType = employeeVehicleType.length > 0;
        const isClaimFlagOne = spot.ClaimFlag === 1;
        const isClaimFlagTwo = spot.ClaimFlag === 2;
        const isClaimFlagThree = spot.ClaimFlag === 3;
        const isReleaseEntry = isClaimFlagTwo;
        const isMeetingRoom = spot.SpotType === 3;
        const isHourly = spot.HourlySpot === 1;
        const isAllDay = spot.IsAllDaySpot === 1;
        const hasSlots = bookingTimeSlots.length > 0;
        const noSlots = bookingTimeSlots.length === 0;
        const isPartiallyBooked = spot.IsPartiallyBooked === 1;
        const showRelease = spot.ShowRelease === 1;
        const bookingTimeType = Number(spot.BookingTimeType);
        const hasBookingTimeType = Number.isFinite(bookingTimeType) && bookingTimeType >= 0;
        const is30MinSpot = bookingTimeType === 0;
        const isOwnedByCurrentUser =
            isClaimFlagTwo || showRelease;
        const isHourlyOrThirtyMinuteSpot =
            isHourly || hasBookingTimeType;
        const hasRemainingHourlyAvailability = hasSlots;
        const isFullyBookedHourlyOrThirtyMinuteSpot =
            isHourlyOrThirtyMinuteSpot && !hasRemainingHourlyAvailability;
        const shouldBlockForVehicle =
            zoneData?.ZoneType == 1 &&
            employeeVehicleType.length === 0 &&
            safeIsGuest == 0;
        const hasPendingRequest =
            spot?.IsClaimPendingRequest === 1 ||
            spot?.IsClaimPendingRequestForSpot === 1 ||
            spot?.isClaimPendingRequest === 1 ||
            spot?.isClaimPendingRequestForSpot === 1;
        const missingGuestVehicleSetup =
            safeIsGuest == 1 &&
            zoneData?.ZoneType == 1 &&
            (guestVehicleTypes.length === 0 || guestFuelTypes.length === 0);
        const shouldBlockHourlyBookingForVehicle =
            shouldBlockForVehicle || missingGuestVehicleSetup;
        const shouldBlockParkingBooking =
            zoneData?.ZoneType == 1 &&
            (
                (safeIsGuest == 1 && (guestVehicleTypes.length === 0 || guestFuelTypes.length === 0)) ||
                (safeIsGuest == 0 && employeeVehicleType.length === 0)
            );

        if (isClaimFlagOne && hasPendingRequest) {
            openHourlyGridBookingModal(spot, {
                readOnly: true,
            });
            return;
        }

        if (isClaimFlagOne && shouldBlockParkingBooking) {
            openHourlyGridBookingModal(spot, {
                readOnly: true,
            });
            return;
        }

        if (isClaimFlagOne && isAllDay) {
            openStandardBookingModal(spot);
            return;
        }

        if (isClaimFlagOne && isPartiallyBooked && isHourly && showRelease) {
            setSelectedSpot(spot);
            setShowModal(false);
            setShowCancelModal(false);
            setShowCancelModalfor30mit(false);
            setShowLeaveQueueModal(false);
            setShowJoinQueueModal(false);
            setIsThirtyMinuteModalReadOnly(false);
            setShowAdditionalBooking(true);
            return;
        }

        if (isClaimFlagOne && isHourly) {
            openHourlyGridBookingModal(spot, {
            });
            return;
        }

        if (isClaimFlagTwo && spot.ShowRelease === 0) {
            if (isAllDay) {
                openReleaseCancelModal(spot, {
                    showAdditionalBookingTime: false,
                    is30MinSpot: false,
                });
                return;
            }
            if (isHourly) {
                openHourlyGridBookingModal(spot, {
                    readOnly: true,
                    loadRoomInfo: true,
                });
                return;
            }

            openHourlyGridBookingModal(spot, {
                loadRoomInfo: true,
            });
            return;
        }

        if (isClaimFlagOne && isMeetingRoom) {
            openStandardBookingModal(spot);

            const slotWiseTypes = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
            const shouldCallAPI =
                !(
                    spot.SpotType === 2 ||
                    slotWiseTypes.includes(spot.BookingTimeType)
                );
            if (shouldCallAPI) {
                if (spot.SpotType !== 3) {
                    MeetingRoomListInfo();
                }
                fetchParticipants(spot.SpotId);
            }
            return;
        }

        if (isReleaseEntry) {
            if (isMeetingRoom) {
                openStandardBookingModal(spot);

                const slotWiseTypes = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
                const shouldCallAPI =
                    !(
                        spot.SpotType === 2 ||
                        slotWiseTypes.includes(spot.BookingTimeType)
                    );
                if (shouldCallAPI) {
                    if (spot.SpotType !== 3) {
                        MeetingRoomListInfo();
                    }
                    fetchParticipants(spot.SpotId);
                }
                return;
            }

            if (isClaimFlagTwo && isHourlyOrThirtyMinuteSpot) {
                if (shouldBlockHourlyBookingForVehicle) {
                    openHourlyGridBookingModal(spot, {
                        readOnly: true,
                    });
                    return;
                }

                if (isOwnedByCurrentUser && isPartiallyBooked && hasRemainingHourlyAvailability) {
                    openReleaseCancelModal(spot, {
                        showAdditionalBookingTime: true,
                        is30MinSpot: true,
                    });
                    return;
                }

                if (!isOwnedByCurrentUser && isFullyBookedHourlyOrThirtyMinuteSpot) {
                    openHourlyGridBookingModal(spot, {
                        readOnly: true,
                        loadRoomInfo: true,
                    });
                    return;
                }

                if (isOwnedByCurrentUser && isFullyBookedHourlyOrThirtyMinuteSpot) {
                    openReleaseCancelModal(spot, {
                        showAdditionalBookingTime: false,
                        is30MinSpot: true,
                    });
                    return;
                }
            }

            if (isClaimFlagTwo && isHourly && noSlots && hasBookingTimeType) {
                if (!showRelease) {
                    openHourlyGridBookingModal(spot, {
                        loadRoomInfo: true,
                    });
                    return;
                }

                if (shouldBlockHourlyBookingForVehicle) {
                    openHourlyGridBookingModal(spot, {
                        readOnly: true,
                    });
                    return;
                }

                openReleaseCancelModal(spot, {
                    showAdditionalBookingTime: isPartiallyBooked,
                    is30MinSpot,
                });
                return;
            }

            if (isHourly) {
                if (isPartiallyBooked && showRelease && hasBookingTimeType && hasSlots) {
                    if (shouldBlockHourlyBookingForVehicle) {
                        openHourlyGridBookingModal(spot, {
                            readOnly: true,
                        });
                        return;
                    }

                    openReleaseCancelModal(spot, {
                        showAdditionalBookingTime: true,
                        is30MinSpot,
                    });
                    return;
                }

                if (bookingTimeType > 0 && hasSlots) {
                    if (isClaimFlagTwo) {
                        openHourlyGridBookingModal(spot, {
                            loadRoomInfo: true,
                        });
                    } else {
                        openStandardBookingModal(spot);
                    }
                    return;
                }

                if (shouldBlockHourlyBookingForVehicle) {
                    openHourlyGridBookingModal(spot, {
                        readOnly: true,
                    });
                    return;
                }

                openHourlyGridBookingModal(spot, {
                    loadRoomInfo: true,
                });
                return;
            }

            if (bookingTimeType > 0 && hasSlots) {
                openStandardBookingModal(spot);
                return;
            }

            if (hasBookingTimeType && noSlots && showRelease) {
                openReleaseCancelModal(spot, {
                    showAdditionalBookingTime: false,
                    is30MinSpot: false,
                });
                return;
            }

            if (shouldBlockForVehicle) return;

            openStandardBookingModal(spot);
            return;
        }

        if (isClaimFlagThree && isAllDay && !queueEmployeeVehicleType && zoneData?.ZoneType == 1) {
            openHourlyGridBookingModal(spot, {
                readOnly: true,
            });
            return;
        }

        if (isClaimFlagThree && isAllDay && leaveQueueParam == 1) {
            setSelectedSpot(spot);
            setShowModal(false)
            setShowCancelModal(false);
            setShowCancelModalfor30mit(false);
            setShowJoinQueueModal(false);
            setShowReleaseAdditionalBooking(false);
            setIsThirtyMinuteModalReadOnly(false);
            setShowLeaveQueueModal(true);
            return;
        }
        if (isClaimFlagThree && isAllDay && joinQueuueParam == 1) {
            setSelectedSpot(spot);
            setShowModal(false)
            setShowCancelModal(false);
            setShowCancelModalfor30mit(false);
            setShowLeaveQueueModal(false);
            setShowReleaseAdditionalBooking(false);
            setIsThirtyMinuteModalReadOnly(false);
            setShowJoinQueueModal(true);
            return;
        }

        if (isClaimFlagThree) {
            return;
        }

        if (!isSpotClickable(spot)) return;
        if (isHourlyOrThirtyMinuteSpot) {
            if (shouldBlockHourlyBookingForVehicle) {
                openHourlyGridBookingModal(spot, {
                    readOnly: true,
                });
                return;
            }

            if (isOwnedByCurrentUser && isPartiallyBooked && hasRemainingHourlyAvailability) {
                setSelectedSpot(spot);
                setShowModal(false);
                setShowCancelModal(false);
                setShowCancelModalfor30mit(false);
                setShowLeaveQueueModal(false);
                setShowJoinQueueModal(false);
                setShowReleaseAdditionalBooking(false);
                setIsThirtyMinuteModalReadOnly(false);
                setShowAdditionalBooking(true);
                return;
            }

            if (!isOwnedByCurrentUser && isFullyBookedHourlyOrThirtyMinuteSpot) {
                openHourlyGridBookingModal(spot, {
                    readOnly: true,
                    loadRoomInfo: true,
                });
                return;
            }

            if (isOwnedByCurrentUser && isFullyBookedHourlyOrThirtyMinuteSpot) {
                openReleaseCancelModal(spot, {
                    showAdditionalBookingTime: false,
                    is30MinSpot: true,
                });
                return;
            }
        }

        openStandardBookingModal(spot);

        const slotWiseTypes = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
        const shouldCallAPI =
            !(
                spot.SpotType === 2 ||
                slotWiseTypes.includes(spot.BookingTimeType)
            );
        if (shouldCallAPI) {
            if (spot.SpotType !== 3) {
                MeetingRoomListInfo();
            }
            fetchParticipants(spot.SpotId);
        }
    };

    // const handleSpotClick = (spot) => {
    //     if (spot.ClaimFlag === 2) {
    //         // Open cancel spot popup
    //         setSelectedSpot(spot);
    //         setShowModal(false);
    //         setShowCancelModal(true);
    //         return;
    //     }
    //     if (!isSpotClickable(spot)) return;
    //     setSelectedSpot(spot);
    //     setShowModal(true);

    //     const slotWiseTypes = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
    //     const shouldCallAPI =
    //         !(
    //             spot.SpotType === 2 ||
    //             slotWiseTypes.includes(spot.BookingTimeType)
    //         );
    //     if (shouldCallAPI) {
    //         MeetingRoomListInfo();
    //         fetchParticipants(spot.SpotId);
    //     }
    // };

    const isSpotClickable = (item) =>
        (item.ClaimFlag === 1 || item.ClaimFlag === 2) &&
        (item.SpotType === 3 ||
            item.HourlySpot === 1 ||
            item.IsHourlySpotAvailable === 1 ||
            item.IsAllDaySpot === 1 ||
            item.ShowRelease === 1);

    const resetDraftBookingDate = (dateOverride = bookingDate) => {
        if (dateOverride) {
            setchangeddate(dateOverride);
            setStartDate(dateOverride);
        }
    };

    const refreshMapForActiveDate = async () => {
        await refreshZoneAfterBooking(selectedZone, changeddate || bookingDate);
    };

    const refreshParentMapForBookingDate = async (dateOverride) => {
        const resolvedDate = dateOverride || getCalendarDateString() || activeBookingDate || bookingDate;

        if (!resolvedDate) {
            console.warn("[30-minute calendar] Cannot refresh parent map: invalid booking date", {
                dateOverride,
                changeddate,
                bookingDate,
            });
            return;
        }

        resetForm(resolvedDate);
        await refreshZoneAfterBooking(selectedZone, resolvedDate);
    };

    const activeBookingDate = changeddate || bookingDate;

    const getSafePickerDate = (value) => {
        if (!value) return null;

        if (value instanceof Date) {
            return Number.isNaN(value.getTime()) ? null : value;
        }

        const parsed = parseDateStringToLocalDate(value) || new Date(value);
        return Number.isNaN(parsed.getTime()) ? null : parsed;
    };

    const closeModal = () => {
        resetDraftBookingDate(meetingCreatedDateRef.current || bookingDate);
        meetingCreatedDateRef.current = null;
        setShowModal(false);
        setSelectedSpot(null);
        setShowTags(false);
        setCurrentStep(1);
    };

    const toMinutes = (time) => {
        const [h, m] = time.split(":").map(Number);
        return h * 60 + m;
    };

    const slotOverlapsRange = (slotStart, slotEnd, rangeStart, rangeEnd) => {
        const slotStartMin = toMinutes(slotStart);
        const slotEndMin = toMinutes(slotEnd);
        const rangeStartMin = toMinutes(rangeStart);
        const rangeEndMin = toMinutes(rangeEnd);

        return slotStartMin >= rangeStartMin && slotEndMin <= rangeEndMin;
    };

    // const getCanvasSpotStyles = (spot) => {
    //     const hasStripedImage = Boolean(spot.StripedHourlyImage);

    //       // Color Blind Mode
    // const useColorBlindImage =
    //     showBookingForStaff === 0 &&
    //     showAvailabilityColour === 3 &&
    //     Boolean(spot.ColorBlindnessSpotImageUrl);

    //     const isColorBlindMode =
    //     showBookingForStaff === 0 && showAvailabilityColour === 3;

    //     return {
    //         left: `${spot.Xaxis}px`,
    //         top: `${spot.Yaxis}px`,
    //         width: `${spot.Width}px`,
    //         height: `${spot.Height}px`,

    //         backgroundColor: !hasStripedImage
    //             ? spot.BackgroundColorForWeb || spot.BackgroundColor || "transparent"
    //             : "transparent",

    //         backgroundImage: hasStripedImage
    //             ? `url(${spot.StripedHourlyImage})`
    //             : "none",

    //         backgroundRepeat: hasStripedImage ? "repeat" : "no-repeat",
    //         backgroundSize: hasStripedImage ? "cover" : "initial",
    //         backgroundPosition: "center",

    //         border: `1px solid ${spot.BorderColor || spot.BackgroundColor || "#333"}`,
    //         transform: `rotate(${spot.Angle}deg)`,
    //         cursor: isSpotClickable(spot) ? "pointer" : "default",
    //     };
    // };



    const mergeContinuousBookedSlots = (bookedSlots = []) => {
        if (!Array.isArray(bookedSlots) || bookedSlots.length === 0) return [];

        const parsedSlots = bookedSlots
            .map((slot) => {
                const [startTime = "", endTime = ""] = String(slot)
                    .replace("â€“", "-")
                    .split("-")
                    .map((part) => part.trim());

                return { startTime, endTime };
            })
            .filter(({ startTime, endTime }) => startTime && endTime)
            .sort((a, b) => toMinutes(a.startTime) - toMinutes(b.startTime));

        if (parsedSlots.length === 0) return [];

        const mergedSlots = [{ ...parsedSlots[0] }];

        for (let index = 1; index < parsedSlots.length; index += 1) {
            const currentSlot = parsedSlots[index];
            const previousSlot = mergedSlots[mergedSlots.length - 1];

            if (previousSlot.endTime === currentSlot.startTime) {
                previousSlot.endTime = currentSlot.endTime;
            } else {
                mergedSlots.push({ ...currentSlot });
            }
        }

        return mergedSlots;
    };

    const mergeCalendarEvents = (calendarEvents = []) => {
        if (!Array.isArray(calendarEvents) || calendarEvents.length === 0) return [];

        const sortedEvents = [...calendarEvents].sort(
            (a, b) => new Date(a.start).getTime() - new Date(b.start).getTime()
        );

        const mergedEvents = [];

        sortedEvents.forEach((event) => {
            const previousEvent = mergedEvents[mergedEvents.length - 1];

            if (
                previousEvent &&
                previousEvent.title === event.title &&
                previousEvent.id.split("-").slice(0, -2).join("-") === event.id.split("-").slice(0, -2).join("-") &&
                previousEvent.end === event.start
            ) {
                previousEvent.end = event.end;
                previousEvent.id = `${previousEvent.id.split("-").slice(0, -2).join("-")}-${previousEvent.start.slice(11, 16)}-${event.end.slice(11, 16)}`;
                return;
            }

            mergedEvents.push({ ...event });
        });

        return mergedEvents;
    };

    const getCanvasSpotStyles = (spot) => {
        const isColorBlindMode =
            showBookingForStaff === 0 && showAvailabilityColour === 3;
        const hasColorBlindIcon = Boolean(spot.ColorBlindnessSpotImageUrl);
        const hasStripedImage =
            spot.HourlySpot === 1 &&
            Boolean(spot.StripedHourlyImage) &&
            spot.IsPartiallyBooked === 1;
        const isColorBlindPartialHourlySpot =
            isColorBlindMode &&
            spot.HourlySpot === 1 &&
            spot.IsPartiallyBooked === 1;
        const shouldShowFullOpacity =
            spot.ShowFullOpacityForTeam === 1 ||
            spot.ShowFullOpacity === 1 ||
            isColorBlindMode ||
            hasStripedImage;
        const shouldSkipBackground =
            isColorBlindMode &&
            !isColorBlindPartialHourlySpot &&
            (
                hasColorBlindIcon ||
                (spot.SpotId > 0 && spot.ClaimFlag !== 0)
            );

        // Color Blind Mode Logic
        // const isColorBlindMode = showBookingForStaff === 0 && showAvailabilityColour === 3;
        // const useColorBlindImage = isColorBlindMode && Boolean(spot.ColorBlindnessSpotImageUrl);

        const useColorBlindImage =
            isColorBlindMode &&
            hasColorBlindIcon;

        const hexToRGBA = (hex, alpha = 1) => {
            if (!hex || hex === 'transparent') return 'transparent';

            let r = 0, g = 0, b = 0;
            const cleanHex = hex.replace('#', '');

            if (cleanHex.length === 3) {
                r = parseInt(cleanHex[0] + cleanHex[0], 16);
                g = parseInt(cleanHex[1] + cleanHex[1], 16);
                b = parseInt(cleanHex[2] + cleanHex[2], 16);
            } else {
                r = parseInt(cleanHex.substring(0, 2), 16);
                g = parseInt(cleanHex.substring(2, 4), 16);
                b = parseInt(cleanHex.substring(4, 6), 16);
            }

            return `rgba(${r}, ${g}, ${b}, ${alpha})`;
        };

        const leftOffset = Number(spot.LeftOffset || 0);
        const topOffset = Number(spot.TopOffset || 0);
        const backgroundColor = spot.BackgroundColor || spot.BackgroundColorForWeb || "transparent";
        const borderColor = spot.BorderColor || spot.BackgroundColor || "#333";
        const fillColor = shouldShowFullOpacity
            ? backgroundColor
            : hexToRGBA(backgroundColor, 0.2);

        return {
            left: `${Number(spot.Xaxis || 0) - leftOffset}px`,
            top: `${Number(spot.Yaxis || 0) - topOffset}px`,
            width: `${spot.Width}px`,
            height: `${spot.Height}px`,
            position: "absolute",
            /*   backgroundColor: spot.BorderAndBackgroundFlag !== 0
                  ? fillColor
                  : "transparent",
              backgroundImage: shouldSkipBackground
                  ? "none"
                  : hasStripedImage
                      ? `url(${spot.StripedHourlyImage})`
                      : spot.GridViewFacingImageBG
                          ? `url(${spot.GridViewFacingImageBG})`
                          : "none",
              backgroundRepeat: "no-repeat",
              backgroundSize: (!shouldSkipBackground && (spot.GridViewFacingImageBG || hasStripedImage)) ? "cover" : "initial",
              backgroundPosition: "center",
              border: spot.BorderFlag === 1
                  ? `3px solid ${borderColor}`
                  : "none",
              color: shouldShowFullOpacity ? "#FFFFFF" : "#000000",
              transform: `rotate(${spot.Angle}deg)`,
              cursor: isSpotClickable(spot) ? "pointer" : "default",
              zIndex: 0, */
        };
    };

    const getSpotImage = (spot, options = {}) => {
        const { suppressColorBlindIcon = false } = options;
        const isColorBlindMode =
            zoneData?.ShowBookingForStaff === 0 &&
            zoneData?.ShowAvailabilityColour === 3;
        const hasHourlyOverlay =
            spot.HourlySpot === 1 &&
            Boolean(spot.StripedHourlyImage) &&
            spot.IsPartiallyBooked === 1;
        const isColorBlindPartialHourlySpot =
            isColorBlindMode &&
            spot.HourlySpot === 1 &&
            spot.IsPartiallyBooked === 1;
        const shouldSkipBackground =
            isColorBlindMode &&
            !isColorBlindPartialHourlySpot &&
            (
                Boolean(spot.ColorBlindnessSpotImageUrl) ||
                (spot.SpotId > 0 && spot.ClaimFlag !== 0)
            );

        if (!suppressColorBlindIcon && isColorBlindPartialHourlySpot && spot.ColorBlindnessSpotImageUrl) {
            return spot.ColorBlindnessSpotImageUrl;
        }

        if (!suppressColorBlindIcon && isColorBlindMode && spot.ColorBlindnessSpotImageUrl) {
            return spot.ColorBlindnessSpotImageUrl;
        }

        if (shouldSkipBackground) {
            return "";
        }

        if (hasHourlyOverlay) {
            return spot.StripedHourlyImage;
        }

        if (spot.GridViewFacingImageBG) {
            return spot.GridViewFacingImageBG;
        }

        // 1️⃣ First priority → Color Blind image
        // if (isColorBlindMode && spot.ColorBlindnessSpotImageUrl) {
        //     return spot.ColorBlindnessSpotImageUrl;
        // }

        // 2️⃣ Second priority → Striped image
        if (hasHourlyOverlay) {
            return spot.StripedHourlyImage;
        }

        // 3️⃣ Default → Normal image
        if (isColorBlindMode && spot.ColorBlindnessSpotImageUrl) {
            return spot.ColorBlindnessSpotImageUrl;
        }

        if (shouldSkipBackground) {
            return "";
        }

        if (hasHourlyOverlay) {
            return spot.StripedHourlyImage;
        }

        if (spot.GridViewFacingImageBG) {
            return spot.GridViewFacingImageBG;
        }

        return spot.GridViewFacingImage;
    };

    const getSpotLabelText = (spot, index) => {
        const label = showBookingForStaff === 1 && spot.FullName
            ? spot.FullName
            : spot.SpotName || `Spot ${index + 1}`;

        return mapFontSize > 30 ? label.split(" ")[0] : label;
    };

    const handleSpotContextMenu = (event, spot, hasRoleIcon, hasMeetingRoomBookings) => {
        event.preventDefault();

        if (hasRoleIcon) {
            setRoleInfoSpot(spot);
            setMeetingInfoSpot(null);
            return;
        }

        if (hasMeetingRoomBookings) {
            setMeetingInfoSpot(spot);
            setRoleInfoSpot(null);
        }
    };

    const HourlySpots = spots.filter(
        (spot) => spot.HourlySpot === 1 && spot.ClaimFlag === 1 && spot.BookingTimeType === 0,
    );
    const availableHourlySpots = HourlySpots.filter((spot) => spot.ClaimFlag === 1);
    const firstAvailableHourlySpot = availableHourlySpots[0] || null;
    const hourlySpotDropdownOptions = (() => {
        if (!selectedSpot?.SpotName) return availableHourlySpots;

        const hasSelectedSpotOption = availableHourlySpots.some(
            (spot) => spot.SpotId === selectedSpot.SpotId
        );

        return hasSelectedSpotOption
            ? availableHourlySpots
            : [selectedSpot, ...availableHourlySpots];
    })();
    const isHourlyRoomSelectionDisabled = availableHourlySpots.length === 0;
    const hasSelectedHourlyRoom = availableHourlySpots.some(
        (spot) => spot.SpotId === selectedSpot?.SpotId
    );
    const shouldDisableThirtyMinuteCalendar =
        isHourlyRoomSelectionDisabled || !hasSelectedHourlyRoom;

    const MeetingRoomSpots = spots.filter((spot) => spot.SpotType === 3);

    const [formData, setFormData] = useState({
        FirstName: "",
        LastName: "",
        PrimaryEmail: "",
        NationalIdentificationId: ""
    });

    const [loading, setLoading] = useState(false);
    const [bookingSpotId, setBookingSpotId] = useState(null);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleAddGuest = () => {
        if (!formData.FirstName || !formData.LastName || !formData.PrimaryEmail || !formData.NationalIdentificationId) {
            // alert("Please fill all guest details before adding.");
            return;
        }
        const newGuest = { ...formData, Id: GuestParticipants.length };
        setGuestParticipants((prev) => [...prev, newGuest]);
        setFormData({ FirstName: "", LastName: "", PrimaryEmail: "", NationalIdentificationId: "" });
        setShowGuestForm(false);
    };

    const handleRemoveGuest = (index) => setGuestParticipants((prev) => prev.filter((_, i) => i !== index));

    const formatDate = (d) => {
        if (!d) return "";

        if (typeof d === "string") {
            const value = d.trim();
            if (/^\d{4}-\d{2}-\d{2}$/.test(value)) return value;
        }

        const date = d instanceof Date ? d : new Date(d);
        if (Number.isNaN(date.getTime())) return "";

        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    };

    const getCalendarDate = () =>
        getSafePickerDate(changeddate) || getSafePickerDate(bookingDate) || new Date();

    const getCalendarDateString = () => formatDate(getCalendarDate());

    const isSameMonthAndYear = (date1, date2) => {
        if (!date1 || !date2) return false;

        return (
            date1.getMonth() === date2.getMonth() &&
            date1.getFullYear() === date2.getFullYear()
        );
    };

    const formatPickerInputValue = (date) => {
        if (!date) return "";

        return date.toLocaleDateString("en-GB", {
            weekday: "short",
            day: "2-digit",
            month: "short"
        });
    };

    useEffect(() => {
        const currentPickerDate = getCalendarDate();
        if (currentPickerDate) {
            setPickerMonth(currentPickerDate);
        }
    }, [changeddate, bookingDate]);

    const normalizeBlockedSlot = (slot) => String(slot || "").replace(/\s/g, "");

    const getBlockedBookingSlots = () =>
        Array.isArray(timeIntervals?.BlockBookingTime)
            ? timeIntervals.BlockBookingTime.map(normalizeBlockedSlot)
            : [];

    const hasBlockedBookingOverlap = (selectedStart, selectedEnd) => {
        const blockedSlots = getBlockedBookingSlots();

        return blockedSlots.some((blockedSlot) => {
            const [blockedStartTime, blockedEndTime] = blockedSlot.split("-");
            if (!blockedStartTime || !blockedEndTime) return false;

            const blockedStart = new Date(selectedStart);
            const blockedEnd = new Date(selectedStart);

            const [startHours, startMinutes] = blockedStartTime.split(":").map(Number);
            const [endHours, endMinutes] = blockedEndTime.split(":").map(Number);

            blockedStart.setHours(startHours || 0, startMinutes || 0, 0, 0);
            blockedEnd.setHours(endHours || 0, endMinutes || 0, 0, 0);

            return (
                (selectedStart >= blockedStart && selectedStart < blockedEnd) ||
                (selectedEnd > blockedStart && selectedEnd <= blockedEnd) ||
                (selectedStart <= blockedStart && selectedEnd >= blockedEnd)
            );
        });
    };

    const applyThirtyMinuteCalendarSlotStyles = () => {
        const calendarApi = calendarRef.current?.getApi();
        const calendarEl = calendarApi?.el;

        if (!calendarEl) return;

        const blockedStartTimes = new Set(
            getBlockedBookingSlots()
                .map((slot) => slot.split("-")[0]?.trim())
                .filter(Boolean)
                .map((time) => (time.length === 5 ? `${time}:00` : time))
        );

        const slots = calendarEl.querySelectorAll(".fc-timegrid-slot-lane");

        slots.forEach((slot) => {
            const time = slot.getAttribute("data-time");

            slot.classList.remove("fc-past-timezone");

            if (time && blockedStartTimes.has(time)) {
                slot.classList.add("fc-past-timezone");
            }
        });
    };

    const resetForm = (dateOverride = bookingDate) => {
        resetDraftBookingDate(dateOverride);
        setMeetingName("");
        setFormData({ FirstName: "", LastName: "", PrimaryEmail: "", NationalIdentificationId: "" });
        setSelectedDate(new Date());
        setSelectedFrom("");
        setSelectedTo("");
        setSelectedSpot(null);
        setGuestParticipants([]);
        setParticipantsList([]);
        setSelectedParticipants([]);
        setShowSlots(false);
        setShowGuestForm()

        setRepeatType(0);
        setMonthlyRepeatOption();
        setEndDate(null);
        setWeeklyRepeatOption([]);
        setNote("");
        setCurrentStep(1);
        setSelectedVehicle("");
        setSelectedVehiclePrimaryKey("");
        setSelectedSlot("");
        setSelectedSlotValues([]);
        setSlotRangeAnchor("");
        setShowTags(false);
        handleToggleSlots();
        setShowCancelModal(false);
        setVehicleOpen(false);
        setSlotOpen(false);
        setRequiredFields({})

        setshowGuestPopupFullday(false);
        setGuestName("");
        setGuestLastName("")
        setGuestEmail("");
        setIdentification("");
        setSelectedGuestAccessibleType(null);
        setSelectedGuestShareableType(null);
        clearGuestErrors("fullDay");

        setShowGuestPopup30mit(false)
        setGuestName30mit("")
        setGuestLastName30mit("")
        setGuestEmail30mit("")
        setIdentification30mit()
        clearGuestErrors("thirtyMin");
        setShowGuestPopupHourly(false)
        setGuestNameHourly("")
        setGuestLastNameHourly("")
        setGuestEmailHourly("")
        setIdentificationHourly("")
        setSelectedGuestAccessibleType(null);
        setSelectedGuestShareableType(null);
        clearGuestErrors("hourly");
        setCheckedPreBookingQue(false)

        setShowModal(false);
        setBookingSpotId(null);
        setShowCancelModal(false);
        setShowLeaveQueueModal(false);
        setShowJoinQueueModal(false);
        setShowAdditionalBooking(false);
        setShowReleaseAdditionalBooking(false);
        setReleaseIs30MinSpot(false);
        setIsThirtyMinuteModalReadOnly(false);
        setShowCancelModalfor30mit(false);
        setRoleInfoSpot(null);
        setMeetingInfoSpot(null);

    };

    const fetchMapData = async () => {
        try {
            const response = await fetchWithTokenRefresh2(BASE_URL + MapCanvas_api, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    GuId: getGuId(),
                    BookingDate: bookingDate,
                    AppVersion: "3.0.11",
                    FuelFilter: "",
                    ZoneId: selectedZone?.Id || 0,
                    FilterEndTime: "",
                    IsGuest: safeIsGuest,
                    TeamId: safeTeamId,
                    DeviceId: "2b78fa68-e9b3-4265-ab25-d74a204d583f",
                    OsVersion: "10",
                    FilterStartTime: "",
                    ManufactureModel: "Teams",
                    TeamMemberGuId: teamMemberGuId,
                    Language: AppConstant.Language,
                    AccessibleFilter: "",
                    ShareableFilter: "",
                    FacilityFilter: "",
                    TagsFilter: "",
                    VehicleTypeFilter: "",
                }),
            });
            if (response.ok) {
                const data = await response.json();
                setMeetingRoomData(data.Data.Records);
                if (data?.Data?.ResponseCode === 200) {
                    setSpots(data.Data.Records.Layout || []);
                    setIsLoadingMap(false);
                    return data;
                }
            } else if (response.status == 446) {
                console.log("Access token is not valid");
            } else if (response.status == 453) {
                console.log("TeamMember position = 0 , Team Member Data reset");
            } else if (response.status == 423 || response.status == 407) {
                console.log("User is not active Logout user");
            } else if (response.status == 401) {
                console.log("User is not registered");
            } else {
                throw new Error("Failed to fetch zone list");
            }
        } catch (error) {
            console.error("Error refreshing map:", error);
        }
    };

    const fetchMapDataafterBooking = async (dateOverride = activeBookingDate) => {
        try {
            const effectiveDate = dateOverride || activeBookingDate || bookingDate;
            const response = await fetchWithTokenRefresh2(BASE_URL + MapCanvas_api, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    GuId: getGuId(),
                    BookingDate: effectiveDate,
                    AppVersion: App_version,
                    FuelFilter: "",
                    ZoneId: selectedZone?.Id || 0,
                    FilterEndTime: "",
                    IsGuest: safeIsGuest,
                    TeamId: safeTeamId,
                    DeviceId: DeviceId,
                    OsVersion: OsVersion,
                    FilterStartTime: "",
                    ManufactureModel: ManufactureModel,
                    TeamMemberGuId: teamMemberGuId,
                    Language: AppConstant.Language,
                    AccessibleFilter: "",
                    ShareableFilter: "",
                    FacilityFilter: "",
                    TagsFilter: "",
                    VehicleTypeFilter: "",
                }),
            });
            if (response.ok) {
                const data = await response.json();
                // const isOk = handleApiResponse(data, setNotification, t, {
                //     successMsg: 1,
                //     errorMsg: 1
                // });
                const isOk = handleApiUiResponse(response, {
                    successToaster: 0,
                    errorToaster: 1,
                    alertPopup: 1
                });

                setMeetingRoomData(data.Data.Records);
                if (data?.Data?.ResponseCode === 200) {
                    syncZoneUiFlagsFromRecords?.(data?.Data?.Records);
                    setSpots(data.Data.Records.Layout || []);
                    // await refreshZoneAfterBooking(selectedZone, effectiveDate);
                    resetForm(effectiveDate)
                    await new Promise(resolve => setTimeout(resolve, 2000));
                    setIsLoadingMap(false);
                    setShowBookingProcess(false)
                    return data;
                }
            } else if (response.status == 446) {
                console.log("Access token is not valid");
            } else if (response.status == 453) {
                console.log("TeamMember position = 0 , Team Member Data reset");
            } else if (response.status == 423 || response.status == 407) {
                console.log("User is not active Logout user");
            } else if (response.status == 401) {
                console.log("User is not registered");
            } else {
                throw new Error("Failed to fetch zone list");
            }
        } catch (error) {
            console.error("Error refreshing map:", error);
        } finally {
            setIsLoadingMap(false);
            setShowBookingProcess(false);
        }
    };

    const fetchMapDataafterBookingAndShowGuestConfirmation = async (reqParams, dateOverride = activeBookingDate) => {
        const mapResponse = await fetchMapDataafterBooking(dateOverride);

        if (mapResponse?.Data?.ResponseCode === 200) {
            openGuestBookingConfirmation(mapResponse, reqParams);
        }

        return mapResponse;
    };

    const fetchMapDataafterMeeting = async () => {
        try {
            setIsLoadingMap(true);
            const response = await fetchWithTokenRefresh2(BASE_URL + MapCanvas_api, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    GuId: getGuId(),
                    BookingDate: activeBookingDate,
                    AppVersion: App_version,
                    FuelFilter: "",
                    ZoneId: selectedZone?.Id || 0,
                    FilterEndTime: "",
                    IsGuest: safeIsGuest,
                    TeamId: safeTeamId,
                    DeviceId: DeviceId,
                    OsVersion: OsVersion,
                    FilterStartTime: "",
                    ManufactureModel: ManufactureModel,
                    TeamMemberGuId: teamMemberGuId,
                    Language: AppConstant.Language,
                    AccessibleFilter: "",
                    ShareableFilter: "",
                    FacilityFilter: "",
                    TagsFilter: "",
                    VehicleTypeFilter: "",
                }),
            });
            if (response.ok) {
                const data = await response.json();
                // const isOk = handleApiResponse(data, setNotification, t, {
                //     successMsg: 1,
                //     errorMsg: 1
                //   });
                const isOk = handleApiUiResponse(response, {
                    successToaster: 0,
                    errorToaster: 1,
                    alertPopup: 1
                });
                setMeetingRoomData(data.Data.Records);

                if (data?.Data?.ResponseCode === 200) {
                    // setZoneData(data.Data.Records); // Update zoneData
                    setSpots(data.Data.Records.Layout || []); // Update spots
                    await new Promise(resolve => setTimeout(resolve, 2000));
                    // setShowModal(false)
                    // resetForm()
                    setIsLoadingMap(false); // Stop loading
                    return data;
                }
            } else if (response.status == 446) {
                console.log("Access token is not valid");
            } else if (response.status == 453) {
                console.log("TeamMember position = 0 , Team Member Data reset");
            } else if (response.status == 423 || response.status == 407) {
                console.log("User is not active Logout user");
            } else if (response.status == 401) {
                console.log("User is not registered");
            } else {
                throw new Error("Failed to fetch zone list");
            }
        } catch (error) {
            console.error("Error refreshing map:", error);
        }
        finally {
            setIsLoadingMap(false);
        }
    };

    const Submit_MeetingRoom = async (e) => {
        e.preventDefault();
        const payload = {
            BookingDate: formatDate(changeddate),
            MeetingName: meetingName,
            SpotId: selectedSpot?.SpotId || 0,
            StartTime: selectedFrom,
            EndTime: selectedTo,
            RepeatOption: repeatType,
            WeeklyRepeatOption: weeklyRepeatOption.join(","),
            MonthlyRepeatOption: monthlyRepeatOption,
            EndDate: endDate ? formatDate(endDate) : "",
            // Participants: getUserId() + "," + selectedParticipants.map((p) => p.Id),
            Participants: selectedParticipants && selectedParticipants.length > 0
                ? getUserId() + "," + selectedParticipants.map(e => e.Id).join(",")
                : getUserId(),
            EndDateBy: 1,
            Note: note,
            GuId: getGuId(),
            Language: AppConstant.Language,
            AppVersion: App_version,
            ManufactureModel: "Android SDK built for x86",
            OsVersion: OsVersion,
            DeviceId: "",
            GuestParticipants: GuestParticipants,
        };
        try {
            setLoading(true);
            const response = await fetchWithTokenRefresh2(BASE_URL + MeetingRoom_api, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload),
            });
            const result = await response.json();
            if (result?.Data?.ResponseCode === 200) {
                // alert("Meeting created successfully!");
                resetForm();
                await new Promise(resolve => setTimeout(resolve, 2000));
                await fetchMapDataafterBooking();
            } else {
                // alert("Failed to create meeting.");
            }
        } catch (error) {
            // console.error(" API Error:", error);
            // alert("An error occurred while creating the meeting.");
        } finally {
            setLoading(false);
        }
    };

    // const Submit_HourlySpot = async (e) => {
    //     e.preventDefault();
    //     const payload = {
    //         BookingDate: bookingDate,
    //         AppVersion: App_version,
    //         EmailAddress: GuestParticipants,
    //         TeamLeaderGuId: getGuId(),
    //         Language: "english",
    //         DeviceId: DeviceId,
    //         OsVersion: OsVersion,
    //         GuId: getGuId(),
    //         SpotId: selectedSpot?.SpotId || 0,
    //         ManufactureModel: "Android SDK built for x86",
    //         BookingPeriodStartTime: selectedFrom,
    //         BookingPeriodEndTime: selectedTo,
    //         ZoneId: selectedZone?.Id || 0,

    //         FirstName: getFirstName(),
    //         IsGuest: 0,
    //         LastName: getLastName(),
    //         NationalId: "",
    //         Tags: "",
    //         TeamMemberGuId: getUserId(),
    //         SsId: "",
    //         BssId: "",
    //         WifiToggleStatus: 0,
    //         LogScreenName: "",
    //         LogActionType: "",
    //         LogPopup: "",

    //         VehicleShareableId: selectedVehicle?.ShareableId ?? 0,
    //         CarRegistrationNumber: selectedVehicle?.VehicleRegistrationId ?? "",
    //         VehicleAccessibleId: selectedVehicle?.AccessibleId ?? 0,
    //         VehicleFuelId: selectedVehicle?.FuelId ?? 0,
    //         VehicleTypeId: selectedVehicle?.Id ?? 0,
    //     };

    //     try {
    //         setLoading(true);
    //         const response = await fetchWithTokenRefresh2(BASE_URL + MapBasedBooking_api, {
    //             method: "POST",
    //             headers: { "Content-Type": "application/json" },
    //             body: JSON.stringify(payload),
    //         });
    //         const result = await response.json();
    //         if (result?.Data?.ResponseCode === 200) {
    //             alert("Booking created successfully!");
    //             resetForm();
    //             await new Promise(resolve => setTimeout(resolve, 3000));
    //             await fetchMapData();
    //         } else {
    //             alert("Failed to create booking.");
    //         }
    //     } catch (error) {
    //         console.error(" API Error:", error);
    //         alert("An error occurred while creating the booking.");
    //     } finally {
    //         setLoading(false);
    //     }
    // };

    // const Submit_HourlySpot = async (e) => {
    //     e.preventDefault();

    //     // if (!selectedSlot) {
    //     //     alert("Please select a slot");
    //     //     return;
    //     // }

    //     // Split selected slot → start & end
    //     const [from, to] = selectedSlot.split("-").map(t => t.trim());

    //     const payload = {
    //         // BookingDate: formatDate(changeddate),
    //         BookingDate: bookingDate,
    //         AppVersion: App_version,
    //         EmailAddress: getEmail(),
    //         TeamLeaderGuId: getGuId(),
    //         Language: "english",
    //         DeviceId: DeviceId,
    //         OsVersion: OsVersion,
    //         GuId: getGuId(),
    //         SpotId: selectedSpot?.SpotId || 0,
    //         ManufactureModel: "Android SDK built for x86",

    //         BookingPeriodStartTime: from,
    //         BookingPeriodEndTime: to,

    //         ZoneId: selectedZone?.Id || 0,
    //         FirstName: getFirstName(),
    //         LastName: getLastName(),
    //         IsGuest: safeIsGuest,

    //         VehicleShareableId: selectedVehicle?.ShareableId ?? 0,
    //         CarRegistrationNumber: selectedVehicle?.VehicleRegistrationId ?? "",
    //         VehicleAccessibleId: selectedVehicle?.AccessibleId ?? 0,
    //         VehicleFuelId: selectedVehicle?.FuelId ?? 0,
    //         VehicleTypeId: selectedVehicle?.Id ?? 0,

    //         NationalId: "",
    //         Tags: "",
    //         TeamMemberGuId: teamMemberGuId,
    //         SsId: "",
    //         BssId: "",
    //         WifiToggleStatus: 0,
    //         LogScreenName: "",
    //         LogActionType: "",
    //         LogPopup: ""
    //     };

    //     console.log("Sending payload:", payload);

    //     try {
    //         setLoading(true);

    //         const response = await fetchWithTokenRefresh2(BASE_URL + MapBasedBooking_api,
    //             {
    //                 method: "POST",
    //                 headers: { "Content-Type": "application/json" },
    //                 body: JSON.stringify(payload),
    //             }
    //         );

    //         const result = await response.json();
    //         console.log("API Response:", result);

    //         if (result?.Data?.ResponseCode === 200) {
    //             // alert("Spot booked successfully!");
    //             resetForm();
    //             await new Promise(resolve => setTimeout(resolve, 2000));
    //             await fetchMapData();
    //         } else {
    //             alert(result?.Data?.ErrorMessage || "Booking failed");
    //         }
    //     } catch (error) {
    //         console.error("API Error:", error);
    //         alert("Something went wrong while booking");
    //     } finally {
    //         setLoading(false);
    //     }
    // };

    const Submit_HourlySpot = async (e) => {
        e.preventDefault();
        setShowModal(false)

        if (safeIsGuest === 1) {
            setShowGuestPopupHourly(true);
            return;
        }
        setBookingSpotId(selectedSpot?.SpotId ?? null);
        await sendBookingHourly();
    }

    const sendBookingHourly = async (guestData = null) => {
        const slotRange = selectedSlotValues.length > 0 ? buildSlotRange(selectedSlotValues) : selectedSlot;
        const [from, to] = slotRange.split("-").map(t => t.trim());

        const payload = {
            // BookingDate: formatDate(changeddate),
            BookingDate: activeBookingDate,
            AppVersion: App_version,
            EmailAddress: guestData?.emailHourly || getEmail(),
            TeamLeaderGuId: getGuId(),
            Language: AppConstant.Language,
            DeviceId: DeviceId,
            OsVersion: OsVersion,
            GuId: getGuId(),
            SpotId: selectedSpot?.SpotId || 0,
            ManufactureModel: ManufactureModel,

            // ✅ FIXED values from slot
            BookingPeriodStartTime: from,
            BookingPeriodEndTime: to,

            ZoneId: selectedZone?.Id || 0,
            FirstName: guestData?.nameHourly || getFirstName(),
            LastName: guestData?.lastnameHourly || getLastName(),
            IsGuest: safeIsGuest,

            VehicleShareableId:
                safeIsGuest === 1
                    ? selectedGuestShareableType?.Id ?? 0
                    : selectedVehicle?.Id ?? 0,
            CarRegistrationNumber: (selectedVehicle?.VehicleRegistrationId ?? "") || (guestData?.vehicleRegistrationNumberHourly ?? ""),
            VehicleAccessibleId:
                safeIsGuest === 1
                    ? selectedGuestAccessibleType?.Id ?? 0
                    : selectedVehicle?.Id ?? 0,
            // VehicleFuelId: selectedVehicle?.FuelId ?? 0,
            // VehicleTypeId: selectedVehicle?.Id ?? 0,

            VehicleFuelId:
                safeIsGuest === 1
                    ? selectedGuestFuelType?.Id ?? 0
                    : selectedVehicle?.FuelId ?? 0,

            VehicleTypeId:
                safeIsGuest === 1
                    ? selectedGuestVehicleType?.Id ?? 0
                    : selectedVehicle?.Id ?? 0,

            NationalId: guestData?.identificatoinHourly || "",
            Tags: "",
            TeamMemberGuId: teamMemberGuId,
            SsId: "",
            BssId: "",
            WifiToggleStatus: 0,
            LogScreenName: "",
            LogActionType: "",
            LogPopup: ""
        };

        console.log("Sending payload:", payload);

        try {
            setLoading(true);
            setBookingSpotId(selectedSpot?.SpotId ?? null);

            const response = await fetchWithTokenRefresh2(BASE_URL + MapBasedBooking_api,
                {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(payload),
                }
            );

            const result = await response.json();
            console.log("API Response:", result);
            // handleApiResponsemap(result, setNotification, t, {
            //     successMsg: 0,
            //     errorMsg: 1
            // });
            handleApiUiResponse(result, {
                successToaster: 0,
                errorToaster: 1,
                alertPopup: 1,
                onConfirmByCode: {
                    432: async () => {
                        await refreshMapForActiveDate();
                    },
                    444: async () => {
                        await refreshMapForActiveDate();
                    }
                }
            });


            if (result?.Data?.ResponseCode === 200) {
                const bookingQueueId = result?.Data?.Records?.MapBookingQueueId;

                const bookingStatusReq = {
                    ZoneId: selectedZone?.Id || 0,
                    MapBookingQueueId: bookingQueueId,
                    IsGuest: safeIsGuest,
                    BookingDate: activeBookingDate,
                    GuestFirstName: guestData?.nameHourly,
                    GuestLastName: guestData?.lastnameHourly,
                    TeamMemberGuId: teamMemberGuId,
                    SpotName: selectedSpot?.SpotName || "",
                    BookingStartTime: from,
                    BookingEndTime: to,


                    VehicleTypeId: payload.VehicleTypeId,
                    VehicleFuelId: payload.VehicleFuelId,
                    VehicleShareableId: payload.VehicleShareableId,
                    VehicleAccessibleId: payload.VehicleAccessibleId
                };

                const statusResult = await pullBookingStatusFullDay(bookingStatusReq);

                // resetForm();
                // await new Promise(resolve => setTimeout(resolve, 3000));
                // await fetchMapData();
                // await refreshZoneAfterBooking();
                if (!statusResult?.stopFetch) {
                    await refreshMapForActiveDate();
                }
            } else {
                // alert(result?.Data?.ErrorMessage || "Booking failed");
            }
        } catch (error) {
            // console.error("API Error:", error);
            // alert("Something went wrong while booking");
        } finally {
            setLoading(false);
            setBookingSpotId(null);
        }
    }

    // const Submit_30mit = async (e) => {
    //     e.preventDefault();
    //     const payload = {
    //         BookingDate: formatDate(changeddate),
    //         AppVersion: App_version,
    //         EmailAddress: " ",
    //         TeamLeaderGuId: getGuId(),
    //         Language: "english",
    //         DeviceId: DeviceId,
    //         OsVersion: OsVersion,
    //         GuId: getGuId(),
    //         SpotId: selectedSpot?.SpotId || 0,
    //         ManufactureModel: "Android SDK built for x86",
    //         BookingPeriodStartTime: selectedFrom,
    //         BookingPeriodEndTime: selectedTo,
    //         ZoneId: selectedZone?.Id || 0,

    //         FirstName: getFirstName(),
    //         IsGuest: safeIsGuest,
    //         LastName: getLastName(),
    //         NationalId: "",
    //         Tags: "",
    //         TeamMemberGuId: teamMemberGuId,
    //         SsId: "",
    //         BssId: "",
    //         WifiToggleStatus: 0,
    //         LogScreenName: "",
    //         LogActionType: "",
    //         LogPopup: "",

    //         VehicleShareableId: selectedVehicle?.ShareableId ?? 0,
    //         CarRegistrationNumber: selectedVehicle?.VehicleRegistrationId ?? "",
    //         VehicleAccessibleId: selectedVehicle?.AccessibleId ?? 0,
    //         VehicleFuelId: selectedVehicle?.FuelId ?? 0,
    //         VehicleTypeId: selectedVehicle?.Id ?? 0,
    //     };

    //     try {
    //         setLoading(true);
    //         const response = await fetchWithTokenRefresh2(BASE_URL + MapBasedBooking_api, {
    //             method: "POST",
    //             headers: { "Content-Type": "application/json" },
    //             body: JSON.stringify(payload),
    //         });
    //         const result = await response.json();
    //         if (result?.Data?.ResponseCode === 200) {
    //             // alert("Booking created successfully!");
    //             resetForm();
    //             await new Promise(resolve => setTimeout(resolve, 2000));
    //             await fetchMapDataafterBooking();
    //         } else {
    //             alert("Failed to create booking.");
    //         }
    //     } catch (error) {
    //         console.error(" API Error:", error);
    //         alert("An error occurred while creating the booking.");
    //     } finally {
    //         setLoading(false);
    //     }
    // };

    const Submit_30mit = async (e) => {
        e.preventDefault();
        setShowModal(false)

        if (safeIsGuest === 1) {
            setShowGuestPopup30mit(true);
            return;
        }

        setBookingSpotId(selectedSpot?.SpotId ?? null);
        await sendBooking30mit();
    }
    const sendBooking30mit = async (guestData = null) => {
        const bookingDateForPayload = getCalendarDateString();

        if (!bookingDateForPayload) {
            console.warn("[30-minute calendar] Invalid date, skipping MapBasedBooking_api", {
                changeddate,
                bookingDate,
            });
            return;
        }
        const payload = {
            BookingDate: bookingDateForPayload,
            AppVersion: App_version,
            EmailAddress: guestData?.email30mit || getEmail(),
            TeamLeaderGuId: getGuId(),
            Language: AppConstant.Language,
            DeviceId: DeviceId,
            OsVersion: OsVersion,
            GuId: getGuId(),
            SpotId: selectedSpot?.SpotId || 0,
            ManufactureModel: ManufactureModel,
            BookingPeriodStartTime: selectedFrom,
            BookingPeriodEndTime: selectedTo,
            ZoneId: selectedZone?.Id || 0,

            FirstName: guestData?.name30mit || getFirstName(),
            IsGuest: safeIsGuest,
            LastName: guestData?.lastname30mit || getLastName(),
            NationalId: guestData?.identificatoin30mit || "",
            Tags: "",
            TeamMemberGuId: teamMemberGuId,
            SsId: "",
            BssId: "",
            WifiToggleStatus: 0,
            LogScreenName: "",
            LogActionType: "",
            LogPopup: "",

            VehicleShareableId: safeIsGuest === 1
                ? selectedGuestShareableType?.Id ?? 0
                : selectedVehicle?.Id ?? 0,
            CarRegistrationNumber: (selectedVehicle?.VehicleRegistrationId ?? "") || (guestData?.vehicleRegistrationNumber30mit ?? ""),
            VehicleAccessibleId: safeIsGuest === 1
                ? selectedGuestAccessibleType?.Id ?? 0
                : selectedVehicle?.Id ?? 0,
            // VehicleFuelId: selectedVehicle?.FuelId ?? 0,
            // VehicleTypeId: selectedVehicle?.Id ?? 0,

            VehicleFuelId:
                safeIsGuest === 1
                    ? selectedGuestFuelType?.Id ?? 0
                    : selectedVehicle?.FuelId ?? 0,

            VehicleTypeId:
                safeIsGuest === 1
                    ? selectedGuestVehicleType?.Id ?? 0
                    : selectedVehicle?.Id ?? 0,

            // MeetingName: meetingName,
            // RepeatOption: repeatType,
            // WeeklyRepeatOption: weeklyRepeatOption.join(","),
            // MonthlyRepeatOption: monthlyRepeatOption,
            // EndDate: endDate ? formatDate(endDate) : "",
            // Participants: getUserId() + "," + selectedParticipants.map((p) => p.Id),
            // EndDateBy: 1,
            // Note: "This is a test Meeting",
            // GuestParticipants: GuestParticipants,
        };

        try {
            setLoading(true);
            setBookingSpotId(selectedSpot?.SpotId ?? null);

            const response = await fetchWithTokenRefresh2(BASE_URL + MapBasedBooking_api, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload),
            });
            const result = await response.json();
            // handleApiResponsemap(result, setNotification, t, {
            //     successMsg: 0,
            //     errorMsg: 1
            // });
            handleApiUiResponse(result, {
                successToaster: 0,
                errorToaster: 1,
                alertPopup: 1,
                onConfirmByCode: {
                    432: async () => {
                        await refreshMapForActiveDate();
                    },
                    444: async () => {
                        await refreshMapForActiveDate();
                    }
                }
            });

            if (result?.Data?.ResponseCode === 200) {
                const bookingQueueId = result?.Data?.Records?.MapBookingQueueId;

                const bookingStatusReq = {
                    ZoneId: selectedZone?.Id || 0,
                    MapBookingQueueId: bookingQueueId,
                    IsGuest: safeIsGuest,
                    BookingDate: bookingDateForPayload,
                    GuestFirstName: guestData?.name30mit,
                    GuestLastName: guestData?.lastname30mit,
                    TeamMemberGuId: teamMemberGuId,


                    VehicleTypeId: payload.VehicleTypeId,
                    VehicleFuelId: payload.VehicleFuelId,
                    VehicleShareableId: payload.VehicleShareableId,
                    VehicleAccessibleId: payload.VehicleAccessibleId
                };

                const statusResult = await pullBookingStatus30mit(bookingStatusReq);

                // resetForm();
                // await new Promise(resolve => setTimeout(resolve, 3000));
                // await fetchMapData();
                // await refreshZoneAfterBooking();
                if (!statusResult?.stopFetch) {
                    await refreshMapForActiveDate();
                }
            } else {
                // alert("Failed to create booking.");
            }
        } catch (error) {
            // console.error(" API Error:", error);
            // alert("An error occurred while creating the booking.");
        } finally {
            setLoading(false);
            setBookingSpotId(null);
        }
    };

    // const Submit_FullDayBooking = async (e) => {
    //     e.preventDefault();
    //     const payload = {
    //         BookingDate: bookingDate,
    //         GuId: getGuId(),
    //         ZoneId: selectedZone?.Id || 0,
    //         DeviceId: DeviceId,
    //         LastName: getLastName(),
    //         Tags: "",
    //         OsVersion: OsVersion,
    //         ManufactureModel: ManufactureModel,
    //         IsGuest: safeIsGuest,
    //         TeamLeaderGuId: getGuId(),
    //         AppVersion: App_version,
    //         FirstName: getFirstName(),
    //         TeamMemberGuId: teamMemberGuId,
    //         NationalId: "",
    //         EmailAddress: getEmail(),
    //         Language: "english",

    //         VehicleShareableId: selectedVehicle?.ShareableId ?? 0,
    //         CarRegistrationNumber: selectedVehicle?.VehicleRegistrationId ?? "",
    //         VehicleAccessibleId: selectedVehicle?.AccessibleId ?? 0,
    //         VehicleFuelId: selectedVehicle?.FuelId ?? 0,
    //         VehicleTypeId: selectedVehicle?.Id ?? 0,
    //     };

    //     console.log("Sending payload:", payload);

    //     try {
    //         setLoading(true);
    //         const response = await fetchWithTokenRefresh2(BASE_URL + MakeBooking_api, {
    //             method: "POST",
    //             headers: { "Content-Type": "application/json" },
    //             body: JSON.stringify(payload),
    //         });

    //         const result = await response.json();
    //         console.log("API Response:", result);

    //         if (result?.Data?.ResponseCode === 200) {
    //             // alert("Booking created successfully!");
    //             resetForm()
    //             await new Promise(resolve => setTimeout(resolve, 2000));
    //             await fetchMapData();
    //         } else {
    //             alert("Failed to create meeting.");
    //         }
    //     } catch (error) {
    //         console.error(" API Error:", error);
    //         alert("An error occurred while creating the meeting.");
    //     } finally {
    //         setLoading(false);
    //     }
    // };

    const Submit_FullDayBooking = async (e) => {
        e.preventDefault();
        setShowModal(false)
        // If guest selected → open popup instead of API
        if (safeIsGuest === 1) {
            setshowGuestPopupFullday(true);
            return;
        }

        setBookingSpotId(selectedSpot?.SpotId ?? null);
        // setShowModal(false);
        await sendBookingFullDay();

        // const payload = {
        //     BookingDate: bookingDate,
        //     GuId: getGuId(),
        //     ZoneId: selectedZone?.Id || 0,
        //     DeviceId: DeviceId,
        //     LastName: getLastName(),
        //     Tags: "",
        //     OsVersion: OsVersion,
        //     ManufactureModel: ManufactureModel,
        //     IsGuest: safeIsGuest,
        //     TeamLeaderGuId: getGuId(),
        //     AppVersion: App_version,
        //     FirstName: getFirstName(),
        //     TeamMemberGuId: teamMemberGuId,
        //     NationalId: "",
        //     EmailAddress: getEmail(),
        //     Language: "english",

        //     VehicleFuelId: selectedVehicle?.FuelId ?? 0,
        //     VehicleTypeId: selectedVehicle?.Id ?? 0,
        //     VehicleShareableId: selectedVehicle?.ShareableId ?? 0,
        //     CarRegistrationNumber: selectedVehicle?.VehicleRegistrationId ?? "",
        //     VehicleAccessibleId: selectedVehicle?.AccessibleId ?? 0,
        // };

        // console.log("Sending payload:", payload);

        // try {
        //     setLoading(true);
        //     const response = await fetchWithTokenRefresh2(BASE_URL + MakeBooking_api, {
        //         method: "POST",
        //         headers: { "Content-Type": "application/json" },
        //         body: JSON.stringify(payload),
        //     });

        //     const result = await response.json();
        //     console.log("API Response:", result);

        //     if (result?.Data?.ResponseCode === 200) {
        //         // alert("Booking created successfully!");
        //         resetForm()
        //         await new Promise(resolve => setTimeout(resolve, 2000));
        //         await fetchMapData();
        //     } else {
        //         alert("Failed to create meeting.");
        //     }
        // } catch (error) {
        //     console.error(" API Error:", error);
        //     alert("An error occurred while creating the meeting.");
        // } finally {
        //     setLoading(false);
        // }
    };

    const sendBookingFullDay = async (guestData = null) => {

        const payload = {
            BookingDate: activeBookingDate,
            AppVersion: App_version,
            EmailAddress: guestData?.guestemail || getEmail(),
            TeamLeaderGuId: getGuId(),
            Language: AppConstant.Language,
            DeviceId: DeviceId,
            OsVersion: OsVersion,
            GuId: getGuId(),
            SpotId: selectedSpot?.SpotId || 0,
            ManufactureModel: "Android SDK built for x86",
            BookingPeriodStartTime: selectedFrom,
            BookingPeriodEndTime: selectedTo,
            ZoneId: selectedZone?.Id || 0,

            FirstName: guestData?.guestname || getFirstName(),
            IsGuest: safeIsGuest,
            LastName: guestData?.guestlastname || getLastName(),
            NationalId: guestData?.guestidentificatoin || "",
            Tags: "",
            TeamMemberGuId: teamMemberGuId,
            SsId: "",
            BssId: "",
            WifiToggleStatus: 0,
            LogScreenName: "",
            LogActionType: "",
            LogPopup: "",

            // VehicleFuelId: selectedVehicle?.FuelId ?? 0,
            // VehicleTypeId: selectedVehicle?.Id ?? 0,
            VehicleFuelId:
                safeIsGuest === 1
                    ? selectedGuestFuelType?.Id ?? 0
                    : selectedVehicle?.FuelId ?? 0,

            VehicleTypeId:
                safeIsGuest === 1
                    ? selectedGuestVehicleType?.Id ?? 0
                    : selectedVehicle?.Id ?? 0,

            VehicleShareableId:
                safeIsGuest === 1
                    ? selectedGuestShareableType?.Id ?? 0
                    : selectedVehicle?.Id ?? 0,
            CarRegistrationNumber: (selectedVehicle?.VehicleRegistrationId ?? "") || (guestData?.guestvehicleregistrationnumber ?? ""),
            VehicleAccessibleId:
                safeIsGuest === 1
                    ? selectedGuestAccessibleType?.Id ?? 0
                    : selectedVehicle?.Id ?? 0
        };

        console.log("Sending payload:", payload);

        try {
            setLoading(true);
            setBookingSpotId(selectedSpot?.SpotId ?? null);

            const response = await fetchWithTokenRefresh2(BASE_URL + MapBasedBooking_api, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload),
            });

            const result = await response.json();
            console.log("API Response:", result);

            handleApiUiResponse(result, {
                successToaster: 0,
                errorToaster: 1,
                alertPopup: 1,
                onConfirmByCode: {
                    432: async () => {
                        await refreshMapForActiveDate();
                    },
                    444: async () => {
                        await refreshMapForActiveDate();
                    }
                }
            });

            if (result?.Data?.ResponseCode !== 200 && result?.Data?.ResponseCode !== 1555) {
                return { stopFetch: true };
            }

            if (result?.Data?.ResponseCode === 200) {

                const bookingQueueId = result?.Data?.Records?.MapBookingQueueId;

                const bookingStatusReq = {
                    ZoneId: selectedZone?.Id || 0,
                    MapBookingQueueId: bookingQueueId,
                    IsGuest: safeIsGuest,
                    BookingDate: activeBookingDate,
                    GuestFirstName: guestData?.guestname,
                    GuestLastName: guestData?.guestlastname,
                    TeamMemberGuId: teamMemberGuId,

                    VehicleTypeId: payload.VehicleTypeId,
                    VehicleFuelId: payload.VehicleFuelId,
                    VehicleShareableId: payload.VehicleShareableId,
                    VehicleAccessibleId: payload.VehicleAccessibleId
                };

                const statusResult = await pullBookingStatusFullDay(bookingStatusReq);

                // resetForm();
                // await new Promise(resolve => setTimeout(resolve, 3000));
                // await fetchMapData();
                // await refreshZoneAfterBooking();
                if (!statusResult?.stopFetch) {
                    await refreshMapForActiveDate();
                }
            } else {
                // alert("Failed to create booking.");
            }

        } catch (error) {
            // console.error("API Error:", error);
        } finally {
            setLoading(false);
            setBookingSpotId(null);
        }
    };

    const pullBookingStatusFullDay = async (reqParams) => {

        const maxAttempts = 3;

        for (let attempt = 1; attempt <= maxAttempts; attempt++) {

            try {

                const response = await MapBasedBooking_apiBookingStatus(reqParams);
                // handleApiResponsemap(response, setNotification, t, {
                //     successMsg: 0,
                //     errorMsg: 1
                // });
                const records = response?.Data?.Records || {};
                const spotId = records?.SpotId ?? null;
                const isPastBooking = records?.IsPastBooking ?? 0;
                const errorCode = response?.Data?.ResponseCode;

                // if (errorCode !== 200 && errorCode !== 1555) {
                //     return { stopFetch: true };
                // }

                handleApiUiResponse(response, {
                    successToaster: 1,
                    errorToaster: 1,
                    alertPopup: 1,
                    onConfirmByCode: {
                        603: async () => { await refreshMapForActiveDate(); }
                    }
                });

                if (errorCode === 423) {
                    localStorage.clear();
                    sessionStorage.clear();
                    // history.push("/Login", { replace: true });
                    return { stopFetch: true };
                }

                // if (errorCode === 416 || errorCode === 427 || errorCode === 605) {
                //     return { stopFetch: true };
                // }

                if (errorCode !== 200 && errorCode !== 1555) {
                    return { stopFetch: true };
                }


                if (Number(spotId) === -1) {
                    return { stopFetch: false };
                }

                if (Number(spotId) > 0) {
                    if (isPastBooking === 0) {
                        // await refreshParentMapForBookingDate(reqParams.BookingDate);
                        // await fetchMapDataafterBooking(reqParams.BookingDate)
                        // await refreshZoneAfterBooking(reqParams.ZoneId, reqParams.BookingDate);
                        await fetchMapDataafterBookingAndShowGuestConfirmation(reqParams)

                        handleApiUiResponse(response, {
                            successToaster: 0,
                            errorToaster: 1,
                            alertPopup: 1
                        });

                        return { stopFetch: true };
                    }

                    if (isPastBooking === 1) {

                        // await fetchMapDataafterBooking();
                        // setIsLoadingMap(false);
                        // setShowBookingProcess(false);
                        await fetchMapDataafterBookingAndShowGuestConfirmation(reqParams)

                        // const isOk = handleApiResponse(response, setNotification, t, {
                        //     successMsg: 1,
                        //     errorMsg: 1
                        // });

                        handleApiUiResponse(response, {
                            successToaster: 0,
                            errorToaster: 1,
                            alertPopup: 1
                        });

                        const res = await PostBookingQuestion_api({
                            ZoneId: reqParams.ZoneId
                        });

                        if (res?.Data?.ResponseCode === 200) {

                            const questions = res?.Data?.Records?.QuestionAnswerList || [];

                            if (questions.length > 0) {
                                setPostRequestParams({
                                    ZoneId: reqParams.ZoneId,
                                    ClaimDate: reqParams.BookingDate || activeBookingDate,
                                    StartTime: "",
                                    EndTime: "",
                                    SpotId: spotId,
                                    ClaimId: response?.Data?.Records?.LastId_tblparkingrelease,
                                    CompanyId: res?.Data?.Records?.CompanyId,
                                    IsGuest: reqParams.IsGuest
                                });

                                setPostbookingQueModalData(questions);
                                setShowPostbookingQueModal(true);
                            }
                            return { stopFetch: true };
                        }
                    }

                    return { stopFetch: false };
                }

                if (attempt < maxAttempts) {
                    await new Promise(res => setTimeout(res, 3000));
                }

            } catch (error) {
                console.error("BookingStatus_api error:", error);
            }
        }

        return { stopFetch: false };
    };

    const pullBookingStatus30mit = async (reqParams) => {

        const maxAttempts = 3;

        for (let attempt = 1; attempt <= maxAttempts; attempt++) {

            try {

                const response = await MapBasedBooking_apiBookingStatus(reqParams);
                // handleApiResponsemap(response, setNotification, t, {
                //     successMsg: 0,
                //     errorMsg: 1
                // });

                const records = response?.Data?.Records || {};
                const spotId = records?.SpotId ?? null;
                const isPastBooking = records?.IsPastBooking ?? 0;
                const errorCode = response?.Data?.ResponseCode;

                //  if (errorCode !== 200 && errorCode !== 1555) {
                //     return { stopFetch: true };
                // } 

                // handleApiResponsemap(response, setNotification, t, {
                //     successMsg: 0,
                //     errorMsg: 1
                // });

                handleApiUiResponse(response, {
                    successToaster: 1,
                    errorToaster: 1,
                    alertPopup: 1,
                    onConfirmByCode: {
                        603: async () => { await refreshMapForActiveDate(); }
                    }
                });

                if (errorCode === 423) {
                    localStorage.clear();
                    sessionStorage.clear();
                    // history.push("/Login", { replace: true });
                    return { stopFetch: true };
                }

                // if (errorCode === 416 || errorCode === 427 || errorCode === 605) {
                //     return { stopFetch: true };
                // }            
                if (errorCode !== 200 && errorCode !== 1555) {
                    return { stopFetch: true };
                }


                if (Number(spotId) === -1) {
                    return { stopFetch: false };
                }

                if (Number(spotId) > 0) {
                    if (isPastBooking === 0) {
                        // await refreshParentMapForBookingDate(reqParams.BookingDate);
                        // await fetchMapDataafterBooking(reqParams.BookingDate)
                        await refreshZoneAfterBooking(reqParams.ZoneId, reqParams.BookingDate);
                        // await fetchMapDataafterBooking()

                        handleApiUiResponse(response, {
                            successToaster: 0,
                            errorToaster: 1,
                            alertPopup: 1
                        });

                        return { stopFetch: true };
                    }

                    if (isPastBooking === 1) {

                        // await refreshParentMapForBookingDate(reqParams.BookingDate);
                        // setIsLoadingMap(false);
                        // setShowBookingProcess(false);
                        await fetchMapDataafterBookingAndShowGuestConfirmation(reqParams)

                        handleApiUiResponse(response, {
                            successToaster: 0,
                            errorToaster: 1,
                            alertPopup: 1
                        });

                        const res = await PostBookingQuestion_api({
                            ZoneId: reqParams.ZoneId
                        });

                        if (res?.Data?.ResponseCode === 200) {

                            const questions = res?.Data?.Records?.QuestionAnswerList || [];

                            if (questions.length > 0) {
                                setPostRequestParams({
                                    ZoneId: reqParams.ZoneId,
                                    ClaimDate: reqParams.BookingDate || activeBookingDate,
                                    StartTime: "",
                                    EndTime: "",
                                    SpotId: spotId,
                                    ClaimId: response?.Data?.Records?.LastId_tblparkingrelease,
                                    CompanyId: res?.Data?.Records?.CompanyId,
                                    IsGuest: reqParams.IsGuest
                                });

                                setPostbookingQueModalData(questions);
                                setShowPostbookingQueModal(true);
                            }

                            return { stopFetch: true };
                        }
                    }

                    return { stopFetch: false };
                }

                if (attempt < maxAttempts) {
                    await new Promise(res => setTimeout(res, 3000));
                }

            } catch (error) {
                console.error("BookingStatus_api error:", error);
            }
        }

        return { stopFetch: false };
    };


    const Submit_JoinQueue = async (e) => {
        e.preventDefault();
        // 👉 If guest selected → open popup instead of API
        // if (safeIsGuest === 1) {
        //     setshowGuestPopupFullday(true);
        //     return;
        // }

        await sendBookingJoinQueue();
    };

    const sendBookingJoinQueue = async (guestData = null) => {

        const payload = {
            BookingDate: activeBookingDate,
            GuId: getGuId(),
            ZoneId: selectedZone?.Id || 0,
            DeviceId: DeviceId,
            LastName: getLastName(),
            Tags: "",
            OsVersion: OsVersion,
            ManufactureModel: ManufactureModel,
            IsGuest: safeIsGuest,
            TeamLeaderGuId: getGuId(),
            AppVersion: App_version,
            FirstName: getFirstName(),
            TeamMemberGuId: teamMemberGuId,
            NationalId: "",
            EmailAddress: getEmail(),
            Language: AppConstant.Language,

            VehicleFuelId: selectedVehicle?.FuelId ?? 0,
            VehicleTypeId: selectedVehicle?.Id ?? 0,
            VehicleShareableId: selectedVehicle?.ShareableId ?? 0,
            CarRegistrationNumber: selectedVehicle?.VehicleRegistrationId ?? "",
            VehicleAccessibleId: selectedVehicle?.AccessibleId ?? 0,
        };

        console.log("Sending payload:", payload);

        try {
            setLoading(true);

            const response = await fetchWithTokenRefresh2(BASE_URL + MakeBooking_api, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload),
            });

            const result = await response.json();
            console.log("API Response:", result);

            if (result?.Data?.ResponseCode === 200) {

                const bookingQueueId = result?.Data?.Records?.BookingQueueId;

                const bookingStatusReq = {
                    ZoneId: selectedZone?.Id || 0,
                    BookingQueueId: bookingQueueId,
                    IsGuest: safeIsGuest,
                    TeamMemberGuId: teamMemberGuId,
                    // BookingDate: activeBookingDate,


                    VehicleTypeId: payload.VehicleTypeId,
                    VehicleFuelId: payload.VehicleFuelId,
                    VehicleShareableId: payload.VehicleShareableId,
                    VehicleAccessibleId: payload.VehicleAccessibleId
                };

                const statusResult = await pullBookingStatusJoinQueue(bookingStatusReq);

                // resetForm();
                // await new Promise(resolve => setTimeout(resolve, 3000));
                // await fetchMapData();
                // await refreshZoneAfterBooking();
                if (!statusResult?.stopFetch) {
                    await refreshMapForActiveDate();
                }
            } else {
                // alert("Failed to create booking.");
            }

        } catch (error) {
            // console.error("API Error:", error);
        } finally {
            setLoading(false);
        }
    };

    const pullBookingStatusJoinQueue = async (reqParams) => {

        const maxAttempts = 3;

        for (let attempt = 1; attempt <= maxAttempts; attempt++) {

            try {

                const response = await BookingStatus_api(reqParams);
                const records = response?.Data?.Records || {};
                const spotId = records?.SpotId ?? null;
                const isPastBooking = records?.IsPastBooking ?? 0;
                const errorCode = response?.Data?.ResponseCode;
                handleApiUiResponse(response, {
                    successToaster: 1,
                    errorToaster: 1,
                    alertPopup: 1,
                    onConfirmByCode: {
                        603: async () => {
                            await refreshMapForActiveDate();
                        }
                    }
                });
                if (errorCode === 423) {
                    localStorage.clear();
                    sessionStorage.clear();
                    // history.push("/Login", { replace: true });
                    return { stopFetch: true };
                }

                // if (errorCode === 416 || errorCode === 427 || errorCode === 605) {
                //     return { stopFetch: true };
                // }

                if (errorCode !== 200 && errorCode !== 1555) {
                    return { stopFetch: true };
                }

                if (Number(spotId) === -1) {
                    return { stopFetch: false };
                }

                // if (Number(spotId) > 0) {

                //     if (isPastBooking === 1) {

                //         const res = await PostBookingQuestion_api({
                //             ZoneId: reqParams.ZoneId
                //         });

                //         if (res?.Data?.ResponseCode === 200) {

                //             const questions = res?.Data?.Records?.QuestionAnswerList || [];

                //             setPostRequestParams({
                //                 ZoneId: reqParams.ZoneId,
                //                 ClaimDate: bookingDate,
                //                 StartTime: "",
                //                 EndTime: "",
                //                 SpotId: spotId,
                //                 ClaimId: response?.Data?.Records?.LastId_tblparkingrelease,
                //                 CompanyId: res?.Data?.Records?.CompanyId,
                //                 IsGuest: reqParams.IsGuest
                //             });

                //             setPostbookingQueModalData(questions);
                //             setShowPostbookingQueModal(true);

                //             return { stopFetch: true };
                //         }
                //     }

                //     return { stopFetch: false };
                // }

                if (attempt < maxAttempts) {
                    await new Promise(res => setTimeout(res, 3000));
                }

            } catch (error) {
                console.error("BookingStatus_api error:", error);
            }
        }

        return { stopFetch: false };
    };

    const MeetingRoomListInfo = async (spotOverride = null) => {
        const effectiveSpot = spotOverride || selectedSpot;

        if (!effectiveSpot || !effectiveSpot.SpotType) {
            console.warn("SpotType not ready, skipping API call");
            return;
        }
        const bookingDateForPayload = getCalendarDateString();

        if (!bookingDateForPayload) {
            console.warn("[30-minute calendar] Invalid date, skipping MeetingRoomListAndInfo", {
                changeddate,
                bookingDate,
            });
            return;
        }
        // e.preventDefault();
        const payload = {
            SpotType: effectiveSpot?.SpotType,
            BookingDate: bookingDateForPayload,
            GuId: getGuId(),
            ZoneId: selectedZone?.Id || 0,
            OsVersion: "10",
            Language: AppConstant.Language,
            TeamMemberGuId: teamMemberGuId,
            DeviceId: "teams-device",
            ManufactureModel: "",
            AppVersion: "12.12.0",
            IsGuest: safeIsGuest,
            Tags: "",
        };

        try {
            setLoading(true);
            const response = await fetchWithTokenRefresh2(BASE_URL + MeetingRoomListAndInfo, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload),
            });
            const result = await response.json();
            const records = result?.Data?.Records;
            const check_IsUserApprover = result?.Data?.Records?.AvailableRooms?.[0]?.IsUserApprover;
            setcheck_IsUserApprover(check_IsUserApprover);
            const rooms = records?.AvailableRooms || [];
            const HourlyBookings = records?.AvailableHourlyBookings || [];

            const evts = [];

            // Map API data to FullCalendar events
            const matchedRoom = rooms.find((room) => room.SpotId === effectiveSpot?.SpotId);
            const bookingsRoom = HourlyBookings.find((room) => room.SpotId === effectiveSpot?.SpotId);
            console.log("Matched Room:", bookingsRoom);
            if (matchedRoom) {
                const selectedTimes = matchedRoom.SelectedBookingTime || [];
                console.log("Selected Times (MatchedRoom):", selectedTimes);

                selectedTimes.forEach((entry) => {
                    const bookedSlots = entry.BookedSlot || [];

                    bookedSlots.forEach((slot) => {
                        const [startTime, endTime] = slot
                            .replace("–", "-")
                            .split("-")
                            .map((p) => p.trim());

                        evts.push({
                            id: `${matchedRoom.SpotId}-${startTime}-${endTime}`,
                            // title: `${entry.MeetingName} (${entry.Organizer})`,
                            title: `${entry.MeetingName}${entry.Organizer ? ` (${entry.Organizer})` : ""}`,
                            start: `${bookingDateForPayload}T${startTime}:00`,
                            end: `${bookingDateForPayload}T${endTime}:00`,
                            backgroundColor: "#D9D9D9",
                            textColor: "#000000",
                            borderColor: "#ffffff",
                            editable: false,
                            overlap: false,
                        });
                    });
                });

            } else if (bookingsRoom) {
                const selectedTimes = bookingsRoom.SelectedBookingTime || [];
                console.log("Selected Times (BookingsRoom):", selectedTimes);

                selectedTimes.forEach((entry) => {
                    const bookedSlots = entry.BookedSlot || [];

                    bookedSlots.forEach((slot) => {
                        const [startTime, endTime] = slot
                            .replace("–", "-")
                            .split("-")
                            .map((p) => p.trim());

                        evts.push({
                            id: `${bookingsRoom.SpotId}-${startTime}-${endTime}`,
                            // title: `${entry.MeetingName} (${entry.Organizer})`,
                            title: `${entry.MeetingName}${entry.Organizer ? ` (${entry.Organizer})` : ""}`,
                            start: `${bookingDateForPayload}T${startTime}:00`,
                            end: `${bookingDateForPayload}T${endTime}:00`,
                            backgroundColor: "#D9D9D9",
                            textColor: "#000000",
                            borderColor: "#ffffff",
                            editable: false,
                            overlap: false,
                        });
                    });
                });
            }

            // if (matchedRoom) {
            //     const selectedTimes = matchedRoom.SelectedBookingTime || [];
            //     console.log("Selected Times:", selectedTimes);

            //     selectedTimes.forEach((entry) => {
            //         const bookedSlots = entry.BookedSlot || [];

            //         bookedSlots.forEach((slot) => {
            //             const [startTime, endTime] = slot
            //                 .replace("–", "-")
            //                 .split("-")
            //                 .map((p) => p.trim());

            //             evts.push({
            //                 id: `${matchedRoom.SpotId}-${startTime}-${endTime}`,
            //                 title: entry.MeetingName + " " + "(" + entry.Organizer + ")", // organiser name
            //                 start: `${formatDate(selectedDate)}T${startTime}:00`,
            //                 end: `${formatDate(selectedDate)}T${endTime}:00`,
            //                 backgroundColor: "#D9D9D9",
            //                 textColor: "#000000",
            //                 borderColor: "#ffffff",
            //                 editable: false,
            //                 overlap: false,
            //             });
            //         });
            //     });
            // }
            // if(bookingsRoom){
            //     const selectedTimes = bookingsRoom.SelectedBookingTime || [];
            //     console.log("Selected Times:", selectedTimes);

            //     selectedTimes.forEach((entry) => {
            //         const bookedSlots = entry.BookedSlot || [];

            //         bookedSlots.forEach((slot) => {
            //             const [startTime, endTime] = slot
            //                 .replace("–", "-")
            //                 .split("-")
            //                 .map((p) => p.trim());

            //             evts.push({
            //                 id: `${bookingsRoom.SpotId}-${startTime}-${endTime}`,
            //                 title: entry.MeetingName + " " + "(" + entry.Organizer + ")", // organiser name
            //                 start: `${formatDate(selectedDate)}T${startTime}:00`,
            //                 end: `${formatDate(selectedDate)}T${endTime}:00`,
            //                 backgroundColor: "#D9D9D9",
            //                 textColor: "#000000",
            //                 borderColor: "#ffffff",
            //                 editable: false,
            //                 overlap: false,
            //             });
            //         });
            //     });
            // }

            // Update FullCalendar events and time intervals
            setEvents(mergeCalendarEvents(evts));
            const selectedRoom = records.AvailableRooms.find(
                (room) => room.SpotId === effectiveSpot?.SpotId
            );
            const selectedHourlyRoom = records.AvailableHourlyBookings.find(
                (room) => room.SpotId === effectiveSpot?.SpotId
            );
            console.log("Selected Hourly Room:", selectedHourlyRoom);
            if (selectedRoom) {
                console.log("Selected Room:", selectedRoom);

                const start = selectedRoom.StartBookingTime;
                const end = selectedRoom.EndBookingTime;
                const RepeatOptionByLiftRestriction = selectedRoom.HideRepeatOptionByLiftRestriction
                const BlockBookingTime = selectedRoom.BlockedBookingTime;

                console.log("Start:", start);
                console.log("End:", end);
                console.log("RepeatOptionByLiftRestriction:", RepeatOptionByLiftRestriction);

                setTimeIntervals(prev => ({
                    ...prev,
                    start,
                    end,
                    RepeatOptionByLiftRestriction,
                    BlockBookingTime
                }));

                if (
                    Array.isArray(selectedRoom.RoomAvailableDays) &&
                    selectedRoom.RoomAvailableDays.length > 0
                ) {
                    const lastDate = selectedRoom.RoomAvailableDays[
                        selectedRoom.RoomAvailableDays.length - 1
                    ];

                    console.log("Max available date for this room:", lastDate);

                    setMaxDate(new Date(lastDate));
                }
            }
            if (selectedHourlyRoom) {
                console.log("Selected Room:", selectedHourlyRoom);

                const start = selectedHourlyRoom.StartBookingTime;
                const end = selectedHourlyRoom.EndBookingTime;
                const BlockBookingTime = selectedHourlyRoom.BlockedBookingTime;

                console.log("StartselectedHourlyRoom:", start);
                console.log("End selectedHourlyRoom:", end);

                setTimeIntervals(prev => ({
                    ...prev,
                    start,
                    end,
                    BlockBookingTime
                }));

                // if (
                //     Array.isArray(selectedHourlyRoom.RoomAvailableDays) &&
                //     selectedHourlyRoom.RoomAvailableDays.length > 0
                // ) {
                //     const lastDate = selectedHourlyRoom.RoomAvailableDays[
                //         selectedHourlyRoom.RoomAvailableDays.length - 1
                //     ];

                //     console.log("Max available date for this room:", lastDate);

                //     setMaxDate(new Date(lastDate));
                // }
            }
        }
        catch (error) {
        }
        finally {
            setLoading(false);
        }
    }

    const fetchParticipants = async (spotId) => {
        const payload = {
            SpotId: spotId,
            Search: "",
            SelectedParticipant: "",
            Language: AppConstant.Language,
            GuId: getGuId(),
            DeviceId: DeviceId,
            OsVersion: OsVersion,
            AppVersion: App_version,
            ManufactureModel: ManufactureModel,
        };
        try {
            const response = await fetchWithTokenRefresh2(BASE_URL + GetParticipantsForMeeting, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload),
            });
            const data = await response.json();
            if (data?.Data?.Records?.Participants) {
                setParticipantsList(data.Data.Records.Participants);
            }
        } catch (err) {
            console.error("fetchParticipants err:", err);
        }
    };

    // const isSlotBooked = (from, to) => events.some((ev) => {
    //     const evStart = ev.start.slice(11, 16);
    //     const evEnd = ev.end.slice(11, 16);
    //     return !(to <= evStart || from >= evEnd);
    // });
    const isSlotBooked = (from, to) => {
        return events.some(event => {
            const evStart = event.start.slice(11, 16);
            const evEnd = event.end.slice(11, 16);

            // check overlap
            return !(to <= evStart || from >= evEnd);
        });
    };

     const isSelectedSpotFullyBooked =
        timeSlots.length > 0 &&
        timeSlots.every((slot) => {
            const [start, end] = slot.split("-");
            const isBooked = isSlotBooked(start, end);
            const isBlocked = getBlockedBookingSlots().includes(normalizeBlockedSlot(slot));

            return isBooked || isBlocked;
        });

    useEffect(() => {
        if (!timeIntervals.start || !timeIntervals.end) return;
        const slots = [];
        let [sh, sm] = timeIntervals.start.split(":").map(Number);
        let [eh, em] = timeIntervals.end.split(":").map(Number);
        const start = sh + sm / 60;
        const end = eh + em / 60;
        for (let t = start; t < end; t += 0.5) {
            let h1 = Math.floor(t);
            let m1 = t % 1 === 0 ? "00" : "30";
            let h2 = Math.floor(t + 0.5);
            let m2 = (t + 0.5) % 1 === 0 ? "00" : "30";
            const s = `${String(h1).padStart(2, "0")}:${m1}`;
            const e = `${String(h2).padStart(2, "0")}:${m2}`;
            slots.push(`${s}-${e}`);
        }
        setTimeSlots(slots);
    }, [timeIntervals]);

    // const handleSlotClick = (slot) => {
    //     const [from, to] = slot.split("-");
    //     if (isSlotBooked(from, to)) return;
    //     setSelectedFrom(from);
    //     setSelectedTo(to);
    // };

    const handleSlotClick = (slot) => {
        const [from, to] = slot.split("-");

        const clickedStart = toMinutes(from);
        const clickedEnd = toMinutes(to);

        const currentStart = toMinutes(selectedFrom);
        const currentEnd = toMinutes(selectedTo);

        // 🔁 Nothing selected → select
        if (
            !selectedFrom ||
            !selectedTo ||
            selectedFrom === "00:00" ||
            selectedTo === "00:00"
        ) {
            setSelectedFrom(from);
            setSelectedTo(to);
            return;
        }

        // 🔁 If clicked slot EXACTLY matches whole range → clear
        if (clickedStart === currentStart && clickedEnd === currentEnd) {
            setSelectedFrom("00:00");
            setSelectedTo("00:00");
            return;
        }

        // 🔁 If clicked slot is INSIDE current range → shrink range
        if (clickedStart >= currentStart && clickedEnd <= currentEnd) {

            // remove from start
            if (clickedStart === currentStart) {
                setSelectedFrom(from);
                setSelectedTo(to);
                return;
            }

            // remove from end
            if (clickedEnd === currentEnd) {
                setSelectedTo(from);
                return;
            }

            // clicked in middle → reset to just that slot
            // setSelectedFrom(from);
            setSelectedTo(from);
            return;
        }

        // 📐 Otherwise expand range
        const newStart = Math.min(clickedStart, currentStart);
        const newEnd = Math.max(clickedEnd, currentEnd);

        const candidateSlots = timeSlots
            .map((timeSlot) => {
                const [slotStart, slotEnd] = timeSlot.split("-");
                return {
                    raw: timeSlot,
                    start: slotStart,
                    end: slotEnd,
                    startMin: toMinutes(slotStart),
                    endMin: toMinutes(slotEnd),
                };
            })
            .filter(
                (timeSlot) =>
                    timeSlot.startMin >= newStart && timeSlot.endMin <= newEnd
            )
            .sort((a, b) => a.startMin - b.startMin);

        const isUnavailableTimeSlot = (timeSlot) => {
            const isBlocked = getBlockedBookingSlots().includes(
                normalizeBlockedSlot(timeSlot.raw)
            );

            return isBlocked || isSlotBooked(timeSlot.start, timeSlot.end);
        };

        if (clickedStart > currentEnd) {
            let lastAllowedEnd = selectedTo;

            for (const timeSlot of candidateSlots) {
                if (timeSlot.startMin < currentEnd) continue;
                if (isUnavailableTimeSlot(timeSlot)) break;
                lastAllowedEnd = timeSlot.end;
            }

            setSelectedFrom(selectedFrom);
            setSelectedTo(lastAllowedEnd);
            return;
        }

        if (clickedEnd < currentStart) {
            let firstAllowedStart = selectedFrom;

            for (let index = candidateSlots.length - 1; index >= 0; index -= 1) {
                const timeSlot = candidateSlots[index];
                if (timeSlot.endMin > currentStart) continue;
                if (isUnavailableTimeSlot(timeSlot)) break;
                firstAllowedStart = timeSlot.start;
            }

            setSelectedFrom(firstAllowedStart);
            setSelectedTo(selectedTo);
            return;
        }

        const toTime = (m) =>
            `${String(Math.floor(m / 60)).padStart(2, "0")}:${String(m % 60).padStart(2, "0")}`;

        setSelectedFrom(toTime(newStart));
        setSelectedTo(toTime(newEnd));
    };

    const handleToggleSlots = () => setShowSlots((s) => !s);

    const loadEvents = async (date) => {
        if (!date || !Array.isArray(meetingRoomData)) {
            console.warn("Invalid meetingRoomData or date:", { date, meetingRoomData });
            return;
        }

        const formattedDate = formatDate(date);
        const evts = [];

        meetingRoomData.forEach((room) => {
            const selectedTimes = room.SelectedBookingTime || [];

            selectedTimes.forEach((entry) => {
                const bookedSlots = entry.BookedSlot || [];

                bookedSlots.forEach((slot) => {
                    const [startTime, endTime] = slot
                        .replace("–", "-")
                        .split("-")
                        .map((t) => t.trim());

                    evts.push({
                        id: `${room.SpotId}-${startTime}-${endTime}`,
                        title: entry.Organizer,
                        start: `${formattedDate}T${startTime}:00`,
                        end: `${formattedDate}T${endTime}:00`,
                        backgroundColor: "rgba(232, 221, 221, 0.5)",
                        editable: false,
                        overlap: false,
                    });
                });
            });
        });

        setEvents(evts);
    };

    // const handleAddParticipant = (value) => {
    //     if (!value) return;
    //     const p = JSON.parse(value);
    //     if (selectedParticipants.some((s) => s.Id === p.Id)) return;
    //     setSelectedParticipants((prev) => [...prev, p]);
    // };

    const participantOptions = participantsList
        .filter(
            p => !selectedParticipants.some(sp => sp.Id === p.Id)
        )
        .map(p => ({
            value: p.Id,
            label: `${p.FirstName} ${p.LastName} (${p.PrimaryEmail})`,
            data: p
        }));

    const handleAddParticipant = (option) => {
        if (!option) return;

        const participant = option.data;

        setSelectedParticipants(prev => {
            const exists = prev.some(p => p.Id === participant.Id);
            if (exists) return prev;
            return [...prev, participant];
        });

        // Clear select after adding
        setSelectedOption(null);
    };

    // const handleConfirm = async (e) => {
    //     e.preventDefault();

    //     if (loading) return;

    //     setLoading(true);

    //     const success = await Submit_MeetingRoom();

    //     setLoading(false);

    //     if (!success) {
    //         // alert("Failed to create meeting.");
    //         return;
    //     }

    //     // alert("Meeting created successfully!");
    //     resetForm();

    //     if (check_IsUserApprover === 0) {
    //         setCurrentStep(3);
    //     }
    // };

    const rawVehicles =
        vehicleMap?.[selectedSpot?.SpotId] || [];

    const vehiclesForSpot = [...rawVehicles].sort((a, b) => a.Id - b.Id);

    console.log("vehiclesForSpot:", vehiclesForSpot.Name);

    const GuestVehicleTypes = selectedSpot?.GuestVehicleTypes || [];
    const GuestFuelTypes = selectedSpot?.GuestFuelTypes || [];
    const GuestAccessibleTypes = selectedSpot?.GuestAccessibleTypes || [];
    const GuestShareableTypes = selectedSpot?.GuestShareableTypes || [];

    useEffect(() => {
        // We check for vehiclesForSpot.length to ensure the list has loaded
        if (vehiclesForSpot && vehiclesForSpot.length > 0 && !selectedVehicle) {

            // Pick the first item as it appears in YOUR array (V2)
            const defaultVehicle = vehiclesForSpot[0];

            setSelectedVehicle(defaultVehicle);
            setSelectedVehiclePrimaryKey(defaultVehicle.VehiclePrimaryKey);

            // Clear errors
            setRequiredFields(prev => ({ ...prev, vehicle: "" }));
        }
    }, [vehiclesForSpot]); // This triggers as soon as the list is ready

    // Ensure first vehicle is selected by default in guest popups
    useEffect(() => {
        if (showGuestPopupFullday && GuestVehicleTypes.length > 0 && !selectedGuestVehicleType) {
            setSelectedGuestVehicleType(GuestVehicleTypes[0]);
            setSelectedGuestFuelType(GuestFuelTypes[0]);
            setSelectedGuestAccessibleType(GuestAccessibleTypes.length > 0 ? { Id: 0, Name: "--" } : null);
            setSelectedGuestShareableType(GuestShareableTypes.length > 0 ? { Id: 0, Name: "--" } : null);
        }
    }, [showGuestPopupFullday, GuestVehicleTypes, GuestFuelTypes, GuestAccessibleTypes, GuestShareableTypes, selectedGuestVehicleType]);

    useEffect(() => {
        if (showGuestPopup30mit && GuestVehicleTypes.length > 0 && !selectedGuestVehicleType) {
            setSelectedGuestVehicleType(GuestVehicleTypes[0]);
            setSelectedGuestFuelType(GuestFuelTypes[0]);
            setSelectedGuestAccessibleType(GuestAccessibleTypes.length > 0 ? { Id: 0, Name: "--" } : null);
            setSelectedGuestShareableType(GuestShareableTypes.length > 0 ? { Id: 0, Name: "--" } : null);
        }
    }, [showGuestPopup30mit, GuestVehicleTypes, GuestFuelTypes, GuestAccessibleTypes, GuestShareableTypes, selectedGuestVehicleType]);

    useEffect(() => {
        if (showGuestPopupHourly && GuestVehicleTypes.length > 0 && !selectedGuestVehicleType) {
            setSelectedGuestVehicleType(GuestVehicleTypes[0]);
            setSelectedGuestFuelType(GuestFuelTypes[0]);
            setSelectedGuestAccessibleType(GuestAccessibleTypes.length > 0 ? { Id: 0, Name: "--" } : null);
            setSelectedGuestShareableType(GuestShareableTypes.length > 0 ? { Id: 0, Name: "--" } : null);
        }
    }, [showGuestPopupHourly, GuestVehicleTypes, GuestFuelTypes, GuestAccessibleTypes, GuestShareableTypes, selectedGuestVehicleType]);

    useEffect(() => {
        const currentSpotId = selectedSpot?.SpotId ?? null;

        if (!spotBookingSlots.length) {
            autoSelectedSpotSlotRef.current = currentSpotId;
            return;
        }

        if (currentSpotId == null) {
            return;
        }

        if (autoSelectedSpotSlotRef.current === currentSpotId) {
            return;
        }

        setSelectedSlot(spotBookingSlots[0]);
        setSelectedSlotValues([spotBookingSlots[0]]);
        setSlotRangeAnchor(spotBookingSlots[0]);
        autoSelectedSpotSlotRef.current = currentSpotId;
    }, [spotBookingSlots, selectedSpot?.SpotId]);

    useEffect(() => {
        if (!showModal || !isThirtyMinuteModalReadOnly) return;
        if (autoDisabledManualSlotsRef.current) return;

        if (selectedSpot?.SpotId) {
            MeetingRoomListInfo(selectedSpot);
            return;
        }

        if (!firstAvailableHourlySpot) return;

        setSelectedSpot(firstAvailableHourlySpot);
    }, [
        showModal,
        isThirtyMinuteModalReadOnly,
        firstAvailableHourlySpot?.SpotId,
        selectedSpot?.SpotId,
    ]);

    useEffect(() => {
        if (!showSlots || timeSlots.length === 0) {
            if (autoDisabledManualSlotsRef.current) {
                setIsThirtyMinuteModalReadOnly(false);
                autoDisabledManualSlotsRef.current = false;
            }
            return;
        }

        const allManualSlotsDisabled = timeSlots.every((slot) => {
            const [start, end] = slot.split("-");
            const isBooked = isSlotBooked(start, end);
            const isBlocked = getBlockedBookingSlots().includes(normalizeBlockedSlot(slot));

            return isBooked || isBlocked;
        });

        if (allManualSlotsDisabled && !isThirtyMinuteModalReadOnly && !autoDisabledManualSlotsRef.current) {
            setIsThirtyMinuteModalReadOnly(true);
            autoDisabledManualSlotsRef.current = true;
            return;
        }

        if (!allManualSlotsDisabled && autoDisabledManualSlotsRef.current) {
            setIsThirtyMinuteModalReadOnly(false);
            autoDisabledManualSlotsRef.current = false;
        }
    }, [
        showSlots,
        timeSlots,
        isThirtyMinuteModalReadOnly,
        changeddate,
        selectedSpot?.SpotId,
    ]);

    useEffect(() => {
        const handleResize = () => {
            window.dispatchEvent(new Event('resize'));
        };

        handleResize();
    }, [scale]);

    useEffect(() => {
        if (!showModal) return;

        const timer = setTimeout(() => {
            applyThirtyMinuteCalendarSlotStyles();
        }, 0);

        return () => clearTimeout(timer);
    }, [
        showModal,
        changeddate,
        events,
        timeIntervals?.start,
        timeIntervals?.end,
        timeIntervals?.BlockBookingTime,
        selectedSpot?.SpotId,
    ]);

    const BookAdditionalTimeModal = ({ onCancel, onBookAdditional }) => (
        <div>
            {/* <ModalContent> */}
            <div className="modal modalscroll" style={{ display: 'block', backgroundColor: 'rgba(217, 217, 217, 0.59)' }}
                id="dateModal" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="dateModalLabel" aria-hidden="true"
            ><div className="modal-dialog modal-dialog-centered modal-custom-width">
                    <div className="modal-content modal-radius">
                        <div className="modal-body">
                            <div className="close-modal">
                                <a onClick={resetForm}>
                                    <img src={Close} aria-label="Close" />
                                </a>
                            </div>
                            <div className="pt-2">
                                {/* <h5 className="popup-title">{t("react_manage_booking_for")} {selectedSpot.SpotName}</h5> */}
                                <h5 className="popup-title">{assignTitle}</h5>
                            </div>

                            <div className="mb-4">
                                {checkInBtn && <CheckInButton onClick={() => {
                                    // setShowAdditionalBooking(false);
                                    CheckInOutAPI(selectedZone?.Id || (selectedSpot && selectedSpot.ZoneId) || 0,
                                        bookingDate || (selectedSpot && selectedSpot.BookingDate) || formatDate(new Date()),
                                        selectedSpot?.SpotId || 0, checkInFlag);
                                }} />}
                            </div>

                            <div className="mb-4">
                                {checkOutBtn && <CheckOutButton onClick={() => {
                                    // setShowAdditionalBooking(false);
                                    CheckOutAPI(selectedZone?.Id || (selectedSpot && selectedSpot.ZoneId) || 0,
                                        bookingDate || (selectedSpot && selectedSpot.BookingDate) || formatDate(new Date()),
                                        selectedSpot?.SpotId || 0, checkInFlag);
                                }} />}
                            </div>

                            <div className="tags-btn me-4 mt-3">
                                <a
                                    type="button"
                                    className="green-outline-with-icon w-100 mw-100 min-height-56"
                                    onClick={onBookAdditional}
                                >
                                    <img src={EditSquare} alt="" />
                                    {t("book_additional_time")}
                                </a>
                            </div>

                            <div className="me-4 mt-3">
                                <a
                                    type="button"
                                    className="w-100 mw-100 min-height-56 main-btn cancel-btn"
                                    onClick={onCancel}
                                >
                                    {/* <img src={closeIcon} alt="" />
                                    &nbsp; */}
                                    {t("cancel_booking")}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* </ModalContent> */}
        </div>
    );

    const CancelBooking = async (zoneId, bookingDateStr, cancelBookingSpotId, teamMemberGuIdParam) => {
        // e.preventDefault();
        const tmGuid = teamMemberGuIdParam ?? teamMemberGuId;
        const IsGuest = safeIsGuest
        console.log(
            `Cancel Booking Clicked: ZoneId=${zoneId}, BookingDate=${bookingDateStr}, SpotId=${cancelBookingSpotId} , TeamMemberGuId=${tmGuid}`
        );
        try {
            setLoading(true);
            const response = await CancelBooking_API_Map(zoneId, bookingDateStr, cancelBookingSpotId, tmGuid, IsGuest);
            //  const result = await response.json();
            console.log("API Response:", response);

            if (response?.Data?.ResponseCode === 200) {
                // alert("Booking cancelled successfully!");
                // handleApiResponse(response, setNotification, t, {
                //     successMsg: 1,
                //     errorMsg: 1
                // });
                handleApiUiResponse(response, {
                    successToaster: 1,
                    errorToaster: 1,
                    alertPopup: 1,
                    onConfirmByCode: {
                        607: async () => {
                            await refreshMapForActiveDate();
                        },
                    }
                });

                // await refreshMapForActiveDate();
                await refreshParentMapForBookingDate()
                resetForm()
                // await new Promise(resolve => setTimeout(resolve, 3000));
                // await fetchMapData();
            } else {
                // handleApiResponse(response, setNotification, t, {
                //     successMsg: 0,
                //     errorMsg: 1
                // });
                handleApiUiResponse(response, {
                    successToaster: 0,
                    errorToaster: 1,
                    alertPopup: 1,
                    onConfirmByCode: {
                        607: async () => {
                            await refreshMapForActiveDate();
                        },
                    }
                });
            }

            // if (response && response.Data?.ResponseCode === 200) {
            //     await new Promise((resolve) => setTimeout(resolve, timeOutTime));
            //     await Calendar_APIforBooking(bookingDateStr, zoneId);
            // } else {
            //     console.error("Cancel booking failed:", response?.Data?.ResponseMessage);
            // }
        } catch (error) {
            console.error("Error calling CancelBooking_api:", error);
        } finally {
            setLoading(false);
        }
    };

    const CancelBookingLeaveQueue = async (zoneId, bookingDateStr, cancelBookingSpotId, teamMemberGuIdParam) => {
        // e.preventDefault();
        const tmGuid = teamMemberGuIdParam ?? teamMemberGuId;
        const IsGuest = safeIsGuest
        /* console.log(
            `Cancel Booking Clicked: ZoneId=${zoneId}, BookingDate=${bookingDateStr}, cancelBookingSpotId=${cancelBookingSpotId}, teamMemberGuId=${tmGuid}`
        ); */
        try {
            setLoading(true);
            setShowLeaveQueueModal(false)
            const response = await CancelBooking_API_LeaveQueue(zoneId, bookingDateStr, cancelBookingSpotId, tmGuid, IsGuest);
            //  const result = await response.json();
            //console.log("API Response:", response);

            if (response?.Data?.ResponseCode === 200) {
                // alert("Booking cancelled successfully!");
                // await new Promise(resolve => setTimeout(resolve, 3000));
                // await fetchMapData();
                // handleApiResponse(response, setNotification, t, {
                //     successMsg: 1,
                //     errorMsg: 1
                // });
                handleApiUiResponse(response, {
                    successToaster: 1,
                    errorToaster: 1,
                    alertPopup: 1,
                    onConfirmByCode: {
                        607: async () => {
                            await refreshMapForActiveDate();
                        },
                    }
                });
                resetForm()
                await refreshMapForActiveDate();
            } else {
                // handleApiResponse(response, setNotification, t, {
                //     successMsg: 1,
                //     errorMsg: 1
                // });
                handleApiUiResponse(response, {
                    successToaster: 1,
                    errorToaster: 1,
                    alertPopup: 1,
                    onConfirmByCode: {
                        607: async () => {
                            await refreshMapForActiveDate();
                        },
                    }
                });
            }

            // if (response && response.Data?.ResponseCode === 200) {
            //     await new Promise((resolve) => setTimeout(resolve, timeOutTime));
            //     await Calendar_APIforBooking(bookingDateStr, zoneId);
            // } else {
            //     console.error("Cancel booking failed:", response?.Data?.ResponseMessage);
            // }
        } catch (error) {
            //console.error("Error calling CancelBooking_api:", error);
        } finally {
            setLoading(false);
        }
    };

    const CheckInOutAPI = async (zoneId, bookingDateStr, cancelBookingSpotId, checkInFlag) => {
        /* console.log(
            `Cancel Booking Clicked: ZoneId=${zoneId}, BookingDate=${bookingDateStr}, SpotId=${cancelBookingSpotId}, CheckInFlag=${checkInFlag}`
        ); */
        try {
            setIsLoadingMap(true);
            setLoading(true);
            setLoadingDates((prev) => [...prev, bookingDateStr]);
            const response = await CheckInUser_API(zoneId, bookingDateStr, cancelBookingSpotId, checkInFlag);
            console.log("CheckInUser_api response:", response);
            handleApiUiResponse(response, {
                successToaster: 0,
                errorToaster: 0,
                alertPopup: 1,
                onConfirmByCode: {
                    449: async () => {
                        await refreshMapForActiveDate();
                    }
                }
            });
            if (response && response.Data?.ResponseCode === 200) {
                await new Promise((resolve) => setTimeout(resolve, timeOutTime));

                await refreshMapForActiveDate();
            } else {
                //console.error("Cancel booking failed:", response?.Data?.ResponseMessage);
            }
        } catch (error) {
            //console.error("Error calling CancelBooking_api:", error);
        } finally {
            setIsLoadingMap(false);
            setLoadingDates((prev) => prev.filter((d) => d !== bookingDateStr));
            setLoading(false);
        }
    }

    const CheckOutAPI = async (zoneId, bookingDateStr, cancelBookingSpotId, checkInFlag) => {
        console.log(
            `Cancel Booking Clicked: ZoneId=${zoneId}, BookingDate=${bookingDateStr}, SpotId=${cancelBookingSpotId}, CheckInFlag=${checkInFlag}`
        );
        try {
            setIsLoadingMap(true);
            setLoading(true);
            setLoadingDates((prev) => [...prev, bookingDateStr]);
            const response = await CheckOutUser_API(zoneId, bookingDateStr, cancelBookingSpotId, checkInFlag);
            console.log("CheckOutUser_api response:", response);

            if (response && response.Data?.ResponseCode === 200) {
                await new Promise((resolve) => setTimeout(resolve, timeOutTime));
                await refreshMapForActiveDate();

                //await Calendar_APIforBooking(bookingDateStr, zoneId);
                //await fetchBookings(zoneId, formatDate(bookingDateStr));
            } else {
                //console.error("Cancel booking failed:", response?.Data?.ResponseMessage);
            }
        } catch (error) {
            //console.error("Error calling CancelBooking_api:", error);
        } finally {
            setIsLoadingMap(false);
            setLoadingDates((prev) => prev.filter((d) => d !== bookingDateStr));
            setLoading(false);
        }
    }

    const CheckInButton = ({ onClick, loading: buttonLoading = false }) => (
        <div className="tags-btn me-4 mt-3">
            <div className="d-block w-100 mb-3">
                <a
                    href="#"
                    onClick={(e) => {
                        e.preventDefault();
                        if (buttonLoading) return;
                        onClick();
                    }}
                    className="fc-checkInBtn-button w-100 fc-checkInBtn-img">
                    {buttonLoading ? (
                        <div
                            className="w-100 d-flex align-items-center justify-content-center"
                            style={{ minHeight: "48px" }}
                        >
                            <img
                                src={LoaderFull}
                                alt="Loading"
                                style={{ width: "56px", height: "56px", objectFit: "contain" }}
                            />
                        </div>
                    ) : (
                        <>
                            <img src={CheckInIcon} className="img-fluid"></img>
                            <span>{t("react_check_in")}</span>
                        </>
                    )}
                </a>
            </div>
        </div>
    );

    const CheckOutButton = ({ onClick, loading: buttonLoading = false }) => (
        <div className="tags-btn me-4 mt-3">
            <div className="d-block w-100 mb-3">
                <a
                    href="#"
                    onClick={(e) => {
                        e.preventDefault();
                        if (buttonLoading) return;
                        onClick();
                    }}
                    className="fc-checkInBtn-button fc-button fc-button-primary active w-100 fc-checkInBtn-img">
                    {buttonLoading ? (
                        <div
                            className="w-100 d-flex align-items-center justify-content-center"
                            style={{ minHeight: "48px" }}
                        >
                            <img
                                src={LoaderFull}
                                alt="Loading"
                                style={{ width: "56px", height: "56px", objectFit: "contain" }}
                            />
                        </div>
                    ) : (
                        <>
                            <img src={CheckInIcon} className="img-fluid"></img>
                            <span>{t("react_check_out")}</span>
                        </>
                    )}
                </a>
            </div>
        </div>
    );

    const CreditValueGrey =
        (zoneCreditValue > 0 && (individualDayCost == 0 || individualDayCost == "0"))

    const CreditValueAdd =
        (zoneCreditValue > 0 && individualDayCost == 1)
    console.log("CreditValueGrey", CreditValueAdd);
    console.log("CreditValueAdd", individualDayCost)

    const refundStartDateTime = zoneData?.RefundStartDateTime;
    const refundEndDateTime = zoneData?.RefundEndDateTime;
    const zoneCurrentDateTime = zoneData?.ZoneCurrentDateTime;
    const fullRefundCredit = zoneData?.FullRefundCredit;
    const halfRefundCredit = zoneData?.HalfRefundCredit;
    const noRefundCredit = zoneData?.NoRefundCredit;

    const displayCreditValue = getDisplayRefundCreditValue({
        refundStartDateTime,
        refundEndDateTime,
        zoneCurrentDateTime,
        fullRefundCredit,
        halfRefundCredit,
        noRefundCredit
    });

    const isZeroDisplayCredit =
        displayCreditValue === 0 || displayCreditValue === "0";


    const RoleIcon = ({ spot, showRoleIcons }) => {
        if (!showRoleIcons) return null;

        if (!spot?.EmployeeRoleIconList?.length) return null;

        const primaryIcon = spot.EmployeeRoleIconList[0]?.IconImage;
        const extraRoles = spot.EmployeeRoleIconList.slice(1);

        return (
            <div
                style={{
                    position: "absolute",
                    top: 4,
                    right: 4,
                    zIndex: 5,
                }}
                className="role-icon-wrapper"
            >
                {/* Main icon */}
                <img
                    src={primaryIcon}
                    alt="role"
                    style={{ width: 26, height: 26 }}
                />

                {/* Hover popup for multiple roles */}
                {extraRoles.length > 0 && (
                    <div className="role-hover-popup">
                        {extraRoles.map((role, i) => (
                            <img
                                key={i}
                                src={role.IconImage}
                                alt="role"
                                style={{ width: 22, height: 22, margin: 2 }}
                            />
                        ))}
                    </div>
                )}
            </div>
        );
    };


    const isRandomSpaceDisabled = Boolean(preBookinQueCanvas) && !checkedPreBookingQue;
    const isJoinQueueDisabled = Boolean(preBookinQueCanvas) && !checkedPreBookingQue;

    const safeHtml = (DOMPurify
        .sanitize(preBookinQueCanvas || "") || "")
        .replace(/<a /g, '<a target="_blank" rel="noopener noreferrer" ');

    const monthNames = [
        t("January"), t("February"), t("March"), t("April"),
        t("May"), t("June"), t("July"), t("August"),
        t("September"), t("October"), t("November"), t("December")
    ];

    const bufferMinutes = 15;

    const spotName = selectedSpot?.SpotName || "";

    const assignTitle = formatReactString(t("YourBookingForSpace"), [spotName], {
        defaultRenderer: (val) => (
            <span className="color-dark-black">{val}</span>
        )
    });

    const react_book_a_space_for_s = formatReactString(t("react_book_a_space_for_s"), [spotName], {
        defaultRenderer: (val) => (
            <span className="color-dark-black">{val}</span>
        )
    });

    const loadingprocessModal = () => {
        setShowBookingProcess(true)
    }

    const LoadingProcessModal = () => {
        return (
            <div className="modal" style={{ display: 'block', backgroundColor: 'rgba(217, 217, 217, 0.59)' }}
                id="dateModal" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="dateModalLabel" aria-hidden="true"
            >
                <div className="modal fade show alertpopup d-block">
                    <div className="modal-dialog modal-dialog-centered modal-custom-width">
                        <div className="modal-content modal-radius">
                            <div className="modal-body">
                                <div className="d-flex justify-content-between align-items-center mb-4">
                                    <h5 className="popup-title">{t("warning")}</h5>
                                    <div className="close-modal">
                                        <a onClick={() => setShowBookingProcess(false)}>
                                            <img src={WarningcloseIcon} aria-label="Close" />
                                        </a>
                                    </div>
                                </div>
                                <div className="modal-des mt-35">
                                    <p>
                                        {t("calender_request_pending_will_processed")}
                                    </p>
                                    <div className="modal-img text-center">
                                        <img className="warning-icon" src={WarningIcon} alt="Warning Icon" />
                                    </div>

                                    <div className="d-flex justify-content-end gap-3 mt-4">
                                        <button
                                            type="button"
                                            className="main-btn outline-alert-btn w-full"
                                            onClick={() => setShowBookingProcess(false)}
                                        >
                                            {t("confirm")}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div>
            <div>
                {/* <CanvasOuter> */}
                <div className="container">
                    <div className="position-relative z-0">
                        {parkingInformationImage && (
                            <div className="parking-info-container" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>

                                {/* 1. The Main Info Icon - Click to toggle options */}
                                <div
                                    onClick={() => setShowParkingOptions(!showParkingOptions)}
                                    className="map-info-zone"
                                    title={showParkingOptions ? t("parking_information") : t("parking_information")}
                                >
                                    <img
                                        src={showParkingOptions ? InformationIconGray : Informationicon}
                                        alt={showParkingOptions ? t("close") : t("react_info")}
                                        style={{ width: '48px', height: '48px' }} // adjust size as needed
                                    />
                                    {/* 2. The Options - Only show if icon was clicked */}
                                    {showParkingOptions && (
                                        <div className="parking-options-wrapper" style={{ display: 'flex', gap: '16px', alignItems: 'center', flexDirection: 'column' }}>

                                            {/* OPEN BUTTON */}
                                            <a

                                                onClick={() => window.open(parkingInformationImage, "_blank")}
                                                title={t("view_document")}
                                            >
                                                <img src={InformationEyeIcon} alt="show" />
                                            </a>

                                            {/* CLOSE/HIDE BUTTON */}
                                            <a
                                                onClick={() => setShowParkingOptions(false)}
                                                title={t("close")}
                                            >
                                                <img src={InformationCloseIcon} alt="Close" />
                                            </a>

                                        </div>
                                    )}
                                </div>


                            </div>
                        )}
                        <div
                            style={{
                                position: "absolute",
                                bottom: 60,
                                right: 60,
                                width: "72px",
                                zIndex: 99,
                                background: "#f8f8f8",
                                padding: "0px",
                                borderRadius: "6px",
                                boxShadow: "4px 4px 22px 0px #00000040",
                                border: "2px solid #FFFFFF",
                                textAlign: "center",
                            }}
                        >
                            <button type="button" onClick={zoomIn} className="btn-zoom" disabled={zoom === 100}><img src={zoomInIcon} alt="Zoom In"></img></button>
                            <button type="button" className="zoom-text">{total}%</button>
                            <button type="button" onClick={zoomOut} className="btn-zoom" disabled={zoom === 0}><img src={zoomOutIcon} alt="Zoom Out"></img></button>
                        </div>
                        <div className="map-section">
                            <div className="map-inner-scroll">
                                {zoneData ? (
                                    <div
                                        style={{
                                            width: `${zoneData.Columns * 100 * scale}px`,
                                            height: `${zoneData.Rows * 100 * scale}px`,
                                        }}>
                                        <CanvasScaler key={scale} scale={scale}>
                                            <CanvasContainer
                                                width={zoneData.ZoneImageWidth}
                                                height={zoneData.ZoneImageHeight}
                                                $backgroundImage={zoneData.ZoneImage}
                                            >
                                                {spots.length ? (
                                                    spots.map((spot, index) => {
                                                        if (spot.ViewFlag !== 1) return null;

                                                        const displayName = getSpotLabelText(spot, index);
                                                        const roleIcons =
                                                            showRoleIcons && spot?.EmployeeRoleIconList?.length > 0
                                                                ? spot.EmployeeRoleIconList
                                                                : [];

                                                        // const firstIcon = roleIcons[0]?.IconImage;
                                                        const iconToShow =
                                                            roleIcons.length > 1
                                                                ? spot.RoleIconImage
                                                                : roleIcons[0]?.IconImage;

                                                        const iconToShowdisplay = spot.RoleIconImage || null;

                                                        const showRoleIcon = iconToShow && zoneTypeforUserIcon;
                                                        const hasMeetingRoomBookings =
                                                            spot?.SpotType === 3 &&
                                                            spot?.MeetingRoomBookingList?.length > 0;
                                                        const isColorBlindMode =
                                                            showBookingForStaff === 0 && showAvailabilityColour === 3;
                                                        const hasStripedImage =
                                                            spot.HourlySpot === 1 &&
                                                            Boolean(spot.StripedHourlyImage) &&
                                                            spot.IsPartiallyBooked === 1;
                                                        const shouldShowFullOpacity =
                                                            spot.ShowFullOpacityForTeam === 1 ||
                                                            spot.ShowFullOpacity === 1 ||
                                                            isColorBlindMode ||
                                                            hasStripedImage;
                                                        const isColorBlindPartialHourlySpot =
                                                            showBookingForStaff === 0 &&
                                                            showAvailabilityColour === 3 &&
                                                            spot.HourlySpot === 1 &&
                                                            spot.IsPartiallyBooked === 1 &&
                                                            Boolean(spot.StripedHourlyImage);
                                                        const shouldSkipBackground =
                                                            isColorBlindMode &&
                                                            !isColorBlindPartialHourlySpot &&
                                                            (
                                                                Boolean(spot.ColorBlindnessSpotImageUrl) ||
                                                                (spot.SpotId > 0 && spot.ClaimFlag !== 0)
                                                            );
                                                        const backgroundColor =
                                                            spot.BackgroundColor || spot.BackgroundColorForWeb || "transparent";
                                                        const borderColor =
                                                            spot.BorderColor || spot.BackgroundColor || "#333";
                                                        const fillColor = shouldShowFullOpacity
                                                            ? backgroundColor
                                                            : (() => {
                                                                if (!backgroundColor || backgroundColor === "transparent") {
                                                                    return "transparent";
                                                                }

                                                                const cleanHex = backgroundColor.replace("#", "");
                                                                const [r, g, b] = cleanHex.length === 3
                                                                    ? [
                                                                        parseInt(cleanHex[0] + cleanHex[0], 16),
                                                                        parseInt(cleanHex[1] + cleanHex[1], 16),
                                                                        parseInt(cleanHex[2] + cleanHex[2], 16)
                                                                    ]
                                                                    : [
                                                                        parseInt(cleanHex.substring(0, 2), 16),
                                                                        parseInt(cleanHex.substring(2, 4), 16),
                                                                        parseInt(cleanHex.substring(4, 6), 16)
                                                                    ];

                                                                return `rgba(${r}, ${g}, ${b}, 0.2)`;
                                                            })();
                                                        //         const showColorBlindIcon =
                                                        //             showBookingForStaff === 0 &&
                                                        //             showAvailabilityColour === 3 &&
                                                        //             Boolean(spot.ColorBlindnessSpotImageUrl);
                                                        //         const isLayeredPartialHourlySpot =
                                                        //             spot.HourlySpot === 1 &&
                                                        //             spot.IsPartiallyBooked === 1 &&
                                                        //             Boolean(spot.GridViewFacingImageBG) &&
                                                        //             Boolean(spot.StripedHourlyImage);
                                                        //         const shouldShowLabel =
                                                        //             Boolean(spot && (spot.FullName || spot.SpotName)) &&
                                                        //             !showRoleIcon &&
                                                        //             !showColorBlindIcon;
                                                        // const spotImage = getSpotImage(spot);
                                                        const shouldSuppressColorBlindIcon =
                                                            isColorBlindMode &&
                                                            Boolean(showRoleIcon) &&
                                                            (
                                                                spot.IsAllDaySpot === 1 ||
                                                                spot.IsPartiallyBooked === 1
                                                            );
                                                        const showColorBlindIcon =
                                                            showBookingForStaff === 0 &&
                                                            showAvailabilityColour === 3 &&
                                                            !shouldSuppressColorBlindIcon &&
                                                            Boolean(spot.ColorBlindnessSpotImageUrl);
                                                        const isLayeredPartialHourlySpot =
                                                            spot.HourlySpot === 1 &&
                                                            spot.IsPartiallyBooked === 1 &&
                                                            Boolean(spot.GridViewFacingImageBG) &&
                                                            Boolean(spot.StripedHourlyImage);
                                                        const shouldShowLabel =
                                                            Boolean(spot && (spot.FullName || spot.SpotName)) &&
                                                            !showRoleIcon &&
                                                            !showColorBlindIcon
                                                        const isCurrentUserFullDayBooking =
                                                            spot.IsAllDaySpot === 1 &&
                                                            spot.ClaimFlag === 2;
                                                        const isHourlySpot = spot.ClaimFlag === 1 && spot.HourlySpot === 1;

                                                        // const ColorBlindshouldShowLabel =
                                                        //     !showRoleIcon

                                                        const spotImage = getSpotImage(spot, {
                                                            suppressColorBlindIcon: shouldSuppressColorBlindIcon,
                                                        });

                                                        return (
                                                            
                                                            <SpotHoverContainer
                                                                key={spot.SpotId || index}
                                                                onContextMenu={(event) =>
                                                                    handleSpotContextMenu(
                                                                        event,
                                                                        spot,
                                                                        Boolean(showRoleIcon),
                                                                        hasMeetingRoomBookings
                                                                    )
                                                                }
                                                                style={spot ? getCanvasSpotStyles(spot) : {}}
                                                            >
                                                                <div className="position-relative z-1">
                                                                {hasMeetingRoomBookings && (
                                                                    <TooltipWrapper $variant="meeting">
                                                                        <div style={{ fontWeight: 'bold', color: '#1c988a', marginBottom: '8px', fontSize: '12px' }}>
                                                                            <h4>{spot.SpotName} </h4>
                                                                        </div>
                                                                        <TooltipTable>
                                                                            <thead>
                                                                                <tr>
                                                                                    <th>{t("Organizer")}</th>
                                                                                    <th>{t("time")}</th>
                                                                                    <th>{t("name")}</th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                {spot.MeetingRoomBookingList.map((booking) => (
                                                                                    <tr key={booking.Id}>
                                                                                        <td>{booking.OrganiserName}</td>
                                                                                        <td style={{ whiteSpace: 'nowrap' }}>
                                                                                            {booking.StartTime} - {booking.EndTime}<br />
                                                                                            {/* <span style={{ color: '#999', fontWeight: 'normal' }}>to {booking.EndTime}</span> */}
                                                                                        </td>
                                                                                        <td>
                                                                                            <MeetingTitleText title={booking.Title}>
                                                                                                {booking.Title}
                                                                                            </MeetingTitleText>
                                                                                        </td>
                                                                                    </tr>
                                                                                ))}
                                                                            </tbody>
                                                                        </TooltipTable>
                                                                    </TooltipWrapper>
                                                                )}
                                                                <SpotBox
                                                                    style={{
                                                                            backgroundColor: (isLayeredPartialHourlySpot || isColorBlindPartialHourlySpot)
                                                                            ? "transparent"
                                                                            : spot.BorderAndBackgroundFlag !== 0
                                                                                ? fillColor
                                                                                : "transparent",
                                                                        backgroundImage: shouldSkipBackground
                                                                            ? "none"
                                                                            : isColorBlindPartialHourlySpot
                                                                                ? `url(${spot.StripedHourlyImage})`
                                                                            : isLayeredPartialHourlySpot
                                                                                ? `url(${spot.StripedHourlyImage}), url(${spot.GridViewFacingImageBG})`
                                                                            : hasStripedImage
                                                                                ? `url(${spot.StripedHourlyImage})`
                                                                                : spot.GridViewFacingImageBG
                                                                                    ? `url(${spot.GridViewFacingImageBG})`
                                                                                    : "none",
                                                                        backgroundRepeat: isLayeredPartialHourlySpot
                                                                            ? "no-repeat, no-repeat"
                                                                            : isColorBlindPartialHourlySpot
                                                                                ? "no-repeat"
                                                                            : "no-repeat",
                                                                        backgroundSize: isLayeredPartialHourlySpot
                                                                            ? "100% 100%, 100% 100%"
                                                                            : isColorBlindPartialHourlySpot
                                                                                ? "100% 100%"
                                                                            : (!shouldSkipBackground && (spot.GridViewFacingImageBG || hasStripedImage)) ? "cover" : "initial",
                                                                        backgroundPosition: isLayeredPartialHourlySpot
                                                                            ? "center, center"
                                                                            : isColorBlindPartialHourlySpot
                                                                                ? "center"
                                                                            : "center",
                                                                        border: spot.BorderFlag === 1
                                                                            ? `3px solid ${borderColor}`
                                                                            : "none",
                                                                        color: shouldShowFullOpacity ? "#FFFFFF" : "#000000",
                                                                        transform: `rotate(${spot.Angle}deg)`,
                                                                        cursor: isSpotClickable(spot) ? "pointer" : "default",
                                                                        zIndex: 0,
                                                                    }}
                                                                    onClick={() => {
                                                                        if (loading) {
                                                                            loadingprocessModal();
                                                                        } else if (spot) {
                                                                            handleSpotClick(spot);
                                                                        }
                                                                    }}
                                                                >
                                                                    {loading && bookingSpotId === spot.SpotId && (
                                                                        <SpotLoadingOverlay
                                                                            onClick={(event) => {
                                                                                event.stopPropagation();
                                                                                loadingprocessModal();
                                                                            }}
                                                                            style={{ cursor: 'pointer', pointerEvents: 'auto' }}
                                                                        >
                                                                            <img src={CellLoader} alt="Loading" />
                                                                        </SpotLoadingOverlay>
                                                                    )}

                                                                    {spotImage && (
                                                                        <SpotImage
                                                                            src={spotImage}
                                                                            alt={spot.SpotName || "Spot"}
                                                                                style={{
                                                                                    zIndex: showColorBlindIcon ? 4 : 2,
                                                                                    width: showColorBlindIcon ? "42%" : "100%",
                                                                                    height: showColorBlindIcon ? "42%" : "100%",
                                                                                    objectFit: showColorBlindIcon ? "contain" : "fill",
                                                                                }}
                                                                        />
                                                                    )}

                                                                    {showRoleIcon && (
                                                                        <RoleIconWrapper
                                                                            style={spot.StripedHourlyImage ? {
                                                                                //background: "rgba(23, 68, 136, 0.95)",
                                                                                backgroundColor: isLayeredPartialHourlySpot
                                                                                    ? (spot.BackgroundColor || spot.BackgroundColorForWeb || "transparent")
                                                                                    : spot.IsPartiallyBooked === 1
                                                                                        ? (spot.BackgroundColor || spot.BackgroundColorForWeb || "transparent")
                                                                                    : "transparent",
                                                                                //border: "1.5px solid #ffffff",
                                                                                border: spot.BorderColor,    
                                                                                //borderRadius: "999px",
                                                                                //width: "28px",
                                                                                //height: "28px",
                                                                                minHeight: isLayeredPartialHourlySpot ? "22px" : "40%",
                                                                                minWidth:"101%",
                                                                                maxWidth: isLayeredPartialHourlySpot ? "78%" : "100%",
                                                                                boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                                                                            } : undefined}
                                                                        >
                                                                            <img
                                                                                src={iconToShowdisplay}
                                                                                className="img-fluid"
                                                                                alt="role-icon"
                                                                                style={{
                                                                                    width: spot.StripedHourlyImage ? "22px" : "22px",
                                                                                    height: spot.StripedHourlyImage ? "22px" : "22px",
                                                                                    objectFit: "contain",
                                                                                    filter:(isCurrentUserFullDayBooking || isHourlySpot)
                                                                                        ? "brightness(0) saturate(100%) invert(100%)"
                                                                                        : "none",
                                                                                }}
                                                                            />

                                                                            {roleIcons.length > 0 && (
                                                                                <RoleTooltipTable>
                                                                                    <div style={{ fontWeight: 'bold', color: '#1c988a', marginBottom: '5px', fontSize: '12px' }}>
                                                                                        <h4>{t("react_employee_roles")}</h4>
                                                                                    </div>
                                                                                    <IconTable>
                                                                                        <thead>
                                                                                            <tr>
                                                                                                <th>{t("role")}</th>
                                                                                                <th>{t("role_name")}</th>
                                                                                            </tr>
                                                                                        </thead>
                                                                                        <tbody>
                                                                                            {roleIcons.map((role, i) => (
                                                                                                <tr key={i}>
                                                                                                    <td>
                                                                                                        <img src={role.IconImage} alt="icon" />
                                                                                                    </td>
                                                                                                    <td style={{ color: '#333' }}>
                                                                                                        {role.Name}
                                                                                                    </td>
                                                                                                </tr>
                                                                                            ))}
                                                                                        </tbody>
                                                                                    </IconTable>
                                                                                </RoleTooltipTable>
                                                                            )}
                                                                        </RoleIconWrapper>
                                                                    )}

                                                                    {/* ✅ Always render wrapper */}
                                                                   

                                                                    {shouldShowLabel && (
                                                                        <SpotNameWrapper
                                                                            style={{
                                                                                fontSize: isLayeredPartialHourlySpot
                                                                                   // ? `${Math.max(10, Math.round(mapFontSize * 0.58))}px`
                                                                                    ? "14px"
                                                                                    : `${mapFontSize}px`,
                                                                                // padding: isLayeredPartialHourlySpot ? "4px 8px" : "0",
                                                                                minHeight: isLayeredPartialHourlySpot ? "auto" : "20%",
                                                                                // width: isLayeredPartialHourlySpot ? "78%" : "100%",
                                                                                minWidth:"101%",
                                                                                maxWidth: "100%",
                                                                                // borderRadius: isLayeredPartialHourlySpot ? "2px" : "0",
                                                                                lineHeight: isLayeredPartialHourlySpot ? "1.1" : "normal",
                                                                                whiteSpace: isLayeredPartialHourlySpot ? "normal" : "normal",
                                                                                textOverflow: isLayeredPartialHourlySpot ? "ellipsis" : "clip",
                                                                                overflow: "hidden",
                                                                                backgroundColor: isLayeredPartialHourlySpot
                                                                                    ? (spot.BackgroundColor || spot.BackgroundColorForWeb || "transparent")
                                                                                    : isColorBlindPartialHourlySpot
                                                                                        ? (spot.BackgroundColor || spot.BackgroundColorForWeb || "transparent")
                                                                                    : spot.IsPartiallyBooked === 1
                                                                                        ? (spot.BackgroundColor || spot.BackgroundColorForWeb || "transparent")
                                                                                    : "transparent",
                                                                                border: isLayeredPartialHourlySpot ? `1px solid ${borderColor}` : "none",    
                                                                                color: spot.IsPartiallyBooked === 1 ? "#ffffff" : "",
                                                                                // boxShadow: isLayeredPartialHourlySpot ? "0 1px 2px rgba(0,0,0,0.15)" : "none",
                                                                                fontWeight:"800",
                                                                            }}
                                                                        >
                                                                            {/* ✅ Hide only text when icon exists */}
                                                                            {displayName}
                                                                        </SpotNameWrapper>
                                                                    )}


                                                                    {showRoleIcons == false && spot?.SpotType === 2 && spot?.HourlyBookingList?.length > 0 && (
                                                                        <TooltipWrapper>
                                                                            <div style={{ fontWeight: 'bold', color: '#1c988a', marginBottom: '8px', fontSize: '12px' }}>
                                                                                <h4>{spot.SpotName} </h4>
                                                                            </div>
                                                                            <TooltipTable>
                                                                                <thead>
                                                                                    <tr>
                                                                                        <th>{t("Name")}</th>
                                                                                        <th>{t("time")}</th>
                                                                                        {/* <th>{t("name")}</th> */}
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    {spot.HourlyBookingList.map((booking) => (
                                                                                        <tr key={booking.Id}>
                                                                                            <td>{booking.Name}</td>
                                                                                            <td style={{ whiteSpace: 'nowrap' }}>
                                                                                                {booking.BookingStartTime} - {booking.BookingEndTime}<br />
                                                                                                {/* <span style={{ color: '#999', fontWeight: 'normal' }}>to {booking.EndTime}</span> */}
                                                                                            </td>
                                                                                            {/* <td>{booking.Title}</td> */}
                                                                                        </tr>
                                                                                    ))}
                                                                                </tbody>
                                                                            </TooltipTable>
                                                                        </TooltipWrapper>
                                                                    )}

                                                                </SpotBox>

 </div>

                                                            </SpotHoverContainer>
                                                           
                                                        );
                                                    })
                                                ) : (
                                                    <div>No spots available</div>
                                                )}
                                            </CanvasContainer>
                                        </CanvasScaler>
                                    </div>
                                ) : (
                                    <MapErrorContainer>
                                        <div>Error loading grid data. Please try again.</div>
                                    </MapErrorContainer>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                {/* </CanvasOuter> */}
                {(notification && !isLoadingMap) && (
                    <NotificationMessage
                        type={notification.type}
                        title={notification.title}
                        message={notification.message}
                        duration={6000}
                        onClose={() => setNotification(null)}
                    />
                )}
                {renderApiUi(isLoadingMap)}
            </div>

            {isLoadingMap && (
                <div className="map-screen-loader-overlay">
                    <img src={LoaderFull} alt="Loading" />
                </div>
            )}

            {showModal && selectedSpot && (
                <div>
                    {/* <ModalContent> */}
                    {/* Require ClaimFlag, then branch by spot type to match MapCanvasZone click logic */}
                    {
                        //Meeting Room Spot
                        selectedSpot.SpotType === 3 ? (
                            <NewMeetingModal
                                setIsLoading={setIsLoadingMap}
                                isLoading={isLoadingMap}
                                show={true}
                                date={bookingDate}
                                // startTime="00:00:00"
                                // endTime="23:59:59"
                                selectedZone={selectedZone?.Id}
                                mapType={selectedZone.Id ? (zoneData[selectedZone.Id] ?? 2) : undefined}
                                onClose={closeModal}
                                onConfirm={fetchMapDataafterMeeting}
                                onMeetingCreatedWithDate={async (createdMeetingDate) => {
                                    if (createdMeetingDate) {
                                        meetingCreatedDateRef.current = createdMeetingDate;
                                        setBookingDate?.(createdMeetingDate);
                                        resetDraftBookingDate(createdMeetingDate);
                                        await fetchMapDataafterMeeting(createdMeetingDate);
                                        return;
                                    }

                                    await fetchMapDataafterMeeting(bookingDate);
                                }}
                                setNotification={setNotification}
                                navSpotId={selectedSpot?.SpotId}
                                setShowScheduleMeetingModal={setShowModal}
                            />
                        ) :
                            //fullDay Spot
                            selectedSpot.IsAllDaySpot === 1 ? (
                                <div>
                                    <div className="modal modalscroll" style={{ display: 'block', backgroundColor: 'rgba(217, 217, 217, 0.59)' }}
                                        id="dateModal" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="dateModalLabel" aria-hidden="true"
                                    >
                                        <div className="modal-dialog modal-dialog-centered modal-custom-width">
                                            <div className="modal-content modal-radius">
                                                <div className="modal-body">

                                                    <div className="close-modal">
                                                        <a>
                                                            <img src={Close} alt="Close" onClick={resetForm} />
                                                        </a>
                                                    </div>

                                                    <div className="pt-4">
                                                        {/* <h5 className="popup-title">Book space {selectedSpot.SpotName}?</h5> */}
                                                        <h5 className="popup-title">{react_book_a_space_for_s}?</h5>
                                                    </div>
                                                    <div className="date-with-credit d-flex align-items-center justify-content-between pt-2">
                                                        <div id="selectedDate" className="selected-current-date">
                                                            <span>{dateforfullday}</span>
                                                            <span>{monthforfullday} {yearforfullday}</span>
                                                        </div>
                                                        {zoneCreditValue > 0 && (
                                                            <div className="credit-info">
                                                                {/* {creditInfoJSX} */}
                                                                <a
                                                                    className="orange-outline-with-icon"
                                                                >
                                                                    {CreditValueGrey ?
                                                                        (
                                                                            <>
                                                                                <img src={GrayStar} alt="star" />
                                                                                <span>{individualDayCost}</span>
                                                                            </>
                                                                        )
                                                                        :
                                                                        <>
                                                                            <img src={Images.OrangeStar} alt="" />
                                                                            <span>{Number(individualDayCost) > 0
                                                                                ? `-${individualDayCost}`
                                                                                : individualDayCost}</span>
                                                                        </>
                                                                    }
                                                                </a>
                                                            </div>
                                                        )}
                                                    </div>
                                                    <form onSubmit={e => {
                                                        let errors = {};
                                                        if (!selectedSpot) {
                                                            errors.spot = "Please select a spot.";
                                                        }
                                                        if (spotBookingSlots && spotBookingSlots.length > 0 && !selectedSlot) {
                                                            errors.spot = "Please select a Spot.";
                                                        }
                                                        if (vehiclesForSpot && vehiclesForSpot.length > 0 && !selectedVehicle) {
                                                            errors.vehicle = "Please select a vehicle.";
                                                        }
                                                        // Add more field checks as needed
                                                        if (Object.keys(errors).length > 0) {
                                                            e.preventDefault();
                                                            setRequiredFields(errors);
                                                            return;
                                                        }
                                                        setRequiredFields({});
                                                        // Call your submit function here
                                                        Submit_FullDayBooking(e)
                                                    }}>
                                                        {/* <h3>Book space {selectedSpot.SpotName}?</h3> */}
                                                        <div className="divider-line mt-3"></div>
                                                        <div className="modal-des">
                                                            <div className="modal-scroll-inner me-4">

                                                                <div className="icon-with-list mb-3">
                                                                    <div className="icon-wrap">
                                                                        <img src={Images.Participant} />
                                                                        <h4 className="ps-1 ms-1">{bookingModalParticipantName}</h4>
                                                                    </div>
                                                                </div>
                                                                <div className="modal-tag">
                                                                    {selectedSpot.SpotTagList && selectedSpot.SpotTagList.length > 0 && (
                                                                        <div className="modal-tag">
                                                                            <button
                                                                                type="button"
                                                                                id="show-tag-tab"
                                                                                className={showTags ? "active" : ""}
                                                                                onClick={() => setShowTags(!showTags)} // Toggle the state on click
                                                                            >
                                                                                <img src={Images.ModalTag} className="img-fluid" alt="Tags" />
                                                                                <span className="show-link">{t("show_tags")}</span>
                                                                                <span className="hide-link">{t("react_hide_tags")}</span>
                                                                                {/* {showTags ? 'Hide Tags' : 'Show Tags'} */}
                                                                            </button>
                                                                        </div>
                                                                    )}
                                                                    {/* </div> */}

                                                                    {/* 2. Conditionally display the Spot Tags list */}
                                                                    {showTags && selectedSpot.SpotTagList && (
                                                                        <div id="all-tags" className={showTags ? "show" : ""}>
                                                                            {selectedSpot.SpotTagList.map((tag, index) => (
                                                                                <button type="button" key={index}>
                                                                                    {tag.TagName}
                                                                                </button>
                                                                            ))}
                                                                        </div>
                                                                    )}
                                                                </div>
                                                                {/* </div> */}

                                                                {vehiclesForSpot.length > 0 && (
                                                                    <div className="custom-dropdown modal-dropdown mb-3">
                                                                        <CustomSearchableDropdown
                                                                            items={vehiclesForSpot}
                                                                            // The current selected ID
                                                                            value={selectedVehiclePrimaryKey}
                                                                            // The key from your data to show in the list (Registration ID)
                                                                            labelKey="VehicleRegistrationId"
                                                                            // The key from your data used as the unique ID
                                                                            valueKey="VehiclePrimaryKey"
                                                                            searchable={false}
                                                                            placeholder="Select Vehicle"
                                                                            disabled={!vehiclesForSpot.length}
                                                                            onChange={(pk) => {
                                                                                // 1. Update the Primary Key state
                                                                                setSelectedVehiclePrimaryKey(pk);

                                                                                // 2. Find the full vehicle object and update it
                                                                                const vehicleObj = vehiclesForSpot.find(v => v.VehiclePrimaryKey === pk);
                                                                                setSelectedVehicle(vehicleObj);

                                                                                // 3. Close the validation error for 'vehicle'
                                                                                setRequiredFields(prev => ({
                                                                                    ...prev,
                                                                                    vehicle: ""
                                                                                }));

                                                                                // Optional: Debugging logs
                                                                                /* if (vehicleObj) {
                                                                                    console.log("Vehicle Selected:", vehicleObj.VehicleRegistrationId);
                                                                                    console.log("PK:", pk);
                                                                                } */
                                                                            }}
                                                                        />
                                                                    </div>
                                                                )
                                                                }
                                                                {requiredFields.vehicle && (
                                                                    <div style={{ color: 'red', marginTop: 8, fontSize: 14 }}>{requiredFields.vehicle}</div>
                                                                )}

                                                                <div className="participants-list ctm-checklist pt-0">
                                                                    {!!preBookinQueCanvas && (
                                                                        <div className="form-check">
                                                                            <input
                                                                                className="form-check-input"
                                                                                type="checkbox"
                                                                                id={`preBookinQueCanvas`}
                                                                                checked={checkedPreBookingQue}
                                                                                onChange={(e) => setCheckedPreBookingQue(e.target.checked)}
                                                                            />

                                                                            <label
                                                                                className="form-check-label ms-2"
                                                                                htmlFor={`preBookinQueCanvas`}
                                                                            >
                                                                                <span dangerouslySetInnerHTML={{ __html: safeHtml }} />

                                                                            </label>
                                                                        </div>
                                                                    )}
                                                                </div>

                                                                <div className="text-center my-34">
                                                                    {zoneData.ZoneType == 1 ?
                                                                        <img src={ParkingIcon} className="img-fluid" alt="Parking Booking" />
                                                                        : <img src={DeskIcon} className="img-fluid" alt="Desk Booking" />
                                                                    }
                                                                </div>

                                                            </div>
                                                        </div>

                                                        {/* <div className="tags-btn me-4 mt-3">
                                                                <button
                                                                    type="submit"
                                                                    className="w-100 min-height-56 selected"
                                                                    disabled={loading}
                                                                >
                                                                    {loading ? <div id='preloader'>
                                                                        <img src={LoaderFull} alt="Loading" />
                                                                    </div> : "Confirm"}
                                                                </button>
                                                            </div> */}
                                                        <div className="tags-btn me-4 mt-3">
                                                            <button
                                                                type="submit"
                                                                className="w-100 min-height-56 selected"
                                                                // Button is disabled if:
                                                                // 1. Loading is true
                                                                // 2. OR (The question exists AND it is NOT checked)
                                                                disabled={loading || (!!preBookinQueCanvas && !checkedPreBookingQue)}
                                                                style={{
                                                                    // Optional: add a visual cue for disabled state
                                                                    opacity: (loading || (!!preBookinQueCanvas && !checkedPreBookingQue)) ? 0.5 : 1,
                                                                    cursor: (loading || (!!preBookinQueCanvas && !checkedPreBookingQue)) ? "not-allowed" : "pointer"
                                                                }}
                                                            >
                                                                {loading ? (
                                                                    <div id='preloader'>
                                                                        <img src={LoaderFull} alt="Loading" />
                                                                    </div>
                                                                ) : (
                                                                    <div>
                                                                        {t("confirm")}
                                                                    </div>
                                                                    // "Confirm"
                                                                )}
                                                            </button>
                                                        </div>

                                                        <div className="tags-btn me-4 mt-3"> {/* Optional: Div for button grouping */}
                                                            <button
                                                                type="button"
                                                                className="w-100 min-height-56"
                                                                onClick={resetForm}>
                                                                {t("cancel")}
                                                            </button>
                                                        </div>
                                                        {/* {vehicleIds && vehicleIds.length > 0 && (
                                        <select>
                                            <option value="">Select Vehicle</option>
                                            {vehicleIds.map((id, index) => (
                                                <option key={index} value={id}>
                                                    {id}
                                                </option>
                                            ))}
                                        </select>
                                    )} */}
                                                    </form>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ) :
                                //Hourly Spot
                                // selectedSpot.BookingTimeType === 1
                                ([1, 2, 3, 4, 5, 6, 7, 8, 9, 10].includes(selectedSpot.BookingTimeType) && !isThirtyMinuteModalReadOnly) ? (
                                    <div>
                                        <div className="modal modalscroll" style={{ display: 'block', backgroundColor: 'rgba(217, 217, 217, 0.59)' }}
                                            id="dateModal" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="dateModalLabel" aria-hidden="true"
                                        >
                                            <div className="modal-dialog modal-dialog-centered modal-custom-width">
                                                <div className="modal-content modal-radius">
                                                    <div className="modal-body">

                                                        <div className="close-modal">
                                                            <a>
                                                                <img src={Close} alt="Close" onClick={resetForm} />
                                                            </a>
                                                        </div>
                                                        <div className="pt-4">
                                                            {/* <h5 className="popup-title">{t("assign")} {selectedSpot.SpotName}?</h5> */}
                                                            <h5 className="popup-title">{react_book_a_space_for_s}?</h5>
                                                        </div>

                                                        <div className="date-with-credit d-flex align-items-center justify-content-between pt-2">
                                                            <div id="selectedDate" className="selected-current-date">
                                                                <span>{dateforfullday}</span>
                                                                <span>{monthforfullday} {yearforfullday}</span>
                                                            </div>
                                                            {zoneCreditValue > 0 && (
                                                                <div className="credit-info">
                                                                    {/* {creditInfoJSX} */}
                                                                    <a
                                                                        className="orange-outline-with-icon"
                                                                    >
                                                                        {CreditValueGrey ?
                                                                            (
                                                                                <>
                                                                                    <img src={GrayStar} alt="star" />
                                                                                    <span>{individualDayCost}</span>
                                                                                </>
                                                                            )
                                                                            :
                                                                            <>
                                                                                <img src={Images.OrangeStar} alt="" />
                                                                                <span>{Number(individualDayCost) > 0
                                                                                    ? `-${individualDayCost}`
                                                                                    : individualDayCost}</span>
                                                                            </>
                                                                        }
                                                                    </a>
                                                                </div>
                                                            )}
                                                        </div>
                                                        {/* <div id="selectedDate" className="selected-current-date">
                                                                <span>{dateforfullday}</span>
                                                                <span>{monthforfullday} &nbsp; {yearforfullday}</span>
                                                            </div> */}
                                                        <form onSubmit={e => {
                                                            let errors = {};
                                                            if (spotBookingSlots && spotBookingSlots.length > 0 && !selectedSlot) {
                                                                errors.spot = "Please select a spot.";
                                                            }
                                                            if (vehiclesForSpot && vehiclesForSpot.length > 0 && !selectedVehicle) {
                                                                errors.vehicle = "Please select a vehicle.";
                                                            }
                                                            // Add more field checks as needed
                                                            if (Object.keys(errors).length > 0) {
                                                                e.preventDefault();
                                                                setRequiredFields(errors);
                                                                return;
                                                            }
                                                            setRequiredFields({});
                                                            Submit_HourlySpot(e)
                                                        }}>
                                                            {/* <button onClick={closeModal}>Cancel</button>
                                            <h3>Design of slot-wise booking</h3>
                                            <p>15:00 - 16:00</p>
                                            <p>16:00 - 17:00</p>
                                            <p>17:00 - 18:00</p> */}
                                                            <div className="divider-line mt-3"></div>
                                                            <div className="modal-des">
                                                                <div className="modal-scroll-inner me-4">

                                                                    <div className="icon-with-list mb-3">

                                                                        <div className="icon-wrap">
                                                                            <img src={Images.Participant} />
                                                                            {/* <h4 className="ps-1 ms-1">{selectedName || getFirstName() || "Name"}</h4> */}
                                                                            <h4 className="ps-1 ms-1">{bookingModalParticipantName}</h4>
                                                                        </div>
                                                                    </div>

                                                                    <div className="modal-tag">
                                                                        {selectedSpot.SpotTagList && selectedSpot.SpotTagList.length > 0 && (
                                                                            <div className="modal-tag">
                                                                                <button
                                                                                    type="button"
                                                                                    id="show-tag-tab"
                                                                                    className={showTags ? "active" : ""}
                                                                                    onClick={() => setShowTags(!showTags)} // Toggle the state on click
                                                                                >
                                                                                    <img src={Images.ModalTag} className="img-fluid" alt="Tags" />
                                                                                    <span className="show-link">{t("show_tags")}</span>
                                                                                    <span className="hide-link">{t("react_hide_tags")}</span>
                                                                                    {/* {showTags ? 'Hide Tags' : 'Show Tags'} */}
                                                                                </button>
                                                                            </div>
                                                                        )}
                                                                        {/* </div> */}

                                                                        {/* 2. Conditionally display the Spot Tags list */}
                                                                        {showTags && selectedSpot.SpotTagList && (
                                                                            <div id="all-tags" className={showTags ? "show" : ""}>
                                                                                {selectedSpot.SpotTagList.map((tag, index) => (
                                                                                    <button type="button" key={index}>
                                                                                        {tag.TagName}
                                                                                    </button>
                                                                                ))}
                                                                            </div>
                                                                        )}
                                                                    </div>

                                                                    {/* <p><strong>{selectedSpot.SpotName}</strong></p> */}
                                                                    {/* {spotBookingSlots.length > 0 && (
                                                                    <div className="custom-dropdown modal-dropdown mb-3" style={{ position: "relative" }}>
                                                                        <label htmlFor="">Slot</label>
                                                                        <CustomSearchableDropdown
                                                                            items={spotBookingSlots.map(slot => ({ label: slot, value: slot }))}
                                                                            value={selectedSlot || spotBookingSlots[0]}
                                                                            labelKey="label"
                                                                            valueKey="value"
                                                                            searchable={false}
                                                                            placeholder="-- Select Slot --"
                                                                            disabled={!spotBookingSlots.length}
                                                                            onChange={(val) => {
                                                                                // 1. Update the selected slot state
                                                                                setSelectedSlot(val);

                                                                                // 2. Close the dropdown (handled internally by most CustomSearchableDropdowns, 
                                                                                // but you can still toggle your state if needed)
                                                                                setSlotOpen(false);

                                                                                // 3. Clear the validation error for 'spot'
                                                                                setRequiredFields(prev => ({
                                                                                    ...prev,
                                                                                    spot: ""
                                                                                }));

                                                                                // Optional: Debugging
                                                                                console.log("Spot:", selectedSpot?.SpotName);
                                                                                console.log("Selected Slot:", val);
                                                                            }}
                                                                        />
                                                                    </div>
                                                                )
                                                                } */}

                                                                    {spotBookingSlots.length > 0 && (
                                                                        <div className="custom-timepicker pt-1 mb-3">
                                                                            <h6 className="popup-inner-title">{t("react_select_time")}</h6>
                                                                            <div
                                                                                className="selected-box mb-3"
                                                                                onClick={() => setSlotOpen((prev) => !prev)}
                                                                                style={{ cursor: "pointer" }}
                                                                            >
                                                                                <div>
                                                                                    {/* <label>{t("react_select_time")}</label> */}
                                                                                    <span>
                                                                                        {selectedSlotValues.length > 0
                                                                                            ? buildSlotRange(selectedSlotValues)
                                                                                            : buildSlotRange(selectedSlotValues)}
                                                                                    </span>
                                                                                </div>
                                                                                <div><img src={Images.DownArrow} alt="" /></div>
                                                                            </div>

                                                                            {slotOpen && (
                                                                                <div ref={slotContainerRef} className="slot-container d-grid mb-3">
                                                                                    {spotBookingSlots.map((slot, idx) => {
                                                                                        const isSelected = selectedSlotValues.includes(slot);

                                                                                        return (
                                                                                            <div
                                                                                                key={`${slot}-${idx}`}
                                                                                                className={`slot ${isSelected ? "active" : ""}`}
                                                                                                onClick={() => handleSpotBookingSlotToggle(slot)}
                                                                                            >
                                                                                                {slot}
                                                                                            </div>
                                                                                        );
                                                                                    })}
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    )}

                                                                    {/* {spotBookingSlots.length > 0 && (
                                                                    <div
                                                                        style={{ position: "relative" }}
                                                                    >
                                                                        <label htmlFor="">Slot</label>
                                                                        <div
                                                                            role="button"
                                                                            onClick={() => setSlotOpen(!slotOpen)}
                                                                            className="dropdown-toggle form-control position-relative custom-dropdown-btn ctm-select"
                                                                            style={{
                                                                                display: "flex",
                                                                                justifyContent: "space-between",
                                                                                cursor: "pointer",
                                                                            }}
                                                                        >
                                                                            <div className="d-flex flex-column">
                                                                                <p className="sub-dropdown-name">Slot</p>
                                                                                <span
                                                                                    style={{
                                                                                        fontSize: "16px",
                                                                                        fontWeight: "bold",
                                                                                        color: "#1c988a",
                                                                                    }}
                                                                                >
                                                                                    {selectedSlot || "-- Select Slot --"}
                                                                                </span>
                                                                            </div>
                                                                        </div>

                                                                        {slotOpen && (
                                                                            <div
                                                                                style={{
                                                                                    position: "absolute",
                                                                                    top: "calc(100% + 6px)",
                                                                                    left: 0,
                                                                                    width: "100%",
                                                                                    background: "#fff",
                                                                                    borderRadius: 12,
                                                                                    boxShadow: "0 10px 30px rgba(0,0,0,.15)",
                                                                                    maxHeight: 300,
                                                                                    overflowY: "auto",
                                                                                    zIndex: 9999,
                                                                                }}
                                                                            >
                                                                                {spotBookingSlots.map((slot, i) => (
                                                                                    <div
                                                                                        key={i}
                                                                                        onClick={() => {
                                                                                            setSelectedSlot(slot);
                                                                                            setSlotOpen(false);

                                                                                            setRequiredFields(prev => ({
                                                                                                ...prev,
                                                                                                spot: ""
                                                                                            }));

                                                                                            console.log("Spot:", selectedSpot?.SpotName);
                                                                                            console.log("Selected Slot:", slot);
                                                                                        }}
                                                                                        style={{
                                                                                            padding: "8px 12px",
                                                                                            display: "flex",
                                                                                            alignItems: "center",
                                                                                            cursor: "pointer",
                                                                                        }}
                                                                                    >
                                                                                        <input
                                                                                            type="radio"
                                                                                            checked={selectedSlot === slot}
                                                                                            readOnly
                                                                                            style={{
                                                                                                marginRight: 8,
                                                                                                accentColor: "#1c988a",
                                                                                            }}
                                                                                        />
                                                                                        <span>{slot}</span>
                                                                                    </div>
                                                                                ))}
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                )} */}

                                                                    {requiredFields.spot && (
                                                                        <div style={{ color: 'red', marginTop: 8, fontSize: 14 }}>{requiredFields.spot}</div>
                                                                    )}


                                                                    {vehiclesForSpot.length > 0 && (
                                                                        <div className="custom-dropdown modal-dropdown mb-3">
                                                                            <CustomSearchableDropdown
                                                                                items={vehiclesForSpot}
                                                                                // The current selected ID
                                                                                value={selectedVehiclePrimaryKey}
                                                                                // The key from your data to show in the list (Registration ID)
                                                                                labelKey="VehicleRegistrationId"
                                                                                // The key from your data used as the unique ID
                                                                                valueKey="VehiclePrimaryKey"
                                                                                searchable={false}
                                                                                placeholder="Select Vehicle"
                                                                                disabled={!vehiclesForSpot.length}
                                                                                onChange={(pk) => {
                                                                                    // 1. Update the Primary Key state
                                                                                    setSelectedVehiclePrimaryKey(pk);

                                                                                    // 2. Find the full vehicle object and update it
                                                                                    const vehicleObj = vehiclesForSpot.find(v => v.VehiclePrimaryKey === pk);
                                                                                    setSelectedVehicle(vehicleObj);

                                                                                    // 3. Close the validation error for 'vehicle'
                                                                                    setRequiredFields(prev => ({
                                                                                        ...prev,
                                                                                        vehicle: ""
                                                                                    }));

                                                                                    // Optional: Debugging logs
                                                                                    /* if (vehicleObj) {
                                                                                        console.log("Vehicle Selected:", vehicleObj.VehicleRegistrationId);
                                                                                        console.log("PK:", pk);
                                                                                    } */
                                                                                }}
                                                                            />
                                                                        </div>
                                                                    )
                                                                    }
                                                                    {/* {vehiclesForSpot.length > 0 && (
                                                                    <div
                                                                        className=""
                                                                        style={{ position: "relative" }}
                                                                    >
                                                                        <label htmlFor=""></label>
                                                                        <div
                                                                            role="button"
                                                                            onClick={() => setVehicleOpen(!vehicleOpen)}
                                                                            className="dropdown-toggle form-control position-relative custom-dropdown-btn ctm-select"
                                                                            style={{
                                                                                display: "flex",
                                                                                justifyContent: "space-between",
                                                                                cursor: "pointer",
                                                                            }}
                                                                        >

                                                                            <div className="d-flex flex-column">
                                                                                <p className="sub-dropdown-name">Vehicle</p>
                                                                                <span
                                                                                    style={{
                                                                                        fontSize: "16px",
                                                                                        fontWeight: "bold",
                                                                                        color: "#1c988a",
                                                                                    }}
                                                                                >
                                                                                    {selectedVehicle?.VehicleRegistrationId || vehiclesForSpot[0]?.VehicleRegistrationId}
                                                                                </span>
                                                                            </div>
                                                                        </div>

                                                                        {vehicleOpen && (
                                                                            <div
                                                                                style={{
                                                                                    position: "absolute",
                                                                                    top: "calc(100% + 6px)",
                                                                                    left: 0,
                                                                                    width: "100%",
                                                                                    background: "#fff",
                                                                                    borderRadius: 12,
                                                                                    boxShadow: "0 10px 30px rgba(0,0,0,.15)",
                                                                                    maxHeight: 300,
                                                                                    overflowY: "auto",
                                                                                    zIndex: 9999,
                                                                                }}
                                                                            >
                                                                                {vehiclesForSpot.map((v) => (
                                                                                    <div
                                                                                        key={v.VehiclePrimaryKey}
                                                                                        onClick={() => {
                                                                                            const pk = v.VehiclePrimaryKey;

                                                                                            setSelectedVehiclePrimaryKey(pk);
                                                                                            setSelectedVehicle(v);
                                                                                            setVehicleOpen(false);

                                                                                            setRequiredFields(prev => ({
                                                                                                ...prev,
                                                                                                vehicle: ""
                                                                                            }));

                                                                                            console.log("Spot +++++:", selectedSpot?.SpotName);
                                                                                            console.log("Registration +++++:", v.VehicleRegistrationId);
                                                                                            console.log("FuelId: ++++", v.FuelId);
                                                                                            console.log("VehiclePrimaryKey +++++++:", v.VehiclePrimaryKey);
                                                                                        }}
                                                                                        style={{
                                                                                            padding: "8px 12px",
                                                                                            display: "flex",
                                                                                            alignItems: "center",
                                                                                            cursor: "pointer",
                                                                                        }}
                                                                                    >
                                                                                        <input
                                                                                            type="radio"
                                                                                            checked={selectedVehiclePrimaryKey === v.VehiclePrimaryKey}
                                                                                            readOnly
                                                                                            style={{
                                                                                                marginRight: 8,
                                                                                                accentColor: "#1c988a",
                                                                                            }}
                                                                                        />
                                                                                        <span>{v.VehicleRegistrationId}</span>
                                                                                    </div>
                                                                                ))}
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                )} */}

                                                                    {requiredFields.vehicle && (
                                                                        <div style={{ color: 'red', marginTop: 8, fontSize: 14 }}>{requiredFields.vehicle}</div>
                                                                    )}

                                                                    <div className="participants-list ctm-checklist pt-0">
                                                                        {!!preBookinQueCanvas && (
                                                                            <div className="form-check">
                                                                                <input
                                                                                    className="form-check-input"
                                                                                    type="checkbox"
                                                                                    id={`preBookinQueCanvas`}
                                                                                    checked={checkedPreBookingQue}
                                                                                    onChange={(e) => setCheckedPreBookingQue(e.target.checked)}
                                                                                />

                                                                                <label
                                                                                    className="form-check-label ms-2"
                                                                                    htmlFor={`preBookinQueCanvas`}
                                                                                >
                                                                                    <span dangerouslySetInnerHTML={{ __html: safeHtml }} />

                                                                                </label>
                                                                            </div>
                                                                        )}
                                                                    </div>


                                                                    {/* <div className="divider-line mt-3"></div> */}
                                                                    <div className="text-center my-34">
                                                                        {zoneData.ZoneType == 1 ?
                                                                            <img src={ParkingIcon} className="img-fluid" alt="Parking Booking" />
                                                                            : <img src={DeskIcon} className="img-fluid" alt="Desk Booking" />
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            {/* <div className="tags-btn me-4 mt-3">
                                                                    <button
                                                                        type="submit"
                                                                        className="w-100 min-height-56"
                                                                        disabled={loading}
                                                                    >
                                                                        {loading ? <div id='preloader'>
                                                                            <img src={LoaderFull} alt="Loading" />
                                                                        </div> : "Confirm selected"}
                                                                    </button>
                                                                </div> */}
                                                            <div className="tags-btn me-4 mt-3">
                                                                <button
                                                                    type="submit"
                                                                    className="w-100 min-height-56 selected"
                                                                    // Button is disabled if:
                                                                    // 1. Loading is true
                                                                    // 2. OR (The question exists AND it is NOT checked)
                                                                    disabled={loading || (!!preBookinQueCanvas && !checkedPreBookingQue)}
                                                                    style={{
                                                                        // Optional: add a visual cue for disabled state
                                                                        opacity: (loading || (!!preBookinQueCanvas && !checkedPreBookingQue)) ? 0.5 : 1,
                                                                        cursor: (loading || (!!preBookinQueCanvas && !checkedPreBookingQue)) ? "not-allowed" : "pointer"
                                                                    }}
                                                                >
                                                                    {loading ? (
                                                                        <div id='preloader'>
                                                                            <img src={LoaderFull} alt="Loading" />
                                                                        </div>
                                                                    ) : (
                                                                        <div>
                                                                            {t("confirm")}
                                                                        </div>
                                                                        // "Confirm"
                                                                    )}
                                                                </button>
                                                            </div>

                                                            <div className="tags-btn me-4 mt-3"> {/* Optional: Div for button grouping */}
                                                                <button
                                                                    type="button"
                                                                    className="w-100 min-height-56"
                                                                    onClick={resetForm}>
                                                                    {t("cancel")}
                                                                </button>
                                                            </div>
                                                        </form>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ) :
                                    // 30-minute Spot
                                    (selectedSpot.SpotType === 1 || selectedSpot.SpotType === 2) && selectedSpot.HourlySpot === 1 ? (
                                        <div className="modal modalscroll map-booking" style={{ display: 'block', backgroundColor: 'rgba(217, 217, 217, 0.59)' }}
                                            id="dateModal" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="dateModalLabel" aria-hidden="true"
                                        >
                                            <div className="modal-dialog modal-dialog-centered modal-custom-width">
                                                <div className="modal-content modal-radius">
                                                    <div className="modal-body">

                                                        <div className="close-modal">
                                                            <a>
                                                                <img src={Close} alt="Close" onClick={resetForm} />
                                                            </a>
                                                        </div>

                                                        <div className="pt-4">
                                                            <h5 className="popup-title">{t("react_calendar_new_booking")}</h5>
                                                        </div>

                                                        <div className="date-with-credit d-flex align-items-center justify-content-between pt-2">
                                                            <div id="selectedDate" className="selected-current-date">
                                                                <span>{dateforfullday}</span>
                                                                <span>{monthforfullday} {yearforfullday}</span>
                                                            </div>
                                                            {zoneCreditValue > 0 && (
                                                                <div className="credit-info">
                                                                    <a
                                                                        className="orange-outline-with-icon"
                                                                    >
                                                                        {CreditValueGrey ?
                                                                            (
                                                                                <>
                                                                                    <img src={GrayStar} alt="star" />
                                                                                    <span>{individualDayCost}</span>
                                                                                </>
                                                                            )
                                                                            :
                                                                            <>
                                                                                <img src={Images.OrangeStar} alt="" />
                                                                                <span>{Number(individualDayCost) > 0
                                                                                    ? `-${individualDayCost}`
                                                                                    : individualDayCost}</span>
                                                                            </>
                                                                        }
                                                                    </a>
                                                                </div>
                                                            )}
                                                        </div>

                                                        <form onSubmit={
                                                            // Submit_30mit
                                                            e => {
                                                                let errors = {};
                                                                if (!selectedSpot) {
                                                                    errors.spot = "Please select a spot.";
                                                                }
                                                                // if (HourlySpots && HourlySpots.length > 0 && !selectedSlot) {
                                                                //     errors.spot = "Please select a spot.";
                                                                // }
                                                                if (timeSlots && timeSlots.length > 0 && (!selectedFrom || !selectedTo)) {
                                                                    errors.timeselect = "Please select time slots.";
                                                                }
                                                                if (vehiclesForSpot && vehiclesForSpot.length > 0 && !selectedVehicle) {
                                                                    errors.vehicle = "Please select a vehicle.";
                                                                }
                                                                // Add more field checks as needed
                                                                if (Object.keys(errors).length > 0) {
                                                                    e.preventDefault();
                                                                    setRequiredFields(errors);
                                                                    return;
                                                                }
                                                                setRequiredFields({});
                                                                Submit_30mit(e)
                                                            }
                                                        }
                                                        >
                                                            <div className="divider-line mt-3"></div>
                                                            <div className="modal-des">
                                                                <div className="modal-scroll-inner me-4">
                                                                    <div className="icon-with-list mb-3">

                                                                        <div className="icon-wrap">
                                                                            <img src={Images.Participant} />
                                                                            <h4 className="ps-1 ms-1">{bookingModalParticipantName}</h4>
                                                                        </div>
                                                                    </div>
                                                                    <div className="form-row mb-3">
                                                                        <label className="popup-inner-title m-0">{t("date")}</label>
                                                                        <div className="date-input position-relative">
                                                                            {/* <DatePicker
                                                                                className="m-0 form-control"
                                                                                filterDate={(date) => !isHoliday(date)}
                                                                                dayClassName={(date) =>
                                                                                    isHoliday(date) ? "react-datepicker__day--holidayClass" : undefined
                                                                                }
                                                                                selected={
                                                                                    isSameMonthAndYear(getCalendarDate(), pickerMonth)
                                                                                        ? getCalendarDate()
                                                                                        : null
                                                                                }
                                                                                openToDate={pickerMonth}
                                                                                calendarClassName={
                                                                                    !isSameMonthAndYear(getCalendarDate(), pickerMonth)
                                                                                        ? "custom-date-picker-calendar datepicker-hide-keyboard-selection"
                                                                                        : "custom-date-picker-calendar"
                                                                                }
                                                                                onCalendarOpen={() => {
                                                                                    const currentPickerDate = getCalendarDate();
                                                                                    setPickerMonth(currentPickerDate || new Date());
                                                                                }}
                                                                                onMonthChange={(date) => {
                                                                                    setPickerMonth(date);
                                                                                }}
                                                                                onChange={(date) => {
                                                                                    if (!date) return;

                                                                                    const formatted = formatDate(date);
                                                                                    if (!formatted) {
                                                                                        console.warn("[30-minute calendar] Invalid DatePicker date", date);
                                                                                        return;
                                                                                    }

                                                                                    setStartDate(formatted);
                                                                                    setchangeddate(formatted);

                                                                                    // Only call loadEvents if meetingRoomData is valid
                                                                                    if (Array.isArray(meetingRoomData)) {
                                                                                        loadEvents(date);
                                                                                    } else {
                                                                                        console.warn("Cannot load events: meetingRoomData is not an array");
                                                                                    }

                                                                                    // Move calendar
                                                                                    const api = calendarRef.current?.getApi();
                                                                                    api?.gotoDate(date);
                                                                                }}
                                                                                shouldCloseOnSelect={true}
                                                                                minDate={new Date()}
                                                                            // maxDate={maxDate}
                                                                            dateFormat="dd/MM/yyyy"
                                                                                locale={{
                                                                                    localize: {
                                                                                        month: (n) => monthNames[n],
                                                                                        day: (n) => [t("sun"), t("mon"), t("tue"), t("wed"), t("thu"), t("fri"), t("sat")][n]
                                                                                    },
                                                                                    formatLong: {
                                                                                        date: () => "dd MMMM"
                                                                                    }
                                                                                }}
                                                                            /> */}
                                                                            <CustomDatePicker
                                                                                className="m-0 form-control"

                                                                                // Keep previous selected date visible
                                                                                preventMonthAutoSelect={true}

                                                                                // Holiday disable
                                                                                filterDate={(date) => !isHoliday(date)}

                                                                                // Holiday class
                                                                                dayClassName={(date) =>
                                                                                    isHoliday(date)
                                                                                        ? "react-datepicker__day--holidayClass"
                                                                                        : undefined
                                                                                }

                                                                                // Selected date
                                                                                selected={getCalendarDate()}

                                                                                // Month to open
                                                                                openToDate={pickerMonth}

                                                                                // Calendar class
                                                                                calendarClassName={
                                                                                    !isSameMonthAndYear(getCalendarDate(), pickerMonth)
                                                                                        ? "custom-date-picker-calendar datepicker-hide-keyboard-selection"
                                                                                        : "custom-date-picker-calendar"
                                                                                }

                                                                                // On calendar open
                                                                                onCalendarOpen={() => {
                                                                                    const currentPickerDate = getCalendarDate();
                                                                                    setPickerMonth(currentPickerDate || new Date());
                                                                                }}

                                                                                // On month change
                                                                                onMonthChange={(date) => {
                                                                                    setPickerMonth(date);
                                                                                }}

                                                                                // On date change
                                                                                onChange={(date) => {
                                                                                    if (!date) return;

                                                                                    const formatted = formatDate(date);

                                                                                    if (!formatted) {
                                                                                        console.warn(
                                                                                            "[30-minute calendar] Invalid DatePicker date",
                                                                                            date
                                                                                        );
                                                                                        return;
                                                                                    }

                                                                                    setStartDate(formatted);
                                                                                    setchangeddate(formatted);

                                                                                    // Only call loadEvents if meetingRoomData is valid
                                                                                    if (Array.isArray(meetingRoomData)) {
                                                                                        loadEvents(date);
                                                                                    } else {
                                                                                        console.warn(
                                                                                            "Cannot load events: meetingRoomData is not an array"
                                                                                        );
                                                                                    }

                                                                                    // Move full calendar
                                                                                    const api = calendarRef.current?.getApi();
                                                                                    api?.gotoDate(date);
                                                                                }}

                                                                                shouldCloseOnSelect={true}

                                                                                // Minimum selectable date
                                                                                minDate={new Date()}

                                                                                // Optional max date
                                                                                // maxDate={maxDate}

                                                                                // Disable condition
                                                                                disabled={isThirtyMinuteModalReadOnly}

                                                                                // Date format
                                                                                dateFormat="dd/MM/yyyy"

                                                                                // Locale
                                                                                locale={{
                                                                                    localize: {
                                                                                        month: (n) => monthNames[n],
                                                                                        day: (n) =>
                                                                                            [
                                                                                                t("sun"),
                                                                                                t("mon"),
                                                                                                t("tue"),
                                                                                                t("wed"),
                                                                                                t("thu"),
                                                                                                t("fri"),
                                                                                                t("sat"),
                                                                                            ][n],
                                                                                    },
                                                                                    formatLong: {
                                                                                        date: () => "dd MMMM",
                                                                                    },
                                                                                }}
                                                                            />
                                                                        </div>
                                                                    </div>

                                                                    <div className="form-row mb-3">
                                                                        <label className="popup-inner-title m-0">{t("spot")}</label>
                                                                        <div className="custom-dropdown modal-dropdown mb-3" style={{ position: "relative" }}>
                                                                            <CustomSearchableDropdown
                                                                                items={hourlySpotDropdownOptions
                                                                                    .map((spot) => ({
                                                                                        label: spot.SpotName,
                                                                                        value: spot.SpotName,
                                                                                    }))}
                                                                                value={selectedSpot?.SpotName || firstAvailableHourlySpot?.SpotName || ""}
                                                                                labelKey="label"
                                                                                valueKey="value"
                                                                                searchable={false}
                                                                                placeholder={t("spot")}
                                                                                // disabled={isHourlyRoomSelectionDisabled}
                                                                                onChange={(val) => {
                                                                                    const chosenSpot = hourlySpotDropdownOptions.find(
                                                                                        (spot) => spot.SpotName === val
                                                                                    );
                                                                                    if (chosenSpot) {
                                                                                        setSelectedSpot(chosenSpot);
                                                                                        MeetingRoomListInfo(chosenSpot);
                                                                                    }
                                                                                }}
                                                                            />
                                                                        </div>
                                                                    </div>

                                                                    {/* FullCalendar preview and time slot UI (same pattern as meeting room) */}
                                                                    <div className="form-row mb-3">
                                                                        <label className="popup-inner-title m-0">{t("react_preview_time_slot")}</label>
                                                                        <div
                                                                            style={{
                                                                                maxHeight: "400px",
                                                                                overflowY: "auto",
                                                                                background: "#fff",
                                                                                // opacity: shouldDisableThirtyMinuteCalendar ? 0.5 : 1,
                                                                                // pointerEvents: shouldDisableThirtyMinuteCalendar ? "none" : "auto",
                                                                                // border: "1px solid #ddd",
                                                                                // borderRadius: "8px",
                                                                                // padding: "4px",
                                                                            }}
                                                                        >
                                                                            {/* <FullCalendar
                                                                                ref={calendarRef}
                                                                                plugins={[timeGridPlugin, interactionPlugin]}
                                                                                initialView="timeGridDay"
                                                                                initialDate={changeddate}
                                                                                height="auto"
                                                                                headerToolbar={false}
                                                                                nowIndicator={true}
                                                                                allDaySlot={false}
                                                                                slotMinTime={timeIntervals.start}
                                                                                slotMaxTime={timeIntervals.end}
                                                                                selectable={!shouldDisableThirtyMinuteCalendar}
                                                                                dayHeaderFormat={false}
                                                                                dayHeaders={false}
                                                                                events={events}
                                                                                selectAllow={(selectInfo) => {
                                                                                    const selectedStart = selectInfo.start;
                                                                                    const selectedEnd = selectInfo.end;
                                                                                    const now = new Date();
                                                                                    if (selectedStart < now) return false;

                                                                                    const isOverlapping = events.some((event) => {
                                                                                        const eventStart = new Date(event.start);
                                                                                        const eventEnd = new Date(event.end);
                                                                                        return (
                                                                                            (selectedStart >= eventStart && selectedStart < eventEnd) ||
                                                                                            (selectedEnd > eventStart && selectedEnd <= eventEnd) ||
                                                                                            (selectedStart <= eventStart && selectedEnd >= eventEnd)
                                                                                        );
                                                                                    });
                                                                                    return !isOverlapping;
                                                                                }}
                                                                                select={(info) => {
                                                                                    const from = info.start.toTimeString().slice(0, 5);
                                                                                    const to = info.end.toTimeString().slice(0, 5);
                                                                                    setSelectedFrom(from);
                                                                                    setSelectedTo(to);
                                                                                }}
                                                                                slotLabelFormat={{ hour: '2-digit', minute: '2-digit', hour12: false }}
                                                                                eventTimeFormat={{ hour: '2-digit', minute: '2-digit', hour12: false }}
                                                                            /> */}
                                                                            <FullCalendar
                                                                                ref={calendarRef}
                                                                                plugins={[timeGridPlugin, interactionPlugin]}
                                                                                initialView="timeGridDay"
                                                                                initialDate={getCalendarDateString()}
                                                                                height="auto"
                                                                                headerToolbar={false}
                                                                                nowIndicator={true}
                                                                                allDaySlot={false}
                                                                                slotMinTime={timeIntervals.start}
                                                                                slotMaxTime={timeIntervals.end}
                                                                                selectable={true}
                                                                                dayHeaderFormat={false}
                                                                                dayHeaders={false}
                                                                                events={events}

                                                                                // ✅ UI: Disable past slots visually
                                                                                slotLaneDidMount={(arg) => {
                                                                                    const now = new Date();

                                                                                    const slotStart = new Date(arg.date);
                                                                                    const slotEnd = new Date(slotStart);
                                                                                    slotEnd.setMinutes(slotEnd.getMinutes() + 30); // match slot duration

                                                                                    if (slotEnd <= now) {
                                                                                        arg.el.style.pointerEvents = "none";
                                                                                        arg.el.style.opacity = "0.5";
                                                                                        arg.el.style.cursor = "not-allowed";
                                                                                    }
                                                                                }}

                                                                                // ✅ Logic: Allow until slot ends
                                                                                selectAllow={(selectInfo) => {
                                                                                    if (shouldDisableThirtyMinuteCalendar) return false;

                                                                                    const selectedStart = selectInfo.start;
                                                                                    const selectedEnd = selectInfo.end;
                                                                                    const hasBlockedOverlap = hasBlockedBookingOverlap(selectedStart, selectedEnd);

                                                                                    // ✅ Overlap check
                                                                                    const isOverlapping = events.some((event) => {
                                                                                        const eventStart = new Date(event.start);
                                                                                        const eventEnd = new Date(event.end);

                                                                                        return (
                                                                                            (selectedStart >= eventStart && selectedStart < eventEnd) ||
                                                                                            (selectedEnd > eventStart && selectedEnd <= eventEnd) ||
                                                                                            (selectedStart <= eventStart && selectedEnd >= eventEnd)
                                                                                        );
                                                                                    });

                                                                                    return !isOverlapping && !hasBlockedOverlap;
                                                                                }}

                                                                                select={(info) => {
                                                                                    if (shouldDisableThirtyMinuteCalendar) return;

                                                                                    const from = info.start.toTimeString().slice(0, 5);
                                                                                    const to = info.end.toTimeString().slice(0, 5);
                                                                                    setSelectedFrom(from);
                                                                                    setSelectedTo(to);
                                                                                }}

                                                                                slotLabelFormat={{ hour: '2-digit', minute: '2-digit', hour12: false }}
                                                                                eventTimeFormat={{ hour: '2-digit', minute: '2-digit', hour12: false }}
                                                                                viewDidMount={() => {
                                                                                    setTimeout(() => {
                                                                                        const calendarApi = calendarRef.current?.getApi();
                                                                                        const calendarEl = calendarApi?.el;

                                                                                        if (!calendarEl) return;

                                                                                        const slots = calendarEl.querySelectorAll(".fc-timegrid-slot");
                                                                                        const blockedSlots = getBlockedBookingSlots();

                                                                                        slots.forEach((slot) => {
                                                                                            const time = slot.getAttribute("data-time");
                                                                                            if (!time) return;

                                                                                            const slotStartLabel = time.slice(0, 5);
                                                                                            const slotStart = new Date(`${changeddate}T${time}`);
                                                                                            const slotEnd = new Date(slotStart);
                                                                                            slotEnd.setMinutes(slotEnd.getMinutes() + 30);
                                                                                            const slotEndLabel = slotEnd.toTimeString().slice(0, 5);
                                                                                            const normalizedSlot = normalizeBlockedSlot(`${slotStartLabel}-${slotEndLabel}`);

                                                                                            if (blockedSlots.includes(normalizedSlot)) {
                                                                                                slot.classList.add("disabled");
                                                                                                slot.classList.add("disabled");
                                                                                                slot.parentElement?.classList.add("disabled");
                                                                                            } else {
                                                                                                slot.classList.remove("disabled");
                                                                                                slot.classList.remove("disabled");
                                                                                                slot.parentElement?.classList.remove("disabled");
                                                                                            }
                                                                                        });
                                                                                    }, 0);
                                                                                }}
                                                                            />
                                                                        </div>
                                                                    </div>

                                                                    <div className="custom-timepicker pt-1">
                                                                        <h6 className="popup-inner-title">{t("react_select_time")}</h6>
                                                                        <div className="mb-3" onClick={handleToggleSlots} id="selectedBox">
                                                                            {/* <div>
                                                                                <label>{t("from")}</label>
                                                                                <span>{selectedFrom}</span>
                                                                            </div>
                                                                            <div><img src={Images.Vector} alt="" /></div>
                                                                            <div>
                                                                                <label>{t("react_to")}</label>
                                                                                <span>{selectedTo}</span>
                                                                            </div> */}
                                                                            <div className="time-selection">
                                                                                <div className="row">
                                                                                    <div className="col-md-6 rightArrow">
                                                                                        <div className="time-alignment pl20">
                                                                                            <label>{t("from")}</label>
                                                                                            <input
                                                                                                type="text"
                                                                                                readOnly
                                                                                                value={selectedFrom === "00:00" ? "" : selectedFrom}
                                                                                                placeholder="00:00"
                                                                                            />
                                                                                        </div>
                                                                                    </div>

                                                                                    <div className="col-md-6">
                                                                                        <div className="time-alignment pl40">
                                                                                            <label>{t("react_to")}</label>
                                                                                            <input
                                                                                                type="text"
                                                                                                readOnly
                                                                                                value={selectedTo === "00:00" ? "" : selectedTo}
                                                                                                placeholder="00:00"
                                                                                            />
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>

                                                                        {/* {showSlots && (
                                                                            <div className="slot-container d-flex flex-wrap gap-2 mb-3">
                                                                                {timeSlots.map((slot, idx) => {
                                                                                    const [start, end] = slot.split("-");
                                                                                    const slotEnd = new Date(`${formatDate(changeddate)}T${end}:00`);
                                                                                    const now = new Date();
                                                                                    const isPast = slotEnd <= now;
                                                                                    const isBooked = isSlotBooked(start, end);
                                                                                    const isDisabled = isPast || isBooked;
                                                                                    const isSelected = slot === `${selectedFrom}-${selectedTo}`;
                                                                                    return (
                                                                                        <div key={idx} className={`slot p-2 border rounded text-center ${isDisabled
                                                                                         ? "bg-secondary text-white" 
                                                                                         : isSelected ? 
                                                                                         "bg-success text-white" 
                                                                                         : "bg-light"
                                                                                         }`} 
                                                                                         style={{ 
                                                                                            cursor: isDisabled ? "not-allowed" : "pointer", 
                                                                                            opacity: isDisabled ? 0.6 : 1 
                                                                                            }} 
                                                                                            onClick={() => !isDisabled && handleSlotClick(slot)}>
                                                                                            {slot}
                                                                                        </div>
                                                                                    );
                                                                                })}
                                                                            </div>
                                                                        )} */}
                                                                        {showSlots && (
                                                                            <div className="slot-container d-grid mb-3">
                                                                                {timeSlots.map((slot, idx) => {
                                                                                    const [start, end] = slot.split("-");
                                                                                    const isBooked = isSlotBooked(start, end);
                                                                                    const isBlocked = getBlockedBookingSlots().includes(
                                                                                        normalizeBlockedSlot(slot)
                                                                                    );
                                                                                    const isDisabled = isBooked || isBlocked;
                                                                                    // const isSelected = slot === `${selectedFrom}-${selectedTo}`;
                                                                                    const isSelected =
                                                                                        selectedFrom &&
                                                                                        selectedTo &&
                                                                                        slotOverlapsRange(start, end, selectedFrom, selectedTo);

                                                                                    return (
                                                                                        <div
                                                                                            key={idx}
                                                                                            className={`slot ${isBlocked || isBooked ? "disabled" : isSelected ? "active" : ""
                                                                                                }`}
                                                                                            onClick={() => !isBooked && !isBlocked && handleSlotClick(slot)}
                                                                                        >
                                                                                            {slot}
                                                                                        </div>
                                                                                    );
                                                                                })}
                                                                            </div>
                                                                        )}

                                                                        {requiredFields.timeselect && (
                                                                            <div style={{ color: 'red', marginTop: 8, fontSize: 14 }}>
                                                                                {requiredFields.timeselect}
                                                                            </div>
                                                                        )}
                                                                    </div>

                                                                    {GuestParticipants.length > 0 && (
                                                                        <div className="mt-3">
                                                                            <h6 className="popup-inner-title">Guest List:</h6>
                                                                            <ul className="list-group">
                                                                                {GuestParticipants.map((guest, index) => (
                                                                                    <li
                                                                                        key={guest.Id}
                                                                                        className="list-group-item d-flex justify-content-between align-items-center"
                                                                                    >
                                                                                        {guest.FirstName} {guest.LastName} ({guest.PrimaryEmail})
                                                                                        <button
                                                                                            type="button"
                                                                                            className="btn btn-sm btn-danger"
                                                                                            onClick={() => handleRemoveGuest(index)}
                                                                                        >
                                                                                            {t("remove")}
                                                                                        </button>
                                                                                    </li>
                                                                                ))}
                                                                            </ul>
                                                                        </div>
                                                                    )}

                                                                    {vehiclesForSpot.length > 0 && (
                                                                        <div className="custom-dropdown modal-dropdown mb-3">
                                                                            <CustomSearchableDropdown
                                                                                items={vehiclesForSpot}
                                                                                // The current selected ID
                                                                                value={selectedVehiclePrimaryKey}
                                                                                // The key from your data to show in the list (Registration ID)
                                                                                labelKey="VehicleRegistrationId"
                                                                                // The key from your data used as the unique ID
                                                                                valueKey="VehiclePrimaryKey"
                                                                                searchable={false}
                                                                                placeholder="Select Vehicle"
                                                                                disabled={!vehiclesForSpot.length}
                                                                                onChange={(pk) => {
                                                                                    // 1. Update the Primary Key state
                                                                                    setSelectedVehiclePrimaryKey(pk);

                                                                                    // 2. Find the full vehicle object and update it
                                                                                    const vehicleObj = vehiclesForSpot.find(v => v.VehiclePrimaryKey === pk);
                                                                                    setSelectedVehicle(vehicleObj);

                                                                                    // 3. Close the validation error for 'vehicle'
                                                                                    setRequiredFields(prev => ({
                                                                                        ...prev,
                                                                                        vehicle: ""
                                                                                    }));

                                                                                    // Optional: Debugging logs
                                                                                    if (vehicleObj) {
                                                                                        console.log("Vehicle Selected:", vehicleObj.VehicleRegistrationId);
                                                                                        console.log("PK:", pk);
                                                                                    }
                                                                                }}
                                                                            />
                                                                        </div>
                                                                    )
                                                                    }

                                                                    {/* {vehiclesForSpot.length > 0 && (
                                                                        <div
                                                                            className=""
                                                                            style={{ position: "relative" }}
                                                                        >
                                                                            <label htmlFor=""></label>
                                                                            <div
                                                                                role="button"
                                                                                onClick={() => setVehicleOpen(!vehicleOpen)}
                                                                                className="dropdown-toggle form-control position-relative custom-dropdown-btn ctm-select"
                                                                                style={{
                                                                                    display: "flex",
                                                                                    justifyContent: "space-between",
                                                                                    cursor: "pointer",
                                                                                }}
                                                                            >

                                                                                <div className="d-flex flex-column">
                                                                                    <p className="sub-dropdown-name">Vehicle</p>
                                                                                    <span
                                                                                        style={{
                                                                                            fontSize: "16px",
                                                                                            fontWeight: "bold",
                                                                                            color: "#1c988a",
                                                                                        }}
                                                                                    >
                                                                                        {selectedVehicle?.VehicleRegistrationId || vehiclesForSpot[0]?.VehicleRegistrationId}
                                                                                    </span>
                                                                                </div>
                                                                            </div>

                                                                            {vehicleOpen && (
                                                                                <div
                                                                                    style={{
                                                                                        position: "absolute",
                                                                                        top: "calc(100% + 6px)",
                                                                                        left: 0,
                                                                                        width: "100%",
                                                                                        background: "#fff",
                                                                                        borderRadius: 12,
                                                                                        boxShadow: "0 10px 30px rgba(0,0,0,.15)",
                                                                                        maxHeight: 300,
                                                                                        overflowY: "auto",
                                                                                        zIndex: 9999,
                                                                                    }}
                                                                                >
                                                                                    {vehiclesForSpot.map((v) => (
                                                                                        <div
                                                                                            key={v.VehiclePrimaryKey}
                                                                                            onClick={() => {
                                                                                                const pk = v.VehiclePrimaryKey;

                                                                                                setSelectedVehiclePrimaryKey(pk);
                                                                                                setSelectedVehicle(v);
                                                                                                setVehicleOpen(false);

                                                                                                setRequiredFields(prev => ({
                                                                                                    ...prev,
                                                                                                    vehicle: ""
                                                                                                }));

                                                                                                console.log("Spot +++++:", selectedSpot?.SpotName);
                                                                                                console.log("Registration +++++:", v.VehicleRegistrationId);
                                                                                                console.log("FuelId: ++++", v.FuelId);
                                                                                                console.log("VehiclePrimaryKey +++++++:", v.VehiclePrimaryKey);
                                                                                            }}
                                                                                            style={{
                                                                                                padding: "8px 12px",
                                                                                                display: "flex",
                                                                                                alignItems: "center",
                                                                                                cursor: "pointer",
                                                                                            }}
                                                                                        >
                                                                                            <input
                                                                                                type="radio"
                                                                                                checked={selectedVehiclePrimaryKey === v.VehiclePrimaryKey}
                                                                                                readOnly
                                                                                                style={{
                                                                                                    marginRight: 8,
                                                                                                    accentColor: "#1c988a",
                                                                                                }}
                                                                                            />
                                                                                            <span>{v.VehicleRegistrationId}</span>
                                                                                        </div>
                                                                                    ))}
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    )} */}

                                                                    {requiredFields.vehicle && (
                                                                        <div style={{ color: 'red', marginTop: 8, fontSize: 14 }}>{requiredFields.vehicle}</div>
                                                                    )}

                                                                    <div className="participants-list ctm-checklist">
                                                                        {!!preBookinQueCanvas && (
                                                                            <div className="form-check">
                                                                                <input
                                                                                    className="form-check-input"
                                                                                    type="checkbox"
                                                                                    id={`preBookinQueCanvas`}
                                                                                    checked={checkedPreBookingQue}
                                                                                    onChange={(e) => setCheckedPreBookingQue(e.target.checked)}
                                                                                />

                                                                                <label
                                                                                    className="form-check-label ms-2"
                                                                                    htmlFor={`preBookinQueCanvas`}
                                                                                >
                                                                                    <span dangerouslySetInnerHTML={{ __html: safeHtml }} />

                                                                                </label>
                                                                            </div>
                                                                        )}
                                                                    </div>

                                                                    {selectedParticipants.length > 0 && (
                                                                        <div className="mt-3">
                                                                            <h6 className="popup-inner-title">{t("selected_participants")}</h6>
                                                                            <ul className="list-group">
                                                                                {selectedParticipants.map((participant, index) => (
                                                                                    <li
                                                                                        key={participant.Id}
                                                                                        className="list-group-item d-flex justify-content-between align-items-center"
                                                                                    >
                                                                                        {participant.FirstName} {participant.LastName} ({participant.PrimaryEmail})
                                                                                        <button
                                                                                            type="button"
                                                                                            className="btn btn-sm btn-danger"
                                                                                            onClick={() =>
                                                                                                setSelectedParticipants((prev) =>
                                                                                                    prev.filter((_, i) => i !== index)
                                                                                                )
                                                                                            }
                                                                                        >
                                                                                            {t("remove")}
                                                                                        </button>
                                                                                    </li>
                                                                                ))}
                                                                            </ul>
                                                                        </div>
                                                                    )}

                                                                    {/* <div className="form-row">
                                                                        <label className="popup-inner-title m-0">Meeting Name</label>
                                                                        <input type="text" name="meetingName" value={meetingName} onChange={(e) => setMeetingName(e.target.value)} className="form-control" />
                                                                    </div>

                                                                    <div className="tags-btn me-4 mt-3">
                                                                        <button type="submit" className="w-100 min-height-56" disabled={loading}>
                                                                            <span>{loading ? "Booking..." : "Confirm"}</span>
                                                                        </button>
                                                                    </div> */}

                                                                    {/* {Number(timeIntervals.RepeatOptionByLiftRestriction) === 0 && (
                                                        <div className="form-row">
                                                            <label className="popup-inner-title m-0">Repeat</label>
                                                            <select className="form-select" value={repeatType} onChange={(e) => { setRepeatType(e.target.value); setEndDate(null); setWeeklyRepeatOption([]); }}>
                                                                <option value={0}>No Repeat</option>
                                                                <option value="1">Daily</option>
                                                                <option value="2">Weekly</option>
                                                                <option value="4">BiWeekly</option>
                                                                <option value="3">Monthly</option>
                                                            </select>
                                                        </div>
                                                    )}

                                                    <div>
                                                        <input type="text" className="form-control mb-2" placeholder="Search by name or email..." value={searchText} onChange={(e) => setSearchText(e.target.value)} />
                                                        <select className="form-control" onChange={(e) => handleAddParticipant(e.target.value)}>
                                                            <option value="">Select Participant</option>
                                                            {participantsList.filter((p) => (p.FirstName + " " + p.LastName + " " + p.PrimaryEmail).toLowerCase().includes(searchText.toLowerCase())).map((p) => (
                                                                <option key={p.Id} value={JSON.stringify(p)}>{p.FirstName} {p.LastName} ({p.PrimaryEmail})</option>
                                                            ))}
                                                        </select>
                                                    </div>

                                                    <div className="tags-btn me-4 mt-3">
                                                        <button type="submit" className="w-100 min-height-56" disabled={loading}>
                                                            <span>{loading ? "Booking..." : "Confirm"}</span>
                                                        </button>
                                                    </div> */}
                                                                </div>
                                                            </div>
                                                            {/* <div className="tags-btn me-4 mt-3">
                                                                    <button type="submit" className="w-100 min-height-56 selected" disabled={loading}>
                                                                        <span>{loading ? <div id='preloader'>
                                                                            <img src={LoaderFull} alt="Loading" />
                                                                        </div> : "Confirm"}</span>
                                                                    </button>
                                                                </div> */}
                                                            <div className="tags-btn me-4 mt-3">
                                                                <button
                                                                    type="submit"
                                                                    className="w-100 min-height-56 selected"
                                                                    // Button is disabled if:
                                                                    // 1. Loading is true
                                                                    // 2. OR (The question exists AND it is NOT checked)
                                                                    disabled={loading || (!!preBookinQueCanvas && !checkedPreBookingQue)}
                                                                    style={{
                                                                        // Optional: add a visual cue for disabled state
                                                                        opacity: (loading || (!!preBookinQueCanvas && !checkedPreBookingQue)) ? 0.5 : 1,
                                                                        cursor: (loading || (!!preBookinQueCanvas && !checkedPreBookingQue)) ? "not-allowed" : "pointer"
                                                                    }}
                                                                >
                                                                    {loading ? (
                                                                        <div id='preloader'>
                                                                            <img src={LoaderFull} alt="Loading" />
                                                                        </div>
                                                                    ) : (
                                                                        <div>
                                                                            {t("confirm")}
                                                                        </div>
                                                                        // "Confirm"
                                                                    )}
                                                                </button>
                                                            </div>
                                                        </form>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ) : (
                                        <p>Spot information not configured for booking.</p>
                                    )}
                    {/* </ModalContent> */}
                </div>
            )}

            {showCancelModal && selectedSpot && (
                <div>
                    {/* <ModalContent> */}
                    {
                        <div>
                            <div className="modal modalscroll" style={{ display: 'block', backgroundColor: 'rgba(217, 217, 217, 0.59)' }}
                                id="dateModal" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="dateModalLabel" aria-hidden="true"
                            >
                                <div className="modal-dialog modal-dialog-centered modal-custom-width">
                                    <div className="modal-content modal-radius">
                                        <div className="modal-body">
                                            <div className="close-modal">
                                                <a>
                                                    <img src={Close} aria-label="Close" onClick={resetForm} />
                                                </a>
                                            </div>
                                            <div className="pt-4">
                                                <h5 className="popup-title">{assignTitle}</h5>

                                            </div>
                                            <div className="date-with-credit d-flex align-items-center justify-content-between pt-2">
                                                <div id="selectedDate" className="selected-current-date">
                                                    <span>{dateforfullday}</span>
                                                    <span>{monthforfullday} {yearforfullday}</span>
                                                </div>
                                                {zoneCreditValue > 0 && (
                                                    <div className="credit-info">
                                                        {/* {creditInfoJSX} */}
                                                        {/* <div className="date-with-credit d-flex align-items-start justify-content-end pe-3">
                                                                <a
                                                                    className="orange-outline-with-icon"
                                                                >
                                                                    {CreditValueGrey ? <img src={GrayStar} alt="star" /> :
                                                                        CreditValueAdd ? "+" : ""
                                                                    }
                                                                    <span>{individualDayCost}</span>
                                                                </a>
                                                            </div> */}
                                                        <a
                                                            className="orange-outline-with-icon"
                                                        >
                                                            {isZeroDisplayCredit ? (
                                                                <>
                                                                    <img src={GrayStar} alt="star" />
                                                                    <span>{displayCreditValue}</span>
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <img src={Images.OrangeStar} alt="" />
                                                                    <span>
                                                                        {`+${displayCreditValue}`}
                                                                    </span>
                                                                </>
                                                            )}
                                                            {/* {CreditValueGrey ?
                                                                        (
                                                                            <>
                                                                                <img src={GrayStar} alt="star" />
                                                                                <span>{individualDayCost}</span>
                                                                            </>
                                                                        )
                                                                        :
                                                                        <>
                                                                            <img src={Images.OrangeStar} alt="" />
                                                                            <span>
                                                                                {Number(individualDayCost) > 0
                                                                                    ? `+${individualDayCost}`
                                                                                    : individualDayCost}
                                                                            </span>
                                                                        </>
                                                                    } */}
                                                        </a>
                                                    </div>
                                                )}
                                            </div>

                                            <div className="divider-line mt-3"></div>
                                            <div className="modal-des">
                                                <div className="modal-scroll-inner me-4">
                                                    <div className="icon-with-list mb-3">
                                                        <div className="icon-wrap">
                                                            <img src={Images.Map} alt="map" />
                                                            <h4 className="ps-1 ms-1">{selectedZone.ZoneName}</h4>
                                                        </div>
                                                        {/* All day booking  */}
                                                        <div className="icon-wrap">
                                                            <img src={Images.TimeIcon} alt="repeat" />
                                                            <h4 className="ps-1 ms-1">
                                                                {t("all_day")} <span> {formatDateToEEEddMMM(bookingDate)}</span>
                                                            </h4>
                                                        </div>

                                                        <div className="icon-wrap">
                                                            <img src={Images.Participant} />
                                                            <h4 className="ps-1 ms-1">{bookingModalParticipantName}</h4>
                                                        </div>
                                                    </div>
                                                    {/* <div className="modal-body">
                                                    <p>Are you sure you want to cancel the booking for spot <b>{selectedSpot.SpotName}</b>?</p>
                                                </div> */}

                                                    <div className="modal-tag">
                                                        {selectedSpot.SpotTagList && selectedSpot.SpotTagList.length > 0 && (
                                                            <div className="modal-tag">
                                                                <button
                                                                    type="button"
                                                                    id="show-tag-tab"
                                                                    className={showTags ? "active" : ""}
                                                                    onClick={() => setShowTags(!showTags)} // Toggle the state on click
                                                                >
                                                                    <img src={Images.ModalTag} className="img-fluid" alt="Tags" />
                                                                    <span className="show-link">{t("show_tags")}</span>
                                                                    <span className="hide-link">{t("react_hide_tags")}</span>
                                                                    {/* {showTags ? 'Hide Tags' : 'Show Tags'} */}
                                                                </button>
                                                            </div>
                                                        )}
                                                        {/* </div> */}

                                                        {/* 2. Conditionally display the Spot Tags list */}
                                                        {showTags && selectedSpot.SpotTagList && (
                                                            <div id="all-tags" className={showTags ? "show" : ""}>
                                                                {selectedSpot.SpotTagList.map((tag, index) => (
                                                                    <button type="button" key={index}>
                                                                        {tag.TagName}
                                                                    </button>
                                                                ))}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>

                                            {checkInBtn && <CheckInButton onClick={() => {
                                                // setShowCancelModal(false);
                                                CheckInOutAPI(selectedZone?.Id || (selectedSpot && selectedSpot.ZoneId) || 0,
                                                    bookingDate || (selectedSpot && selectedSpot.BookingDate) || formatDate(new Date()),
                                                    selectedSpot?.SpotId || 0, checkInFlag);
                                            }} />}

                                            {checkOutBtn && <CheckOutButton onClick={() => {
                                                // setShowCancelModal(false);
                                                CheckOutAPI(selectedZone?.Id || (selectedSpot && selectedSpot.ZoneId) || 0,
                                                    bookingDate || (selectedSpot && selectedSpot.BookingDate) || formatDate(new Date()),
                                                    selectedSpot?.SpotId || 0, checkInFlag);
                                            }} />}


                                            <div className="me-4 mt-3">
                                                {/* <button type="button" className="btn btn-secondary" onClick={() => setShowCancelModal(false)}>
                                                Close
                                            </button> */}
                                                <button type="button" className="w-100 min-height-56 main-btn cancel-btn" onClick={() => {
                                                    // Call your cancel API here
                                                    setShowCancelModal(false);
                                                    // Fix: Ensure variables are defined before calling CancelBooking
                                                    CancelBooking(
                                                        selectedZone?.Id || (selectedSpot && selectedSpot.ZoneId) || 0,
                                                        bookingDate || (selectedSpot && selectedSpot.BookingDate) || formatDate(new Date()),
                                                        selectedSpot?.SpotId || 0
                                                    );
                                                }}>
                                                    {/* <img src={closeIcon} alt="" /> */}
                                                    <span> {t("cancel_booking")} </span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    {/* </ModalContent> */}
                </div>
            )}

            {showCancelModalfor30mit && selectedSpot && (
                <div>
                    {/* <ModalContent> */}
                    {
                        <div>
                            <div className="modal modalscroll" style={{ display: 'block', backgroundColor: 'rgba(217, 217, 217, 0.59)' }}
                                id="dateModal" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="dateModalLabel" aria-hidden="true"
                            >
                                <div className="modal-dialog modal-dialog-centered modal-custom-width">
                                    <div className="modal-content modal-radius">
                                        <div className="modal-body">
                                            <div className="close-modal">
                                                <a >
                                                    <img src={Close} aria-label="Close" onClick={resetForm} />
                                                </a>
                                            </div>
                                            <div className="pt-4">
                                                {/* <h5 className="popup-title">{t("react_manage_booking_for")} {selectedSpot.SpotName}</h5> */}
                                                <h5 className="popup-title">{assignTitle}</h5>
                                            </div>
                                            <div className="date-with-credit d-flex align-items-center justify-content-between pt-2">
                                                <div id="selectedDate" className="selected-current-date">
                                                    <span>{dateforfullday}</span>
                                                    <span>{monthforfullday} {yearforfullday}</span>
                                                </div>
                                                {zoneCreditValue > 0 && (
                                                    <div className="credit-info">
                                                        {/* {creditInfoJSX} */}
                                                        <a
                                                            className="orange-outline-with-icon"
                                                        >
                                                            {isZeroDisplayCredit ? (
                                                                <>
                                                                    <img src={GrayStar} alt="star" className="img-fluid" />
                                                                    <span>{displayCreditValue}</span>
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <img src={Images.OrangeStar} alt="star" className="img-fluid" />
                                                                    <span>
                                                                        {`+${displayCreditValue}`}
                                                                    </span>
                                                                </>
                                                            )}
                                                            {/* {CreditValueGrey ?
                                                                    (
                                                                        <>
                                                                            <img src={GrayStar} alt="star" />
                                                                            <span>{individualDayCost}</span>
                                                                        </>
                                                                    )
                                                                    :
                                                                    <>
                                                                        <img src={Images.OrangeStar} alt="" />
                                                                        
                                                                    <span>
                                                                        {Number(individualDayCost) > 0
                                                                            ? `+${individualDayCost}`
                                                                            : individualDayCost}
                                                                    </span>
                                                                    </>
                                                                } */}
                                                        </a>
                                                    </div>
                                                )}
                                            </div>

                                            <div className="divider-line mt-3"></div>
                                            {/* <div className="modal-body">
                                                <p>Are you sure you want to cancel the booking for spot <b>{selectedSpot.SpotName}</b>?</p>
                                            </div> */}
                                            <div className="modal-des">
                                                <div className="modal-scroll-inner me-4">
                                                    {/* Zone name */}

                                                    <div className="icon-with-list mb-3">
                                                        <div className="icon-wrap">
                                                            <img src={Images.Map} alt="map" />
                                                            <h4 className="ps-1 ms-1">{selectedZone.ZoneName}</h4>
                                                        </div>
                                                        {/* All day booking  */}
                                                        <div className="icon-wrap">
                                                            <img src={Images.CalendarMenu} alt="repeat" />
                                                            <h4 className="ps-1 ms-1">
                                                                {/* {t("all_day")}  */}
                                                                <span> {formatDateToEEEddMMM(bookingDate)} </span>
                                                            </h4>
                                                        </div>

                                                        <div className="icon-wrap">
                                                            <img src={Images.Participant} />
                                                            <h4 className="ps-1 ms-1">{bookingModalParticipantName}</h4>
                                                        </div>
                                                    </div>
                                                    {selectedSpot.SpotTagList && selectedSpot.SpotTagList.length > 0 && (
                                                        <div className="modal-tag">
                                                            <button
                                                                type="button"
                                                                id="show-tag-tab"
                                                                className={showTags ? "active" : ""}
                                                                onClick={() => setShowTags(!showTags)} // Toggle the state on click
                                                            >
                                                                <img src={Images.ModalTag} className="img-fluid" alt="Tags" />
                                                                <span className="show-link">{t("show_tags")}</span>
                                                                <span className="hide-link">{t("react_hide_tags")}</span>
                                                                {/* {showTags ? 'Hide Tags' : 'Show Tags'} */}
                                                            </button>
                                                        </div>
                                                    )}
                                                    {/* </div> */}

                                                    {/* 2. Conditionally display the Spot Tags list */}
                                                    {showTags && selectedSpot.SpotTagList && (
                                                        <div id="all-tags" className={showTags ? "show" : ""}>
                                                            {selectedSpot.SpotTagList.map((tag, index) => (
                                                                <button type="button" key={index}>
                                                                    {tag.TagName}
                                                                </button>
                                                            ))}
                                                        </div>
                                                    )}

                                                    {isThirtyMinuteModalReadOnly && (
                                                        <div className="modal-info-box mb-3">
                                                            {/* {t("react_no_space_left")} */}
                                                            <div className="modal modalscroll map-booking" style={{ display: 'block', backgroundColor: 'rgba(217, 217, 217, 0.59)' }}
                                                                id="dateModal" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="dateModalLabel" aria-hidden="true"
                                                            >
                                                                <div className="modal-dialog modal-dialog-centered modal-custom-width">
                                                                    <div className="modal-content modal-radius">
                                                                        <div className="modal-body">

                                                                            <div className="close-modal">
                                                                                <a>
                                                                                    <img src={Close} alt="Close" onClick={resetForm} />
                                                                                </a>
                                                                            </div>

                                                                            <div className="pt-4">
                                                                                <h5 className="popup-title">{t("react_calendar_new_booking")}</h5>
                                                                            </div>

                                                                            <div className="date-with-credit d-flex align-items-center justify-content-between pt-2">
                                                                                <div id="selectedDate" className="selected-current-date">
                                                                                    <span>{dateforfullday}</span>
                                                                                    <span>{monthforfullday} {yearforfullday}</span>
                                                                                </div>
                                                                                {zoneCreditValue > 0 && (
                                                                                    <div className="credit-info">
                                                                                        <a
                                                                                            className="orange-outline-with-icon"
                                                                                        >
                                                                                            {CreditValueGrey ?
                                                                                                (
                                                                                                    <>
                                                                                                        <img src={GrayStar} alt="star" />
                                                                                                        <span>{individualDayCost}</span>
                                                                                                    </>
                                                                                                )
                                                                                                :
                                                                                                <>
                                                                                                    <img src={Images.OrangeStar} alt="" />
                                                                                                    <span>{Number(individualDayCost) > 0
                                                                                                        ? `-${individualDayCost}`
                                                                                                        : individualDayCost}</span>
                                                                                                </>
                                                                                            }
                                                                                        </a>
                                                                                    </div>
                                                                                )}
                                                                            </div>

                                                                            <form onSubmit={
                                                                                // Submit_30mit
                                                                                e => {
                                                                                    let errors = {};
                                                                                    if (!selectedSpot) {
                                                                                        errors.spot = "Please select a spot.";
                                                                                    }
                                                                                    // if (HourlySpots && HourlySpots.length > 0 && !selectedSlot) {
                                                                                    //     errors.spot = "Please select a spot.";
                                                                                    // }
                                                                                    if (timeSlots && timeSlots.length > 0 && (!selectedFrom || !selectedTo)) {
                                                                                        errors.timeselect = "Please select time slots.";
                                                                                    }
                                                                                    if (vehiclesForSpot && vehiclesForSpot.length > 0 && !selectedVehicle) {
                                                                                        errors.vehicle = "Please select a vehicle.";
                                                                                    }
                                                                                    // Add more field checks as needed
                                                                                    if (Object.keys(errors).length > 0) {
                                                                                        e.preventDefault();
                                                                                        setRequiredFields(errors);
                                                                                        return;
                                                                                    }
                                                                                    setRequiredFields({});
                                                                                    Submit_30mit(e)
                                                                                }
                                                                            }
                                                                            >
                                                                                <div className="divider-line mt-3"></div>
                                                                                <div className="modal-des">
                                                                                    <div className="modal-scroll-inner me-4">
                                                                                        <div className="icon-with-list mb-3">

                                                                                            <div className="icon-wrap">
                                                                                                <img src={Images.Participant} />
                                                                                                <h4 className="ps-1 ms-1">{bookingModalParticipantName}</h4>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div className="form-row mb-3">
                                                                                            <label className="popup-inner-title m-0">{t("date")}</label>
                                                                                            <div className="date-input position-relative">
                                                                                                <DatePicker
                                                                                                    className="m-0 form-control"
                                                                                                    filterDate={(date) => !isHoliday(date)}
                                                                                                    dayClassName={(date) =>
                                                                                                        isHoliday(date) ? "react-datepicker__day--holidayClass" : undefined
                                                                                                    }
                                                                                                    selected={getCalendarDate()}
                                                                                                    onChange={(date) => {
                                                                                                        if (!date) return;

                                                                                                        const formatted = formatDate(date);
                                                                                                        if (!formatted) {
                                                                                                            console.warn("[30-minute calendar] Invalid DatePicker date", date);
                                                                                                            return;
                                                                                                        }

                                                                                                        setStartDate(formatted);
                                                                                                        setchangeddate(formatted);

                                                                                                        // Only call loadEvents if meetingRoomData is valid
                                                                                                        if (Array.isArray(meetingRoomData)) {
                                                                                                            loadEvents(date);
                                                                                                        } else {
                                                                                                            console.warn("Cannot load events: meetingRoomData is not an array");
                                                                                                        }

                                                                                                        // Move calendar
                                                                                                        const api = calendarRef.current?.getApi();
                                                                                                        api?.gotoDate(date);
                                                                                                    }}
                                                                                                    shouldCloseOnSelect={false}
                                                                                                    minDate={new Date()}
                                                                                                    // maxDate={maxDate}
                                                                                                    locale={{
                                                                                                        localize: {
                                                                                                            month: (n) => monthNames[n],
                                                                                                            day: (n) => [t("sun"), t("mon"), t("tue"), t("wed"), t("thu"), t("fri"), t("sat")][n]
                                                                                                        },
                                                                                                        formatLong: {
                                                                                                            date: () => "dd MMMM"
                                                                                                        }
                                                                                                    }}
                                                                                                />
                                                                                            </div>
                                                                                        </div>

                                                                                        <div className="form-row mb-3">
                                                                                            <label className="popup-inner-title m-0">{t("spot")}</label>
                                                                                            <div className="custom-dropdown modal-dropdown mb-3" style={{ position: "relative" }}>
                                                                                                <CustomSearchableDropdown
                                                                                                    items={HourlySpots
                                                                                                        .filter((spot) => spot.ClaimFlag === 1)
                                                                                                        .map((spot) => ({
                                                                                                            label: spot.SpotName,
                                                                                                            value: spot.SpotName,
                                                                                                        }))}
                                                                                                    value={selectedSpot?.SpotName || ""}
                                                                                                    labelKey="label"
                                                                                                    valueKey="value"
                                                                                                    searchable={false}
                                                                                                    placeholder={t("spot")}
                                                                                                    disabled={!HourlySpots.filter((spot) => spot.ClaimFlag === 1).length}
                                                                                                    onChange={(val) => {
                                                                                                        const chosenSpot = HourlySpots.find(
                                                                                                            (spot) => spot.SpotName === val
                                                                                                        );
                                                                                                        if (chosenSpot) {
                                                                                                            setSelectedSpot(chosenSpot);
                                                                                                        }
                                                                                                    }}
                                                                                                />
                                                                                            </div>
                                                                                        </div>

                                                                                        {/* FullCalendar preview and time slot UI (same pattern as meeting room) */}
                                                                                        <div className="form-row mb-3">
                                                                                            <label className="popup-inner-title m-0">{t("react_preview_time_slot")}</label>
                                                                                            <div
                                                                                                style={{
                                                                                                    maxHeight: "400px",
                                                                                                    overflowY: "auto",
                                                                                                    background: "#fff",
                                                                                                    // border: "1px solid #ddd",
                                                                                                    // borderRadius: "8px",
                                                                                                    // padding: "4px",
                                                                                                }}
                                                                                            >
                                                                                                {/* <FullCalendar
                                                                                ref={calendarRef}
                                                                                plugins={[timeGridPlugin, interactionPlugin]}
                                                                                initialView="timeGridDay"
                                                                                initialDate={changeddate}
                                                                                height="auto"
                                                                                headerToolbar={false}
                                                                                nowIndicator={true}
                                                                                allDaySlot={false}
                                                                                slotMinTime={timeIntervals.start}
                                                                                slotMaxTime={timeIntervals.end}
                                                                                selectable={true}
                                                                                dayHeaderFormat={false}
                                                                                dayHeaders={false}
                                                                                events={events}
                                                                                selectAllow={(selectInfo) => {
                                                                                    const selectedStart = selectInfo.start;
                                                                                    const selectedEnd = selectInfo.end;
                                                                                    const now = new Date();
                                                                                    if (selectedStart < now) return false;

                                                                                    const isOverlapping = events.some((event) => {
                                                                                        const eventStart = new Date(event.start);
                                                                                        const eventEnd = new Date(event.end);
                                                                                        return (
                                                                                            (selectedStart >= eventStart && selectedStart < eventEnd) ||
                                                                                            (selectedEnd > eventStart && selectedEnd <= eventEnd) ||
                                                                                            (selectedStart <= eventStart && selectedEnd >= eventEnd)
                                                                                        );
                                                                                    });
                                                                                    return !isOverlapping;
                                                                                }}
                                                                                select={(info) => {
                                                                                    const from = info.start.toTimeString().slice(0, 5);
                                                                                    const to = info.end.toTimeString().slice(0, 5);
                                                                                    setSelectedFrom(from);
                                                                                    setSelectedTo(to);
                                                                                }}
                                                                                slotLabelFormat={{ hour: '2-digit', minute: '2-digit', hour12: false }}
                                                                                eventTimeFormat={{ hour: '2-digit', minute: '2-digit', hour12: false }}
                                                                            /> */}
                                                                                                <FullCalendar
                                                                                                    ref={calendarRef}
                                                                                                    plugins={[timeGridPlugin, interactionPlugin]}
                                                                                                    initialView="timeGridDay"
                                                                                                    initialDate={getCalendarDateString()}
                                                                                                    height="auto"
                                                                                                    headerToolbar={false}
                                                                                                    nowIndicator={true}
                                                                                                    allDaySlot={false}
                                                                                                    slotMinTime={timeIntervals.start}
                                                                                                    slotMaxTime={timeIntervals.end}
                                                                                                    selectable={true}
                                                                                                    dayHeaderFormat={false}
                                                                                                    dayHeaders={false}
                                                                                                    events={events}

                                                                                                    // ✅ UI: Disable past slots visually
                                                                                                    slotLaneDidMount={(arg) => {
                                                                                                        const now = new Date();

                                                                                                        const slotStart = new Date(arg.date);
                                                                                                        const slotEnd = new Date(slotStart);
                                                                                                        slotEnd.setMinutes(slotEnd.getMinutes() + 30); // match slot duration

                                                                                                        if (slotEnd <= now) {
                                                                                                            arg.el.style.pointerEvents = "none";
                                                                                                            arg.el.style.opacity = "0.5";
                                                                                                            arg.el.style.cursor = "not-allowed";
                                                                                                        }
                                                                                                    }}

                                                                                                    // ✅ Logic: Allow until slot ends
                                                                                                    selectAllow={(selectInfo) => {
                                                                                                        const selectedStart = selectInfo.start;
                                                                                                        const selectedEnd = selectInfo.end;
                                                                                                        const hasBlockedOverlap = hasBlockedBookingOverlap(selectedStart, selectedEnd);

                                                                                                        // ✅ Overlap check
                                                                                                        const isOverlapping = events.some((event) => {
                                                                                                            const eventStart = new Date(event.start);
                                                                                                            const eventEnd = new Date(event.end);

                                                                                                            return (
                                                                                                                (selectedStart >= eventStart && selectedStart < eventEnd) ||
                                                                                                                (selectedEnd > eventStart && selectedEnd <= eventEnd) ||
                                                                                                                (selectedStart <= eventStart && selectedEnd >= eventEnd)
                                                                                                            );
                                                                                                        });

                                                                                                        return !isOverlapping && !hasBlockedOverlap;
                                                                                                    }}

                                                                                                    select={(info) => {
                                                                                                        const from = info.start.toTimeString().slice(0, 5);
                                                                                                        const to = info.end.toTimeString().slice(0, 5);
                                                                                                        setSelectedFrom(from);
                                                                                                        setSelectedTo(to);
                                                                                                    }}

                                                                                                    slotLabelFormat={{ hour: '2-digit', minute: '2-digit', hour12: false }}
                                                                                                    eventTimeFormat={{ hour: '2-digit', minute: '2-digit', hour12: false }}
                                                                                                    viewDidMount={() => {
                                                                                                        setTimeout(() => {
                                                                                                            applyThirtyMinuteCalendarSlotStyles();
                                                                                                        }, 0);
                                                                                                    }}
                                                                                                />
                                                                                            </div>
                                                                                        </div>

                                                                                        <div className="custom-timepicker pt-1">
                                                                                            <h6 className="popup-inner-title">{t("react_select_time")}</h6>
                                                                                            <div className="mb-3" onClick={handleToggleSlots} id="selectedBox">
                                                                                                {/* <div>
                                                                                <label>{t("from")}</label>
                                                                                <span>{selectedFrom}</span>
                                                                            </div>
                                                                            <div><img src={Images.Vector} alt="" /></div>
                                                                            <div>
                                                                                <label>{t("react_to")}</label>
                                                                                <span>{selectedTo}</span>
                                                                            </div> */}
                                                                                                <div className="time-selection">
                                                                                                    <div className="row">
                                                                                                        <div className="col-md-6 rightArrow">
                                                                                                            <div className="time-alignment pl20">
                                                                                                                <label>{t("from")}</label>
                                                                                                                <input
                                                                                                                    type="text"
                                                                                                                    readOnly
                                                                                                                    value={selectedFrom === "00:00" ? "" : selectedFrom}
                                                                                                                    placeholder="00:00"
                                                                                                                />
                                                                                                            </div>
                                                                                                        </div>

                                                                                                        <div className="col-md-6">
                                                                                                            <div className="time-alignment pl40">
                                                                                                                <label>{t("react_to")}</label>
                                                                                                                <input
                                                                                                                    type="text"
                                                                                                                    readOnly
                                                                                                                    value={selectedTo === "00:00" ? "" : selectedTo}
                                                                                                                    placeholder="00:00"
                                                                                                                />
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>

                                                                                            {/* {showSlots && (
                                                                            <div className="slot-container d-flex flex-wrap gap-2 mb-3">
                                                                                {timeSlots.map((slot, idx) => {
                                                                                    const [start, end] = slot.split("-");
                                                                                    const slotEnd = new Date(`${formatDate(changeddate)}T${end}:00`);
                                                                                    const now = new Date();
                                                                                    const isPast = slotEnd <= now;
                                                                                    const isBooked = isSlotBooked(start, end);
                                                                                    const isDisabled = isPast || isBooked;
                                                                                    const isSelected = slot === `${selectedFrom}-${selectedTo}`;
                                                                                    return (
                                                                                        <div key={idx} className={`slot p-2 border rounded text-center ${isDisabled
                                                                                         ? "bg-secondary text-white" 
                                                                                         : isSelected ? 
                                                                                         "bg-success text-white" 
                                                                                         : "bg-light"
                                                                                         }`} 
                                                                                         style={{ 
                                                                                            cursor: isDisabled ? "not-allowed" : "pointer", 
                                                                                            opacity: isDisabled ? 0.6 : 1 
                                                                                            }} 
                                                                                            onClick={() => !isDisabled && handleSlotClick(slot)}>
                                                                                            {slot}
                                                                                        </div>
                                                                                    );
                                                                                })}
                                                                            </div>
                                                                        )} */}
                                                                                            {showSlots && (
                                                                                                <div className="slot-container d-grid mb-3">
                                                                                                    {timeSlots.map((slot, idx) => {
                                                                                                        const [start, end] = slot.split("-");
                                                                                                        const isBooked = isSlotBooked(start, end);
                                                                                                        const isBlocked = getBlockedBookingSlots().includes(
                                                                                                            normalizeBlockedSlot(slot)
                                                                                                        );
                                                                                                        const isDisabled = isBooked || isBlocked;
                                                                                                        // const isSelected = slot === `${selectedFrom}-${selectedTo}`;
                                                                                                        const isSelected =
                                                                                                            selectedFrom &&
                                                                                                            selectedTo &&
                                                                                                            slotOverlapsRange(start, end, selectedFrom, selectedTo);

                                                                                                        return (
                                                                                                            <div
                                                                                                                key={idx}
                                                                                                                className={`slot ${isBlocked || isBooked ? "disabled" : isSelected ? "active" : ""
                                                                                                                    }`}
                                                                                                                onClick={() => !isBooked && !isBlocked && handleSlotClick(slot)}
                                                                                                            >
                                                                                                                {slot}
                                                                                                            </div>
                                                                                                        );
                                                                                                    })}
                                                                                                </div>
                                                                                            )}

                                                                                            {requiredFields.timeselect && (
                                                                                                <div style={{ color: 'red', marginTop: 8, fontSize: 14 }}>
                                                                                                    {requiredFields.timeselect}
                                                                                                </div>
                                                                                            )}
                                                                                        </div>

                                                                                        {GuestParticipants.length > 0 && (
                                                                                            <div className="mt-3">
                                                                                                <h6 className="popup-inner-title">Guest List:</h6>
                                                                                                <ul className="list-group">
                                                                                                    {GuestParticipants.map((guest, index) => (
                                                                                                        <li
                                                                                                            key={guest.Id}
                                                                                                            className="list-group-item d-flex justify-content-between align-items-center"
                                                                                                        >
                                                                                                            {guest.FirstName} {guest.LastName} ({guest.PrimaryEmail})
                                                                                                            <button
                                                                                                                type="button"
                                                                                                                className="btn btn-sm btn-danger"
                                                                                                                onClick={() => handleRemoveGuest(index)}
                                                                                                            >
                                                                                                                {t("remove")}
                                                                                                            </button>
                                                                                                        </li>
                                                                                                    ))}
                                                                                                </ul>
                                                                                            </div>
                                                                                        )}

                                                                                        {vehiclesForSpot.length > 0 && (
                                                                                            <div className="custom-dropdown modal-dropdown mb-3">
                                                                                                <CustomSearchableDropdown
                                                                                                    items={vehiclesForSpot}
                                                                                                    // The current selected ID
                                                                                                    value={selectedVehiclePrimaryKey}
                                                                                                    // The key from your data to show in the list (Registration ID)
                                                                                                    labelKey="VehicleRegistrationId"
                                                                                                    // The key from your data used as the unique ID
                                                                                                    valueKey="VehiclePrimaryKey"
                                                                                                    searchable={false}
                                                                                                    placeholder="Select Vehicle"
                                                                                                    disabled={!vehiclesForSpot.length}
                                                                                                    onChange={(pk) => {
                                                                                                        // 1. Update the Primary Key state
                                                                                                        setSelectedVehiclePrimaryKey(pk);

                                                                                                        // 2. Find the full vehicle object and update it
                                                                                                        const vehicleObj = vehiclesForSpot.find(v => v.VehiclePrimaryKey === pk);
                                                                                                        setSelectedVehicle(vehicleObj);

                                                                                                        // 3. Close the validation error for 'vehicle'
                                                                                                        setRequiredFields(prev => ({
                                                                                                            ...prev,
                                                                                                            vehicle: ""
                                                                                                        }));

                                                                                                        // Optional: Debugging logs
                                                                                                        if (vehicleObj) {
                                                                                                            console.log("Vehicle Selected:", vehicleObj.VehicleRegistrationId);
                                                                                                            console.log("PK:", pk);
                                                                                                        }
                                                                                                    }}
                                                                                                />
                                                                                            </div>
                                                                                        )
                                                                                        }

                                                                                        {/* {vehiclesForSpot.length > 0 && (
                                                                        <div
                                                                            className=""
                                                                            style={{ position: "relative" }}
                                                                        >
                                                                            <label htmlFor=""></label>
                                                                            <div
                                                                                role="button"
                                                                                onClick={() => setVehicleOpen(!vehicleOpen)}
                                                                                className="dropdown-toggle form-control position-relative custom-dropdown-btn ctm-select"
                                                                                style={{
                                                                                    display: "flex",
                                                                                    justifyContent: "space-between",
                                                                                    cursor: "pointer",
                                                                                }}
                                                                            >

                                                                                <div className="d-flex flex-column">
                                                                                    <p className="sub-dropdown-name">Vehicle</p>
                                                                                    <span
                                                                                        style={{
                                                                                            fontSize: "16px",
                                                                                            fontWeight: "bold",
                                                                                            color: "#1c988a",
                                                                                        }}
                                                                                    >
                                                                                        {selectedVehicle?.VehicleRegistrationId || vehiclesForSpot[0]?.VehicleRegistrationId}
                                                                                    </span>
                                                                                </div>
                                                                            </div>

                                                                            {vehicleOpen && (
                                                                                <div
                                                                                    style={{
                                                                                        position: "absolute",
                                                                                        top: "calc(100% + 6px)",
                                                                                        left: 0,
                                                                                        width: "100%",
                                                                                        background: "#fff",
                                                                                        borderRadius: 12,
                                                                                        boxShadow: "0 10px 30px rgba(0,0,0,.15)",
                                                                                        maxHeight: 300,
                                                                                        overflowY: "auto",
                                                                                        zIndex: 9999,
                                                                                    }}
                                                                                >
                                                                                    {vehiclesForSpot.map((v) => (
                                                                                        <div
                                                                                            key={v.VehiclePrimaryKey}
                                                                                            onClick={() => {
                                                                                                const pk = v.VehiclePrimaryKey;

                                                                                                setSelectedVehiclePrimaryKey(pk);
                                                                                                setSelectedVehicle(v);
                                                                                                setVehicleOpen(false);

                                                                                                setRequiredFields(prev => ({
                                                                                                    ...prev,
                                                                                                    vehicle: ""
                                                                                                }));

                                                                                                console.log("Spot +++++:", selectedSpot?.SpotName);
                                                                                                console.log("Registration +++++:", v.VehicleRegistrationId);
                                                                                                console.log("FuelId: ++++", v.FuelId);
                                                                                                console.log("VehiclePrimaryKey +++++++:", v.VehiclePrimaryKey);
                                                                                            }}
                                                                                            style={{
                                                                                                padding: "8px 12px",
                                                                                                display: "flex",
                                                                                                alignItems: "center",
                                                                                                cursor: "pointer",
                                                                                            }}
                                                                                        >
                                                                                            <input
                                                                                                type="radio"
                                                                                                checked={selectedVehiclePrimaryKey === v.VehiclePrimaryKey}
                                                                                                readOnly
                                                                                                style={{
                                                                                                    marginRight: 8,
                                                                                                    accentColor: "#1c988a",
                                                                                                }}
                                                                                            />
                                                                                            <span>{v.VehicleRegistrationId}</span>
                                                                                        </div>
                                                                                    ))}
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    )} */}

                                                                                        {requiredFields.vehicle && (
                                                                                            <div style={{ color: 'red', marginTop: 8, fontSize: 14 }}>{requiredFields.vehicle}</div>
                                                                                        )}

                                                                                        <div className="participants-list ctm-checklist">
                                                                                            {!!preBookinQueCanvas && (
                                                                                                <div className="form-check">
                                                                                                    <input
                                                                                                        className="form-check-input"
                                                                                                        type="checkbox"
                                                                                                        id={`preBookinQueCanvas`}
                                                                                                        checked={checkedPreBookingQue}
                                                                                                        onChange={(e) => setCheckedPreBookingQue(e.target.checked)}
                                                                                                    />

                                                                                                    <label
                                                                                                        className="form-check-label ms-2"
                                                                                                        htmlFor={`preBookinQueCanvas`}
                                                                                                    >
                                                                                                        <span dangerouslySetInnerHTML={{ __html: safeHtml }} />

                                                                                                    </label>
                                                                                                </div>
                                                                                            )}
                                                                                        </div>

                                                                                        {selectedParticipants.length > 0 && (
                                                                                            <div className="mt-3">
                                                                                                <h6 className="popup-inner-title">{t("selected_participants")}</h6>
                                                                                                <ul className="list-group">
                                                                                                    {selectedParticipants.map((participant, index) => (
                                                                                                        <li
                                                                                                            key={participant.Id}
                                                                                                            className="list-group-item d-flex justify-content-between align-items-center"
                                                                                                        >
                                                                                                            {participant.FirstName} {participant.LastName} ({participant.PrimaryEmail})
                                                                                                            <button
                                                                                                                type="button"
                                                                                                                className="btn btn-sm btn-danger"
                                                                                                                onClick={() =>
                                                                                                                    setSelectedParticipants((prev) =>
                                                                                                                        prev.filter((_, i) => i !== index)
                                                                                                                    )
                                                                                                                }
                                                                                                            >
                                                                                                                {t("remove")}
                                                                                                            </button>
                                                                                                        </li>
                                                                                                    ))}
                                                                                                </ul>
                                                                                            </div>
                                                                                        )}

                                                                                        {/* <div className="form-row">
                                                                        <label className="popup-inner-title m-0">Meeting Name</label>
                                                                        <input type="text" name="meetingName" value={meetingName} onChange={(e) => setMeetingName(e.target.value)} className="form-control" />
                                                                    </div>

                                                                    <div className="tags-btn me-4 mt-3">
                                                                        <button type="submit" className="w-100 min-height-56" disabled={loading}>
                                                                            <span>{loading ? "Booking..." : "Confirm"}</span>
                                                                        </button>
                                                                    </div> */}

                                                                                        {/* {Number(timeIntervals.RepeatOptionByLiftRestriction) === 0 && (
                                                        <div className="form-row">
                                                            <label className="popup-inner-title m-0">Repeat</label>
                                                            <select className="form-select" value={repeatType} onChange={(e) => { setRepeatType(e.target.value); setEndDate(null); setWeeklyRepeatOption([]); }}>
                                                                <option value={0}>No Repeat</option>
                                                                <option value="1">Daily</option>
                                                                <option value="2">Weekly</option>
                                                                <option value="4">BiWeekly</option>
                                                                <option value="3">Monthly</option>
                                                            </select>
                                                        </div>
                                                    )}

                                                    <div>
                                                        <input type="text" className="form-control mb-2" placeholder="Search by name or email..." value={searchText} onChange={(e) => setSearchText(e.target.value)} />
                                                        <select className="form-control" onChange={(e) => handleAddParticipant(e.target.value)}>
                                                            <option value="">Select Participant</option>
                                                            {participantsList.filter((p) => (p.FirstName + " " + p.LastName + " " + p.PrimaryEmail).toLowerCase().includes(searchText.toLowerCase())).map((p) => (
                                                                <option key={p.Id} value={JSON.stringify(p)}>{p.FirstName} {p.LastName} ({p.PrimaryEmail})</option>
                                                            ))}
                                                        </select>
                                                    </div>

                                                    <div className="tags-btn me-4 mt-3">
                                                        <button type="submit" className="w-100 min-height-56" disabled={loading}>
                                                            <span>{loading ? "Booking..." : "Confirm"}</span>
                                                        </button>
                                                    </div> */}
                                                                                    </div>
                                                                                </div>
                                                                                {/* <div className="tags-btn me-4 mt-3">
                                                                    <button type="submit" className="w-100 min-height-56 selected" disabled={loading}>
                                                                        <span>{loading ? <div id='preloader'>
                                                                            <img src={LoaderFull} alt="Loading" />
                                                                        </div> : "Confirm"}</span>
                                                                    </button>
                                                                </div> */}
                                                                                <div className="tags-btn me-4 mt-3">
                                                                                    <button
                                                                                        type="submit"
                                                                                        className="w-100 min-height-56 selected"
                                                                                        // Button is disabled if:
                                                                                        // 1. Loading is true
                                                                                        // 2. OR (The question exists AND it is NOT checked)
                                                                                        disabled={isThirtyMinuteModalReadOnly || isSelectedSpotFullyBooked || loading || (!!preBookinQueCanvas && !checkedPreBookingQue)}
                                                                                        style={{
                                                                                            // Optional: add a visual cue for disabled state
                                                                                            opacity: (isThirtyMinuteModalReadOnly || isSelectedSpotFullyBooked || loading || (!!preBookinQueCanvas && !checkedPreBookingQue)) ? 0.5 : 1,
                                                                                            cursor: (isThirtyMinuteModalReadOnly || isSelectedSpotFullyBooked || loading || (!!preBookinQueCanvas && !checkedPreBookingQue)) ? "not-allowed" : "pointer"
                                                                                        }}
                                                                                    >
                                                                                        {loading ? (
                                                                                            <div id='preloader'>
                                                                                                <img src={LoaderFull} alt="Loading" />
                                                                                            </div>
                                                                                        ) : (
                                                                                            <div>
                                                                                                {t("confirm")}
                                                                                            </div>
                                                                                            // "Confirm"
                                                                                        )}
                                                                                    </button>
                                                                                </div>
                                                                            </form>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>

                                            <div className="me-4 mt-3">
                                                {/* <button type="button" className="btn btn-secondary" onClick={() => setShowCancelModal(false)}>
                                                            Close
                                                        </button> */}
                                                <button type="button" className="w-100 min-height-56 main-btn cancel-btn" onClick={() => {
                                                    if (isThirtyMinuteModalReadOnly) {
                                                        resetForm();
                                                        return;
                                                    }
                                                    // Call your cancel API here
                                                    // setShowCancelModal(false);
                                                    // Fix: Ensure variables are defined before calling CancelBooking
                                                    CancelBooking(
                                                        selectedZone?.Id || (selectedSpot && selectedSpot.ZoneId) || 0,
                                                        bookingDate || (selectedSpot && selectedSpot.BookingDate) || formatDate(new Date()),
                                                        selectedSpot?.SpotId || 0
                                                    );
                                                }}
                                                    disabled={isThirtyMinuteModalReadOnly}
                                                    style={{
                                                        opacity: isThirtyMinuteModalReadOnly ? 0.5 : 1,
                                                        cursor: isThirtyMinuteModalReadOnly ? "not-allowed" : "pointer"
                                                    }}>
                                                    {/* <img src={closeIcon} alt="" /> */}
                                                    <span> {isThirtyMinuteModalReadOnly ? t("cancel_booking") : t("cancel_booking")} </span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    {/* </ModalContent> */}
                </div>
            )}

            {showGuestPopupFullday && (

                <div>
                    <form>
                        <div className="modal" style={{ display: 'block', backgroundColor: 'rgba(217, 217, 217, 0.59)' }}
                            id="dateModal" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="dateModalLabel" aria-hidden="true"
                        >
                            <div className="modal-dialog modal-dialog-centered modal-custom-width">
                                <div className="modal-content modal-radius">
                                    <div className="modal-body">
                                        <div className="close-modal">
                                            <a className="close-modal">
                                                <img src={Close} alt="Close" onClick={resetForm} />
                                            </a>
                                        </div>
                                        <div className="pt-2">
                                            <h5 className="popup-title">{t("react_guest_details")}</h5>
                                        </div>

                                        {/* <h5>Guest Details</h5> */}

                                        <div className="form-row mb-3">
                                            <label className="popup-inner-title m-0">{t("react_first_name")}*</label>
                                            <input
                                                type="text"
                                                placeholder={t("react_first_name")}
                                                className={`form-control ${guestErrors.fullDay.firstname ? "error-form" : ""} ${!guestErrors.fullDay.firstname && guestName ? "success-validation" : ""}`}
                                                value={guestName}
                                                onChange={(e) => {
                                                    setGuestName(e.target.value);
                                                    clearGuestFieldError("fullDay", "firstname");
                                                }}
                                            />
                                            {guestErrors.fullDay.firstname && (
                                                <div className="error-text"><img src={Images.ErrorMsg} alt="" /><p>{guestErrors.fullDay.firstname}</p></div>
                                            )}
                                        </div>

                                        <div className="form-row mb-3">
                                            <label className="popup-inner-title m-0">{t("react_last_name")}*</label>
                                            <input
                                                type="text"
                                                placeholder={t("react_last_name")}
                                                className={`form-control ${guestErrors.fullDay.lastname ? "error-form" : ""} ${!guestErrors.fullDay.lastname && guestLastName ? "success-validation" : ""}`}
                                                value={guestLastName}
                                                onChange={(e) => {
                                                    setGuestLastName(e.target.value);
                                                    clearGuestFieldError("fullDay", "lastname");
                                                }}
                                            />
                                            {guestErrors.fullDay.lastname && (
                                                <div className="error-text"><img src={Images.ErrorMsg} alt="" /><p>{guestErrors.fullDay.lastname}</p></div>
                                            )}
                                        </div>

                                        <div className="form-row mb-3">
                                            <label className="popup-inner-title m-0">{t("email_address")}*</label>
                                            <input
                                                type="email"
                                                placeholder="___@____"
                                                className={`form-control ${guestErrors.fullDay.email ? "error-form" : ""} ${!guestErrors.fullDay.email && guestEmail ? "success-validation" : ""}`}
                                                value={guestEmail}
                                                onChange={(e) => {
                                                    setGuestEmail(e.target.value);
                                                    clearGuestFieldError("fullDay", "email");
                                                }}
                                            />
                                            {guestErrors.fullDay.email && (
                                                <div className="error-text"><img src={Images.ErrorMsg} alt="" /><p>{guestErrors.fullDay.email}</p></div>
                                            )}
                                        </div>

                                        <div className="form-row mb-3">
                                            <label className="popup-inner-title m-0">{t("react_national_id_optional")}</label>
                                            <input
                                                type="text"
                                                placeholder={`${t("react_national_id_optional")}`}
                                                className="form-control"
                                                value={identificatoin}
                                                onChange={(e) => setIdentification(e.target.value)}
                                            />
                                        </div>

                                        {GuestVehicleTypes.length > 0 && (
                                            <div className="form-row mb-3">
                                                <label className="popup-inner-title m-0">{t("vehicle_registration_number")}</label>
                                                <input
                                                    type="text"
                                                    placeholder="AB12CDE"
                                                    className="form-control"
                                                    value={vehicleRegistrationNumber}
                                                    onChange={(e) => setVehicleRegistrationNumber(e.target.value)}
                                                />
                                            </div>
                                        )}

                                        {/* {zoneData.ZoneType== 1  } */}
                                        {GuestVehicleTypes.length > 0 && (
                                            <div className="form-row mb-3">
                                                <label className="popup-inner-title m-0">{t("react_vehicle_size")}</label>
                                                <div className="custom-dropdown modal-dropdown mb-3" style={{ position: "relative" }}>
                                                    <CustomSearchableDropdown
                                                        items={GuestVehicleTypes}
                                                        value={selectedGuestVehicleType?.Id ?? GuestVehicleTypes[0]?.Id ?? ""}
                                                        labelKey="Name"
                                                        valueKey="Id"
                                                        searchable={false}
                                                        placeholder={t("react_vehicle_size")}
                                                        disabled={!GuestVehicleTypes.length}
                                                        onChange={(value) => {
                                                            const vehicleType = GuestVehicleTypes.find((v) => String(v.Id) === String(value)) || null;
                                                            setSelectedGuestVehicleType(vehicleType);
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        )}

                                        {GuestFuelTypes.length > 0 && (
                                            <div className="form-row mb-3">
                                                <label className="popup-inner-title m-0">{t("fuel")}</label>
                                                <div className="custom-dropdown modal-dropdown mb-3" style={{ position: "relative" }}>
                                                    <CustomSearchableDropdown
                                                        items={GuestFuelTypes}
                                                        value={selectedGuestFuelType?.Id ?? GuestFuelTypes[0]?.Id ?? ""}
                                                        labelKey="Name"
                                                        valueKey="Id"
                                                        searchable={false}
                                                        placeholder={t("fuel")}
                                                        disabled={!GuestFuelTypes.length}
                                                        onChange={(value) => {
                                                            const fuelType = GuestFuelTypes.find((f) => String(f.Id) === String(value)) || null;
                                                            setSelectedGuestFuelType(fuelType);
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        )}


                                        {GuestAccessibleTypes.length > 0 && (
                                            <div className="form-row mb-3">
                                                <label className="popup-inner-title m-0">{t("VehicleTypeReducedMobility")}</label>
                                                <div className="custom-dropdown modal-dropdown mb-3" style={{ position: "relative" }}>
                                                    <CustomSearchableDropdown
                                                        items={[{ Id: 0, Name: "--" }, ...GuestAccessibleTypes]}
                                                        value={selectedGuestAccessibleType?.Id ?? 0}
                                                        labelKey="Name"
                                                        valueKey="Id"
                                                        searchable={false}
                                                        placeholder={`${t("VehicleTypeReducedMobility")}`}
                                                        disabled={!GuestAccessibleTypes.length}
                                                        onChange={(value) => {
                                                            const accessibleType = Number(value) === 0
                                                                ? null
                                                                : GuestAccessibleTypes.find((item) => String(item.Id) === String(value)) || null;
                                                            setSelectedGuestAccessibleType(accessibleType);
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        )}

                                        {GuestShareableTypes.length > 0 && (
                                            <div className="form-row mb-3">
                                                <label className="popup-inner-title m-0">{t("label_shareable_category")}</label>
                                                <div className="custom-dropdown modal-dropdown mb-3" style={{ position: "relative" }}>
                                                    <CustomSearchableDropdown
                                                        items={[{ Id: 0, Name: "--" }, ...GuestShareableTypes]}
                                                        value={selectedGuestShareableType?.Id ?? 0}
                                                        labelKey="Name"
                                                        valueKey="Id"
                                                        searchable={false}
                                                        placeholder={`${t("label_shareable_category")}`}
                                                        disabled={!GuestShareableTypes.length}
                                                        onChange={(value) => {
                                                            const shareableType = Number(value) === 0
                                                                ? null
                                                                : GuestShareableTypes.find((item) => String(item.Id) === String(value)) || null;
                                                            setSelectedGuestShareableType(shareableType);
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        )}


                                        <div className="tags-btn mt-4">
                                            <button
                                                type="button"
                                                className="w-100 min-height-56 selected"
                                                onClick={() => {
                                                    const isValid = validateGuestFields({
                                                        name: guestName,
                                                        surname: guestLastName,
                                                        email: guestEmail
                                                    }, "fullDay");

                                                    if (!isValid) {
                                                        return;
                                                    }
                                                    setshowGuestPopupFullday(false);
                                                    sendBookingFullDay({
                                                        guestname: guestName,
                                                        guestlastname: guestLastName,
                                                        guestemail: guestEmail,
                                                        guestidentificatoin: identificatoin,
                                                        guestvehicleregistrationnumber: vehicleRegistrationNumber
                                                    });
                                                }}
                                            >
                                                {t("confirm")}
                                            </button>
                                        </div>

                                        <div className="main-btn outline-gray-btn w-100 mw-100 min-height-56 mt-3">
                                            <a
                                                onClick={() => setshowGuestPopupFullday(false)}
                                            >
                                                {t("cancel")}
                                            </a>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            )}

            {showGuestPopup30mit && (
                <div className="modal" style={{ display: 'block', backgroundColor: 'rgba(217, 217, 217, 0.59)' }}
                    id="dateModal" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="dateModalLabel" aria-hidden="true"
                >
                    <div className="modal-dialog modal-dialog-centered modal-custom-width">
                        <div className="modal-content modal-radius">
                            <div className="modal-body">
                                <div className="close-modal">
                                    <img src={Close} alt="Close" onClick={resetForm} />
                                </div>
                                <div className="pt-2">
                                    <h5 className="popup-title">{t("react_guest_details")}</h5>
                                </div>

                                {/* <h5>Guest Details 30mit</h5> */}

                                <div className="form-row mb-3">
                                    <label className="popup-inner-title m-0">{t("react_first_name")}*</label>
                                    <input
                                        type="text"
                                        placeholder={t("react_first_name")}
                                        className={`form-control ${guestErrors.thirtyMin.firstname ? "error-form" : ""} ${!guestErrors.thirtyMin.firstname && guestName30mit ? "success-validation" : ""}`}
                                        value={guestName30mit}
                                        onChange={(e) => {
                                            setGuestName30mit(e.target.value);
                                            clearGuestFieldError("thirtyMin", "firstname");
                                        }}
                                    />
                                    {guestErrors.thirtyMin.firstname && (
                                        <div className="error-text"><img src={Images.ErrorMsg} alt="" /><p>{guestErrors.thirtyMin.firstname}</p></div>
                                    )}
                                </div>

                                <div className="form-row mb-3">
                                    <label className="popup-inner-title m-0">{t("react_last_name")}*</label>
                                    <input
                                        type="text"
                                        placeholder={t("react_last_name")}
                                        className={`form-control ${guestErrors.thirtyMin.lastname ? "error-form" : ""} ${!guestErrors.thirtyMin.lastname && guestLastName30mit ? "success-validation" : ""}`}
                                        value={guestLastName30mit}
                                        onChange={(e) => {
                                            setGuestLastName30mit(e.target.value);
                                            clearGuestFieldError("thirtyMin", "lastname");
                                        }}
                                    />
                                    {guestErrors.thirtyMin.lastname && (
                                        <div className="error-text"><img src={Images.ErrorMsg} alt="" /><p>{guestErrors.thirtyMin.lastname}</p></div>
                                    )}
                                </div>

                                <div className="form-row mb-3">
                                    <label className="popup-inner-title m-0">{t("email_address")}*</label>
                                    <input
                                        type="email"
                                        placeholder="___@____"
                                        className={`form-control mt-2 ${guestErrors.thirtyMin.email ? "error-form" : ""} ${!guestErrors.thirtyMin.email && guestEmail30mit ? "success-validation" : ""}`}
                                        value={guestEmail30mit}
                                        onChange={(e) => {
                                            setGuestEmail30mit(e.target.value);
                                            clearGuestFieldError("thirtyMin", "email");
                                        }}
                                    />
                                    {guestErrors.thirtyMin.email && (
                                        <div className="error-text"><img src={Images.ErrorMsg} alt="" /><p>{guestErrors.thirtyMin.email}</p></div>
                                    )}
                                </div>

                                <div className="form-row mb-3">
                                    <label className="popup-inner-title m-0">{t("react_national_id_optional")}</label>
                                    <input
                                        type="text"
                                        placeholder={t("react_national_id_optional")}
                                        className="form-control"
                                        value={identificatoin30mit}
                                        onChange={(e) => setIdentification30mit(e.target.value)}
                                    />
                                </div>

                                {GuestVehicleTypes.length > 0 && (
                                    <div className="form-row mb-3">
                                        <label className="popup-inner-title m-0">{t("vehicle_registration_number")}</label>
                                        <input
                                            type="text"
                                            placeholder="AB12CDE"
                                            className="form-control"
                                            value={vehicleRegistrationNumber30mit}
                                            onChange={(e) => setVehicleRegistrationNumber30mit(e.target.value)}
                                        />
                                    </div>
                                )}

                                {GuestVehicleTypes.length > 0 && (
                                    <div className="form-row mb-3">
                                        <label className="popup-inner-title m-0">{t("react_vehicle_size")}</label>
                                        <div className="custom-dropdown modal-dropdown mb-3" style={{ position: "relative" }}>
                                            <CustomSearchableDropdown
                                                items={GuestVehicleTypes}
                                                value={selectedGuestVehicleType?.Id ?? GuestVehicleTypes[0]?.Id ?? ""}
                                                labelKey="Name"
                                                valueKey="Id"
                                                searchable={false}
                                                placeholder={t("react_vehicle_size")}
                                                disabled={!GuestVehicleTypes.length}
                                                onChange={(value) => {
                                                    const vehicleType = GuestVehicleTypes.find((v) => String(v.Id) === String(value)) || null;
                                                    setSelectedGuestVehicleType(vehicleType);
                                                }}
                                            />
                                        </div>
                                    </div>
                                )}

                                {GuestFuelTypes.length > 0 && (
                                    <div className="form-row mb-3">
                                        <label className="popup-inner-title m-0">{t("fuel")}</label>
                                        <div className="custom-dropdown modal-dropdown mb-3" style={{ position: "relative" }}>
                                            <CustomSearchableDropdown
                                                items={GuestFuelTypes}
                                                value={selectedGuestFuelType?.Id ?? GuestFuelTypes[0]?.Id ?? ""}
                                                labelKey="Name"
                                                valueKey="Id"
                                                searchable={false}
                                                placeholder={t("fuel")}
                                                disabled={!GuestFuelTypes.length}
                                                onChange={(value) => {
                                                    const fuelType = GuestFuelTypes.find((f) => String(f.Id) === String(value)) || null;
                                                    setSelectedGuestFuelType(fuelType);
                                                }}
                                            />
                                        </div>
                                    </div>
                                )}


                                {GuestAccessibleTypes.length > 0 && (
                                    <div className="form-row mb-3">
                                        <label className="popup-inner-title m-0">{t("VehicleTypeReducedMobility")}</label>
                                        <div className="custom-dropdown modal-dropdown mb-3" style={{ position: "relative" }}>
                                            <CustomSearchableDropdown
                                                items={[{ Id: 0, Name: "--" }, ...GuestAccessibleTypes]}
                                                value={selectedGuestAccessibleType?.Id ?? 0}
                                                labelKey="Name"
                                                valueKey="Id"
                                                searchable={false}
                                                placeholder={`${t("VehicleTypeReducedMobility")}`}
                                                disabled={!GuestAccessibleTypes.length}
                                                onChange={(value) => {
                                                    const accessibleType = Number(value) === 0
                                                        ? null
                                                        : GuestAccessibleTypes.find((item) => String(item.Id) === String(value)) || null;
                                                    setSelectedGuestAccessibleType(accessibleType);
                                                }}
                                            />
                                        </div>
                                    </div>
                                )}

                                {GuestShareableTypes.length > 0 && (
                                    <div className="form-row mb-3">
                                        <label className="popup-inner-title m-0">{t("label_shareable_category")}</label>
                                        <div className="custom-dropdown modal-dropdown mb-3" style={{ position: "relative" }}>
                                            <CustomSearchableDropdown
                                                items={[{ Id: 0, Name: "--" }, ...GuestShareableTypes]}
                                                value={selectedGuestShareableType?.Id ?? 0}
                                                labelKey="Name"
                                                valueKey="Id"
                                                searchable={false}
                                                placeholder={`${t("label_shareable_category")}`}
                                                disabled={!GuestShareableTypes.length}
                                                onChange={(value) => {
                                                    const shareableType = Number(value) === 0
                                                        ? null
                                                        : GuestShareableTypes.find((item) => String(item.Id) === String(value)) || null;
                                                    setSelectedGuestShareableType(shareableType);
                                                }}
                                            />
                                        </div>
                                    </div>
                                )}



                                <div className="tags-btn mt-4">
                                    <button
                                        type="button"
                                        className="w-100 min-height-56 selected"
                                        onClick={() => {
                                            const isValid = validateGuestFields({
                                                name: guestName30mit,
                                                surname: guestLastName30mit,
                                                email: guestEmail30mit
                                            }, "thirtyMin");

                                            if (!isValid) {
                                                return;
                                            }
                                            setShowGuestPopup30mit(false);
                                            sendBooking30mit({
                                                name30mit: guestName30mit,
                                                lastname30mit: guestLastName30mit,
                                                email30mit: guestEmail30mit,
                                                identificatoin30mit: identificatoin30mit,
                                                vehicleRegistrationNumber30mit: vehicleRegistrationNumber30mit
                                            });
                                        }}
                                    >
                                        {t("confirm")}
                                    </button>
                                </div>

                                <div className="main-btn outline-gray-btn w-100 mw-100 min-height-56 mt-3">
                                    <a
                                        type="button"
                                        onClick={() => setShowGuestPopup30mit(false)}
                                    >
                                        {t("cancel")}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {showGuestPopupHourly && (
                <div className="modal" style={{ display: 'block', backgroundColor: 'rgba(217, 217, 217, 0.59)' }}
                    id="dateModal" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="dateModalLabel" aria-hidden="true"
                >
                    <div className="modal-dialog modal-dialog-centered modal-custom-width">
                        <div className="modal-content modal-radius">
                            <div className="modal-body">
                                <div className="close-modal">
                                    <img src={Close} alt="Close" onClick={resetForm} />
                                </div>
                                <div className="pt-2">
                                    <h5 className="popup-title">{t("react_guest_details")}</h5>
                                </div>

                                <div className="form-row mb-3">
                                    <label className="popup-inner-title m-0">{t("react_first_name")}*</label>

                                    <input
                                        type="text"
                                        placeholder={`${t("react_first_name")}*`}
                                        className={`form-control ${guestErrors.hourly.firstname ? "error-form" : ""} ${!guestErrors.hourly.firstname && guestNameHourly ? "success-validation" : ""}`}
                                        value={guestNameHourly}
                                        onChange={(e) => {
                                            setGuestNameHourly(e.target.value);
                                            clearGuestFieldError("hourly", "firstname");
                                        }}
                                    />
                                    {guestErrors.hourly.firstname && (
                                        <div className="error-text"><img src={Images.ErrorMsg} alt="" /><p>{guestErrors.hourly.firstname}</p></div>
                                    )}
                                </div>

                                <div className="form-row mb-3">
                                    <label className="popup-inner-title m-0">{t("react_last_name")}*</label>
                                    <input
                                        type="text"
                                        placeholder={`${t("react_last_name")}*`}
                                        className={`form-control mt-3 ${guestErrors.hourly.lastname ? "error-form" : ""} ${!guestErrors.hourly.lastname && guestLastNameHourly ? "success-validation" : ""}`}
                                        value={guestLastNameHourly}
                                        onChange={(e) => {
                                            setGuestLastNameHourly(e.target.value);
                                            clearGuestFieldError("hourly", "lastname");
                                        }}
                                    />
                                    {guestErrors.hourly.lastname && (
                                        <div className="error-text"><img src={Images.ErrorMsg} alt="" /><p>{guestErrors.hourly.lastname}</p></div>
                                    )}
                                </div>

                                <div className="form-row mb-3">
                                    <label className="popup-inner-title m-0">{t("email_address")}*</label>
                                    <input
                                        type="email"
                                        placeholder="___@____"
                                        className={`form-control ${guestErrors.hourly.email ? "error-form" : ""} ${!guestErrors.hourly.email && guestEmailHourly ? "success-validation" : ""}`}
                                        value={guestEmailHourly}
                                        onChange={(e) => {
                                            setGuestEmailHourly(e.target.value);
                                            clearGuestFieldError("hourly", "email");
                                        }}
                                    />
                                    {guestErrors.hourly.email && (
                                        <div className="error-text"><img src={Images.ErrorMsg} alt="" /><p>{guestErrors.hourly.email}</p></div>
                                    )}
                                </div>
                                <div className="form-row mb-3">
                                    <label className="popup-inner-title m-0">{t("react_national_id_optional")}</label>
                                    <input
                                        type="text"
                                        placeholder={`${t("react_national_id_optional")}`}
                                        className="form-control mt-2"
                                        value={identificatoinHourly}
                                        onChange={(e) => setIdentificationHourly(e.target.value)}
                                    />
                                </div>

                                {GuestVehicleTypes.length > 0 && (
                                    <div className="form-row mb-3">
                                        <label className="popup-inner-title m-0">{t("vehicle_registration_number")}</label>
                                        <input
                                            type="text"
                                            placeholder="AB12CDE"
                                            className="form-control"
                                            value={vehicleRegistrationNumberHourly}
                                            onChange={(e) => setVehicleRegistrationNumberHourly(e.target.value)}
                                        />
                                    </div>
                                )}

                                {GuestVehicleTypes.length > 0 && (
                                    <div className="form-row mb-3">
                                        <label className="popup-inner-title m-0">{t("react_vehicle_size")}</label>
                                        <div className="custom-dropdown modal-dropdown mb-3" style={{ position: "relative" }}>
                                            <CustomSearchableDropdown
                                                items={GuestVehicleTypes}
                                                value={selectedGuestVehicleType?.Id ?? GuestVehicleTypes[0]?.Id ?? ""}
                                                labelKey="Name"
                                                valueKey="Id"
                                                searchable={false}
                                                placeholder={t("react_vehicle_size")}
                                                disabled={!GuestVehicleTypes.length}
                                                onChange={(value) => {
                                                    const vehicleType = GuestVehicleTypes.find((v) => String(v.Id) === String(value)) || null;
                                                    setSelectedGuestVehicleType(vehicleType);
                                                }}
                                            />
                                        </div>
                                    </div>
                                )}

                                {GuestFuelTypes.length > 0 && (
                                    <div className="form-row mb-3">
                                        <label className="popup-inner-title m-0">{t("fuel")}</label>
                                        <div className="custom-dropdown modal-dropdown mb-3" style={{ position: "relative" }}>
                                            <CustomSearchableDropdown
                                                items={GuestFuelTypes}
                                                value={selectedGuestFuelType?.Id ?? GuestFuelTypes[0]?.Id ?? ""}
                                                labelKey="Name"
                                                valueKey="Id"
                                                searchable={false}
                                                placeholder={t("fuel")}
                                                disabled={!GuestFuelTypes.length}
                                                onChange={(value) => {
                                                    const fuelType = GuestFuelTypes.find((f) => String(f.Id) === String(value)) || null;
                                                    setSelectedGuestFuelType(fuelType);
                                                }}
                                            />
                                        </div>
                                    </div>
                                )}

                                {GuestAccessibleTypes.length > 0 && (
                                    <div className="form-row mb-3">
                                        <label className="popup-inner-title m-0">{t("VehicleTypeReducedMobility")}</label>
                                        <div className="custom-dropdown modal-dropdown mb-3" style={{ position: "relative" }}>
                                            <CustomSearchableDropdown
                                                items={[{ Id: 0, Name: "--" }, ...GuestAccessibleTypes]}
                                                value={selectedGuestAccessibleType?.Id ?? 0}
                                                labelKey="Name"
                                                valueKey="Id"
                                                searchable={false}
                                                placeholder={`${t("VehicleTypeReducedMobility")}`}
                                                disabled={!GuestAccessibleTypes.length}
                                                onChange={(value) => {
                                                    const accessibleType = Number(value) === 0
                                                        ? null
                                                        : GuestAccessibleTypes.find((item) => String(item.Id) === String(value)) || null;
                                                    setSelectedGuestAccessibleType(accessibleType);
                                                }}
                                            />
                                        </div>
                                    </div>
                                )}

                                {GuestShareableTypes.length > 0 && (
                                    <div className="form-row mb-3">
                                        <label className="popup-inner-title m-0">{t("label_shareable_category")}</label>
                                        <div className="custom-dropdown modal-dropdown mb-3" style={{ position: "relative" }}>
                                            <CustomSearchableDropdown
                                                items={[{ Id: 0, Name: "--" }, ...GuestShareableTypes]}
                                                value={selectedGuestShareableType?.Id ?? 0}
                                                labelKey="Name"
                                                valueKey="Id"
                                                searchable={false}
                                                placeholder={`${t("label_shareable_category")}`}
                                                disabled={!GuestShareableTypes.length}
                                                onChange={(value) => {
                                                    const shareableType = Number(value) === 0
                                                        ? null
                                                        : GuestShareableTypes.find((item) => String(item.Id) === String(value)) || null;
                                                    setSelectedGuestShareableType(shareableType);
                                                }}
                                            />
                                        </div>
                                    </div>
                                )}

                                <div className="tags-btn mt-4">
                                    <button
                                        type="button"
                                        className="w-100 min-height-56 selected"
                                        onClick={() => {
                                            const isValid = validateGuestFields({
                                                name: guestNameHourly,
                                                surname: guestLastNameHourly,
                                                email: guestEmailHourly
                                            }, "hourly");

                                            if (!isValid) {
                                                return;
                                            }
                                            setShowGuestPopupHourly(false);
                                            sendBookingHourly({
                                                nameHourly: guestNameHourly,
                                                lastnameHourly: guestLastNameHourly,
                                                emailHourly: guestEmailHourly,
                                                identificatoinHourly: identificatoinHourly,
                                                vehicleRegistrationNumberHourly: vehicleRegistrationNumberHourly
                                            });
                                        }}
                                    >
                                        {t("confirm")}
                                    </button>
                                </div>
                                <div className="main-btn outline-gray-btn w-100 mw-100 min-height-56 mt-3">
                                    <a
                                        onClick={() => setShowGuestPopupHourly(false)}
                                    >
                                        {t("cancel")}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {showAdditionalBooking && selectedSpot && (
                <BookAdditionalTimeModal
                    onCancel={() => {
                        setShowAdditionalBooking(false);
                        // setShowCancelModal(true);
                        setShowCancelModalfor30mit(true)
                    }}
                    onBookAdditional={() => {
                        setShowAdditionalBooking(false);
                        setShowModal(true);
                    }}
                />
            )}

            {showReleaseAdditionalBooking && selectedSpot && (
                <BookAdditionalTimeModal
                    onCancel={() => {
                        setShowReleaseAdditionalBooking(false);
                        setShowCancelModal(!releaseIs30MinSpot);
                        setShowCancelModalfor30mit(releaseIs30MinSpot);
                    }}
                    onBookAdditional={() => {
                        setShowReleaseAdditionalBooking(false);
                        resetDraftBookingDate(bookingDate);
                        setShowModal(true);
                    }}
                />
            )}

            {guestBookingConfirmation && (
                <div className="modal" style={{ display: 'block', backgroundColor: 'rgba(217, 217, 217, 0.59)' }}>
                    <div className="modal-dialog modal-dialog-centered modal-custom-width">
                        <div className="modal-content modal-radius">
                            <div className="modal-body">
                                <div className="close-modal">
                                    <img
                                        src={Close}
                                        alt="Close"
                                        style={{ cursor: "pointer" }}
                                        onClick={closeGuestBookingConfirmation}
                                    />
                                </div>
                                <div className="pt-4">
                                    <h5 className="popup-title">{t("your_booking_is_confirmed")}</h5>
                                </div>
                                <div className="divider-line mt-3"></div>
                                <div className="modal-des">
                                    <div className="">
                                        <div className="icon-with-list mb-3">
                                            <div className="icon-wrap">
                                                <img src={Images.Participant} />
                                                <h4 className="ps-1 ms-1">{guestBookingConfirmation.name}</h4>
                                            </div>
                                            <div className="icon-wrap">
                                                <img src={Images.CalendarMenu} alt="repeat" />
                                                <h4 className="ps-1 ms-1">{formatDateToEEEddMMM(guestBookingConfirmation.bookedDate)}</h4>
                                            </div>

                                            {guestBookingConfirmation.startTime && guestBookingConfirmation.endTime && (
                                                <div className="icon-wrap">
                                                    <img src={Images.TimeIcon} alt="time" />
                                                    <h4 className="ps-1 ms-1">
                                                       {t("from")}: <span>{guestBookingConfirmation.startTime}</span> {t("react_to")}: <span>{guestBookingConfirmation.endTime}</span>
                                                    </h4>
                                                </div>
                                            )}

                                            <div className="icon-wrap">
                                                <img src={Images.ZoneMap} alt="map" />
                                                <h4 className="ps-1 ms-1">{guestBookingConfirmation.zoneName} <span>{guestBookingConfirmation.spotName}</span></h4>
                                            </div>
                                            {/* {guestBookingConfirmation.spotName && (
                                                <div className="icon-wrap">
                                                    <img src={Images.ModalTag} alt="spot" />
                                                    <h4 className="ps-1 ms-1">{guestBookingConfirmation.spotName}</h4>
                                                </div>
                                            )} */}
                                            <div className="text-center mt-5 mb-2">
                                                <img src={guestConfirmation} alt="" />
                                            </div>
                                        </div>
                                        {/* <div className="me-4 mt-3">
                                            <button
                                                type="button"
                                                className="w-100 mw-100 min-height-56 main-btn cancel-btn"
                                                onClick={closeGuestBookingConfirmation}
                                            >
                                                {t("ok")}
                                            </button>
                                        </div> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {showPostbookingQueModal && (
                <PostbookingQueModal
                    questions={postbookingQueModalData}
                    onClose={async () => {
                        setShowPostbookingQueModal(false)
                        await refreshZoneAfterBooking(selectedZone, activeBookingDate);
                    }}
                    onSubmit={async () => {
                        setShowPostbookingQueModal(false);
                        await refreshZoneAfterBooking(
                            selectedZone,
                            activeBookingDate
                            // formatDate(selectedDate)
                        );
                    }}
                    postRequestParams={postRequestParams}
                    selectedBookingDate={postRequestParams?.ClaimDate}
                />
            )}

            {showLeaveQueueModal && selectedSpot && (
                <div>
                    {/* <ModalContent> */}
                    {
                        <div>
                            <div className="modal modalscroll" style={{ display: 'block', backgroundColor: 'rgba(217, 217, 217, 0.59)' }}
                                id="dateModal" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="dateModalLabel" aria-hidden="true"
                            >
                                <div className="modal-dialog modal-dialog-centered modal-custom-width">
                                    <div className="modal-content modal-radius">
                                        <div className="modal-body">

                                            <div className="close-modal">
                                                <a >
                                                    <img src={Close} aria-label="Close" onClick={resetForm} />
                                                </a>
                                            </div>
                                            <div className="pt-4">
                                                {queuePositoin == 0 &&
                                                    <h5 className="popup-title">{t("react_you_are_on_waitlist")} </h5>
                                                }
                                                {queuePositoin > 0 &&
                                                    <h5 className="popup-title">{t("react_waitlist_position")}
                                                        <span style={{ color: "black" }}> {queuePositoin} </span>
                                                        {t("react_on_the_waitlist")}
                                                    </h5>
                                                }
                                            </div>
                                            <div className="date-with-credit d-flex align-items-center justify-content-between pt-2">
                                                <div id="selectedDate" className="selected-current-date">
                                                    <span>{dateforfullday}</span>
                                                    <span>{monthforfullday} {yearforfullday}</span>
                                                </div>
                                                {zoneCreditValue > 0 && (
                                                    <div className="credit-info">
                                                        {/* {creditInfoJSX} */}
                                                        <a
                                                            className="orange-outline-with-icon"
                                                        >
                                                            {/* {CreditValueGrey ?
                                                                    (
                                                                        <>
                                                                            <img src={GrayStar} alt="star" />
                                                                            <span>{individualDayCost}</span>
                                                                        </>
                                                                    )
                                                                    :
                                                                    <>
                                                                        <img src={Images.OrangeStar} alt="" />
                                                                        
                                                                    <span>
                                                                        {Number(individualDayCost) > 0
                                                                            ? `+${individualDayCost}`
                                                                            : individualDayCost}
                                                                    </span>
                                                                    </>
                                                                } */}
                                                            {isZeroDisplayCredit ? (
                                                                <>
                                                                    <img src={GrayStar} alt="star" className="img-fluid" />
                                                                    <span>{displayCreditValue}</span>
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <img src={Images.OrangeStar} alt="star" className="img-fluid" />
                                                                    <span>
                                                                        {`+${displayCreditValue}`}
                                                                    </span>
                                                                </>
                                                            )}
                                                        </a>
                                                    </div>
                                                )}
                                            </div>
                                            {/* <div className="modal-body">
                                                    <p>{t("react_you_are_on_waitlist")} <b>{selectedSpot.SpotName}</b>?</p>
                                                </div> */}

                                            <div className="divider-line mt-3"></div>
                                            <div className="modal-des">
                                                <div className="modal-scroll-inner me-4">
                                                    {/* Zone name */}

                                                    <div className="icon-with-list mb-3">
                                                        <div className="icon-wrap">
                                                            <img src={Images.Map} alt="map" />
                                                            <h4 className="ps-1 ms-1">{selectedZone.ZoneName}</h4>
                                                        </div>

                                                        {/* All day booking  */}
                                                        <div className="icon-wrap">
                                                            <img src={Images.TimeIcon} alt="repeat" />
                                                            <h4 className="ps-1 ms-1">
                                                                {t("all_day")} <span>  {formatDateToEEEddMMM(bookingDate)}</span>
                                                            </h4>
                                                        </div>
                                                        <div className="icon-wrap">
                                                            <img src={Images.Participant} />
                                                            <h4 className="ps-1 ms-1">{bookingModalParticipantName}</h4>
                                                        </div>
                                                    </div>
                                                    <div className="modal-tag">
                                                        {selectedSpot.SpotTagList && selectedSpot.SpotTagList.length > 0 && (
                                                            <div className="modal-tag">
                                                                <button
                                                                    type="button"
                                                                    id="show-tag-tab"
                                                                    className={showTags ? "active" : ""}
                                                                    onClick={() => setShowTags(!showTags)} // Toggle the state on click
                                                                >
                                                                    <img src={Images.ModalTag} className="img-fluid" alt="Tags" />
                                                                    <span className="show-link">{t("show_tags")}</span>
                                                                    <span className="hide-link">{t("react_hide_tags")}</span>
                                                                    {/* {showTags ? 'Hide Tags' : 'Show Tags'} */}
                                                                </button>
                                                            </div>
                                                        )}
                                                        {/* </div> */}

                                                        {/* 2. Conditionally display the Spot Tags list */}
                                                        {showTags && selectedSpot.SpotTagList && (
                                                            <div id="all-tags" className={showTags ? "show" : ""}>
                                                                {selectedSpot.SpotTagList.map((tag, index) => (
                                                                    <button type="button" key={index}>
                                                                        {tag.TagName}
                                                                    </button>
                                                                ))}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="me-4 mt-3">
                                                {/* <button type="button" className="btn btn-secondary" onClick={() => setShowCancelModal(false)}>
                                                Close
                                            </button> */}
                                                <button
                                                    type="button"
                                                    className="green-outline-with-icon w-100 mw-100 min-height-56"
                                                    onClick={() => {
                                                        // Call your cancel API here
                                                        // setShowCancelModal(false);
                                                        // Fix: Ensure variables are defined before calling CancelBooking
                                                        CancelBookingLeaveQueue(
                                                            selectedZone?.Id || (selectedSpot && selectedSpot.ZoneId) || 0,
                                                            bookingDate || (selectedSpot && selectedSpot.BookingDate) || formatDate(new Date()),
                                                            selectedSpot?.SpotId || 0
                                                        );
                                                    }}>
                                                    <img src={LeaveQueueIcon} alt="Cancel" />
                                                    <span>{t("react_leave_waitlist")} </span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    {/* </ModalContent> */}
                </div>
            )}

            {showJoinQueueModal && selectedSpot && (
                <div>
                    {/* <ModalContent> */}
                    {
                        <div>
                            <div className="modal modalscroll" style={{ display: 'block', backgroundColor: 'rgba(217, 217, 217, 0.59)' }}
                                id="dateModal" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="dateModalLabel" aria-hidden="true"
                            >
                                <div className="modal-dialog modal-dialog-centered modal-custom-width">
                                    <div className="modal-content modal-radius">
                                        <div className="modal-body">
                                            <div className="close-modal">
                                                <a >
                                                    <img src={Close} alt="Close" onClick={resetForm} />
                                                </a>
                                            </div>
                                            <div className="pt-4">
                                                <h5 className="popup-title">{t("react_calendar_new_booking")}
                                                    {/* {formatDateToEEEddMMM(bookingDate)} */}
                                                </h5>
                                            </div>
                                            <div className="date-with-credit d-flex align-items-center justify-content-between pt-2">
                                                <div id="selectedDate" className="selected-current-date">
                                                    <span>{dateforfullday}</span>
                                                    <span>{monthforfullday} {yearforfullday}</span>
                                                </div>
                                                {zoneCreditValue > 0 && (
                                                    <div className="credit-info">
                                                        {/* {creditInfoJSX} */}
                                                        <a
                                                            className="orange-outline-with-icon"
                                                        >
                                                            {CreditValueGrey ?
                                                                (
                                                                    <>
                                                                        <img src={GrayStar} alt="star" />
                                                                        <span>{individualDayCost}</span>
                                                                    </>
                                                                )
                                                                :
                                                                <>
                                                                    <img src={Images.OrangeStar} alt="" />
                                                                    <span>
                                                                        {/* {(`-${individualDayCost}`)} */}
                                                                        {Number(individualDayCost) > 0
                                                                            ? `-${individualDayCost}`
                                                                            : individualDayCost}
                                                                    </span>
                                                                </>
                                                            }
                                                        </a>
                                                    </div>
                                                )}
                                            </div>
                                            <form onSubmit={e => {
                                                let errors = {};
                                                if (!selectedSpot) {
                                                    errors.spot = "Please select a spot.";
                                                }
                                                if (spotBookingSlots && spotBookingSlots.length > 0 && !selectedSlot) {
                                                    errors.spot = "Please select a Spot.";
                                                }
                                                if (vehiclesForSpot && vehiclesForSpot.length > 0 && !selectedVehicle) {
                                                    errors.vehicle = "Please select a vehicle.";
                                                }
                                                // Add more field checks as needed
                                                if (Object.keys(errors).length > 0) {
                                                    e.preventDefault();
                                                    setRequiredFields(errors);
                                                    return;
                                                }
                                                setRequiredFields({});
                                                // Call your submit function here
                                                Submit_JoinQueue(e)
                                            }}>
                                                <div className="divider-line mt-3"></div>
                                                <div className="modal-des">
                                                    <div className="modal-scroll-inner me-4">

                                                        <div className="icon-with-list mb-3">
                                                            {/* Zone name */}
                                                            {/* <div className="icon-wrap">
                                                        <img src={Images.Map} alt="map" />
                                                        <h4 className="ps-1 ms-1">{selectedZone.ZoneName}</h4>
                                                    </div> */}
                                                            {/* All day booking  */}
                                                            {/* <div className="icon-wrap">
                                                         <img src={Images.TimeIcon} alt="repeat" />
                                                        <h4 className="ps-1 ms-1">
                                                            {t("all_day")} {formatDateToEEEddMMM(bookingDate)}
                                                        </h4>
                                                    </div> */}
                                                            <div className="icon-wrap">
                                                                <img src={Images.Participant} />
                                                                <h4 className="ps-1 ms-1">{bookingModalParticipantName}</h4>
                                                            </div>
                                                        </div>

                                                        <div className="modal-tag">
                                                            {selectedSpot.SpotTagList && selectedSpot.SpotTagList.length > 0 && (
                                                                <div className="modal-tag">
                                                                    <button
                                                                        type="button"
                                                                        id="show-tag-tab"
                                                                        className={showTags ? "active" : ""}
                                                                        onClick={() => setShowTags(!showTags)} // Toggle the state on click
                                                                    >
                                                                        <img src={Images.ModalTag} className="img-fluid" alt="Tags" />
                                                                        <span className="show-link">{t("show_tags")}</span>
                                                                        <span className="hide-link">{t("react_hide_tags")}</span>
                                                                        {/* {showTags ? 'Hide Tags' : 'Show Tags'} */}
                                                                    </button>
                                                                </div>
                                                            )}
                                                            {/* </div> */}

                                                            {/* 2. Conditionally display the Spot Tags list */}
                                                            {showTags && selectedSpot.SpotTagList && (
                                                                <div id="all-tags" className={showTags ? "show" : ""}>
                                                                    {selectedSpot.SpotTagList.map((tag, index) => (
                                                                        <button type="button" key={index}>
                                                                            {tag.TagName}
                                                                        </button>
                                                                    ))}
                                                                </div>
                                                            )}
                                                        </div>

                                                        {vehiclesForSpot.length > 0 && (
                                                            <div className="custom-dropdown modal-dropdown mb-3">
                                                                <CustomSearchableDropdown
                                                                    items={vehiclesForSpot}
                                                                    // The current selected ID
                                                                    value={selectedVehiclePrimaryKey}
                                                                    // The key from your data to show in the list (Registration ID)
                                                                    labelKey="VehicleRegistrationId"
                                                                    // The key from your data used as the unique ID
                                                                    valueKey="VehiclePrimaryKey"
                                                                    searchable={false}
                                                                    placeholder="Select Vehicle"
                                                                    disabled={!vehiclesForSpot.length}
                                                                    onChange={(pk) => {
                                                                        // 1. Update the Primary Key state
                                                                        setSelectedVehiclePrimaryKey(pk);

                                                                        // 2. Find the full vehicle object and update it
                                                                        const vehicleObj = vehiclesForSpot.find(v => v.VehiclePrimaryKey === pk);
                                                                        setSelectedVehicle(vehicleObj);

                                                                        // 3. Close the validation error for 'vehicle'
                                                                        setRequiredFields(prev => ({
                                                                            ...prev,
                                                                            vehicle: ""
                                                                        }));

                                                                        // Optional: Debugging logs
                                                                        if (vehicleObj) {
                                                                            console.log("Vehicle Selected:", vehicleObj.VehicleRegistrationId);
                                                                            console.log("PK:", pk);
                                                                        }
                                                                    }}
                                                                />
                                                            </div>
                                                        )
                                                        }
                                                        {/* {vehiclesForSpot.length > 0 && (
                                                        <div
                                                            className=""
                                                            style={{ position: "relative" }}
                                                        >
                                                            <label htmlFor=""></label>
                                                            <div
                                                                role="button"
                                                                onClick={() => setVehicleOpen(!vehicleOpen)}
                                                                className="dropdown-toggle form-control position-relative custom-dropdown-btn ctm-select"
                                                                style={{
                                                                    display: "flex",
                                                                    justifyContent: "space-between",
                                                                    cursor: "pointer",
                                                                }}
                                                            >

                                                                <div className="d-flex flex-column">
                                                                    <p className="sub-dropdown-name">Vehicle</p>
                                                                    <span
                                                                        style={{
                                                                            fontSize: "16px",
                                                                            fontWeight: "bold",
                                                                            color: "#1c988a",
                                                                        }}
                                                                    >
                                                                        {selectedVehicle?.VehicleRegistrationId || vehiclesForSpot[0]?.VehicleRegistrationId}
                                                                    </span>
                                                                </div>
                                                            </div>

                                                            {vehicleOpen && (
                                                                <div
                                                                    style={{
                                                                        position: "absolute",
                                                                        top: "calc(100% + 6px)",
                                                                        left: 0,
                                                                        width: "100%",
                                                                        background: "#fff",
                                                                        borderRadius: 12,
                                                                        boxShadow: "0 10px 30px rgba(0,0,0,.15)",
                                                                        maxHeight: 300,
                                                                        overflowY: "auto",
                                                                        zIndex: 9999,
                                                                    }}
                                                                >
                                                                    {vehiclesForSpot.map((v) => (
                                                                        <div
                                                                            key={v.VehiclePrimaryKey}
                                                                            onClick={() => {
                                                                                const pk = v.VehiclePrimaryKey;

                                                                                setSelectedVehiclePrimaryKey(pk);
                                                                                setSelectedVehicle(v);
                                                                                setVehicleOpen(false);

                                                                                setRequiredFields(prev => ({
                                                                                    ...prev,
                                                                                    vehicle: ""
                                                                                }));

                                                                                console.log("Spot +++++:", selectedSpot?.SpotName);
                                                                                console.log("Registration +++++:", v.VehicleRegistrationId);
                                                                                console.log("FuelId: ++++", v.FuelId);
                                                                                console.log("VehiclePrimaryKey +++++++:", v.VehiclePrimaryKey);
                                                                            }}
                                                                            style={{
                                                                                padding: "8px 12px",
                                                                                display: "flex",
                                                                                alignItems: "center",
                                                                                cursor: "pointer",
                                                                            }}
                                                                        >
                                                                            <input
                                                                                type="radio"
                                                                                checked={selectedVehiclePrimaryKey === v.VehiclePrimaryKey}
                                                                                readOnly
                                                                                style={{
                                                                                    marginRight: 8,
                                                                                    accentColor: "#1c988a",
                                                                                }}
                                                                            />
                                                                            <span>{v.VehicleRegistrationId}</span>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            )}
                                                        </div>
                                                    )} */}
                                                        {requiredFields.vehicle && (
                                                            <div style={{ color: 'red', marginTop: 8, fontSize: 14 }}>{requiredFields.vehicle}</div>
                                                        )}

                                                        {/* {zoneData.ZoneType== 1 ? } */}

                                                        <div className="participants-list ctm-checklist pt-0">
                                                            {!!preBookinQueCanvas && (
                                                                <div className="form-check">
                                                                    <input
                                                                        className="form-check-input"
                                                                        type="checkbox"
                                                                        id={`preBookinQueCanvas`}
                                                                        checked={checkedPreBookingQue}
                                                                        onChange={(e) => setCheckedPreBookingQue(e.target.checked)}
                                                                    />

                                                                    <label
                                                                        className="form-check-label ms-2"
                                                                        htmlFor={`preBookinQueCanvas`}
                                                                    >
                                                                        <span dangerouslySetInnerHTML={{ __html: safeHtml }} />

                                                                    </label>
                                                                </div>
                                                            )}
                                                        </div>

                                                        <div className="text-center my-34">
                                                            {zoneData.ZoneType == 1 ?
                                                                <img src={ParkingIcon} className="img-fluid" alt="Parking Booking" />
                                                                : <img src={DeskIcon} className="img-fluid" alt="Desk Booking" />
                                                            }
                                                        </div>
                                                        {/* <div className="tags-btn me-4 mt-3">
                                                                <button
                                                                    type="submit"
                                                                    className="w-100 min-height-56 selected"
                                                                    disabled={loading}
                                                                >
                                                                    {loading ? <div id='preloader'>
                                                                        <img src={LoaderFull} alt="Loading" />
                                                                    </div> : "Confirm"}
                                                                </button>
                                                            </div> */}
                                                    </div>
                                                </div>
                                                <div className="tags-btn me-4 mt-3">
                                                    <button
                                                        type="submit"
                                                        className="green-outline-with-icon w-100 mw-100 min-height-56"
                                                        // Button is disabled if:
                                                        // 1. Loading is true
                                                        // 2. OR (The question exists AND it is NOT checked)
                                                        disabled={loading || (!!preBookinQueCanvas && !checkedPreBookingQue)}
                                                        style={{
                                                            // Optional: add a visual cue for disabled state
                                                            opacity: (loading || (!!preBookinQueCanvas && !checkedPreBookingQue)) ? 0.5 : 1,
                                                            cursor: (loading || (!!preBookinQueCanvas && !checkedPreBookingQue)) ? "not-allowed" : "pointer"
                                                        }}
                                                    >
                                                        {loading ? (
                                                            <div id='preloader'>
                                                                <img src={LoaderFull} alt="Loading" />
                                                            </div>
                                                        ) : (
                                                            <div>
                                                                <img src={JoinQueueIcon} alt="Join" className="me-2" />
                                                                <span>{t("is_queue_status")} </span>
                                                            </div>
                                                        )}
                                                    </button>
                                                </div>
                                                {/* <div className="tags-btn me-4 mt-3">
                                                                <button
                                                                    type="button"
                                                                    className="w-100 min-height-56"
                                                                    onClick={closeModal}>
                                                                    Cancel
                                                                </button>
                                                            </div> */}

                                                {/* {bookingtimeSlots.length > 0 && (
                                            <div>
                                                <label>Select Time Slot</label>
                                                <select>
                                                    <option value="">Select Slot</option>
                                                    {bookingtimeSlots.map((slot, i) => (
                                                        <option key={i} value={slot}>{slot}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        )} */}
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    {/* /</ModalContent> */}
                </div>
            )}

            {roleInfoSpot && (
                <Modal onClick={() => setRoleInfoSpot(null)}>
                    <ModalContent onClick={(event) => event.stopPropagation()}>
                        <h3>{t("react_employee_roles")}</h3>
                        <p><strong>{roleInfoSpot.SpotName}</strong></p>
                        {roleInfoSpot.EmployeeRoleIconList?.length ? (
                            <IconTable>
                                <thead>
                                    <tr>
                                        <th>{t("role")}</th>
                                        <th>{t("role_name")}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {roleInfoSpot.EmployeeRoleIconList.map((role, index) => (
                                        <tr key={role.Id || index}>
                                            <td>
                                                <img src={role.IconImage} alt="icon" />
                                            </td>
                                            <td>{role.Name}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </IconTable>
                        ) : (
                            <p>{t("no_data_found")}</p>
                        )}
                    </ModalContent>
                </Modal>
            )}

            {meetingInfoSpot && (
                <Modal onClick={() => setMeetingInfoSpot(null)}>
                    <ModalContent onClick={(event) => event.stopPropagation()}>
                        <h3>{meetingInfoSpot.SpotName}</h3>
                        {meetingInfoSpot.MeetingRoomBookingList?.length ? (
                            <TooltipTable>
                                <thead>
                                    <tr>
                                        <th>{t("Organizer")}</th>
                                        <th>{t("time")}</th>
                                        <th>{t("name")}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {meetingInfoSpot.MeetingRoomBookingList.map((booking) => (
                                        <tr key={booking.Id}>
                                            <td>{booking.OrganiserName}</td>
                                            <td>{booking.StartTime} - {booking.EndTime}</td>
                                            <td>{booking.Title}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </TooltipTable>
                        ) : (
                            <p>{t("no_data_found")}</p>
                        )}
                    </ModalContent>
                </Modal>
            )}

            {showBookingProcess && (
                <LoadingProcessModal
                />
            )}
        </div>
    );
}
/* Styled Components */
const CanvasContainer = styled.div`
    position: relative;
    width: ${({ width }) => width}px;
    height: ${({ height }) => height}px;
    background-image: ${({ $backgroundImage }) => `url(${$backgroundImage})`};
    background-size: cover;
    background-position: center;
    border: 1px solid #ccc;
    overflow: hidden;
    background-color: transparent;
    padding: 10px;
`;

const CanvasOuter = styled.div`
  width: 100vw;
  height: 100vh;
  overflow: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f4f4f4;
`;

const CanvasScaler = styled.div`
  transform: scale(${({ scale }) => scale});
  transform-origin: top left;
`;


// const SpotBox = styled.div`
//   position: absolute;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   overflow: hidden; /* Ensures stripes don't leak outside the border */
//   padding: 0 !important; /* Forces background to touch the blue borders */
//   box-sizing: border-box;
// `;



// const SpotImage = styled.img`
//     position: absolute;
//     width: 100%;
//     height: 100%;
//     object-fit: contain;
//     pointer-events: none;
// `;

const SpotHoverContainer = styled.div`
  position: absolute;
  overflow: visible;
  box-sizing: border-box;
  z-index: 0;

  &:hover {
    z-index: 9999;
  }
`;

const SpotBox = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  overflow: visible;
  box-sizing: border-box;
  z-index: 0;
`;

const SpotImage = styled.img`
  position: absolute;
  width: 100%;
  height: 100%;
  /* Use cover if you want stripes to fill the box, 
     contain if you want the whole icon visible */
  object-fit: fill; 
  pointer-events: none;
  z-index: 2;
`;

// const SpotNameWrapper = styled.div`
//   position: absolute;
//   z-index: 10;
//   width: 100%; /* Leave room for stripes at the edges */
//   display: flex;
//   justify-content: center;
//   align-items: center;

//   /* This creates the "Banner" effect seen in your D-1hour images */
//   background-color: ${props => props.isPartiallyBooked ? "rgba(255, 255, 255, 0.9)" : "transparent"};
// //   padding: 2px 4px;
// //   border-radius: 4px;
// `;

const SpotNameWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 3;
  width: 100%;
  max-width: 100%;
  max-height: 100%;
//   display: flex;
  /* 'safe' ensures that if the text overflows, it aligns to the start 
     so the first letter isn't cut off */
//   justify-content: safe center; 
//   align-items: center;
  text-align: center;
  overflow: hidden;
  /* Use nowrap to keep the word on one line if you want to see the 
     full initial word at 40px */
//   white-space: nowrap; 
  
  /* Adds "..." if the word is still too long, but keeps the start visible */
//   text-overflow: ellipsis; 
  
  box-sizing: border-box;
  pointer-events: none;
`;

const SpotName = styled.div`
  position: absolute;
  /* Center it exactly */
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  
  /* Force it to the front */
  z-index: 20 !important; 
  
  /* Size constraints */
  width: 90%;
  max-height: 80%;
  
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-weight: 600;
  
  /* Text handling */
  overflow: hidden;
  word-break: break-all;
  line-height: 1;
  pointer-events: none;
`;

const SpotLoadingOverlay = styled.div`
  position: absolute;
  inset: 0;
  z-index: 30;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.65);
  pointer-events: none;

  img {
    width: 32px;
    height: 32px;
    object-fit: contain;
  }
`;


const RoleIcon = styled.img`
    position: absolute;
    width: 22px;
    height: 22px;
    top: 2px;
    right: 2px;
    z-index: 2;
`;


const SpotLabel = styled.div`
    font-size: 10px;
    text-align: center;
    user-select: none;

      ${({ hasStripedImage }) =>
        hasStripedImage &&
        `
      background: rgba(255, 255, 255, 0.85);
      padding: 4px 8px;
      border-radius: 6px;
      box-shadow: 0 2px 6px rgba(0,0,0,0.2);
    `}
`;

const Modal = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
`;

const ModalContent = styled.div`
    // background-color: white;
    // padding: 20px;
    // border-radius: 5px;
    // text-align: center;
    // box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    // h3 { margin-bottom: 10px; }
    // button { margin: 5px; padding: 10px 20px; border: none; border-radius: 5px; cursor: pointer; }
    // button:first-child { background-color: #f44336; color: white; }
    // button:last-child { background-color: #4caf50; color: white; }
    //  background: white;
  border-radius: 10px;
  width: 600px;
  max-height: 90vh;
  overflow-y: auto;
  padding: 20px;
    h3 {
    margin-bottom: 10px;
  }
  button {
    margin: 5px;
    padding: 10px 20px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
  }
  button:first-child {
    background-color: #4caf50;
    color: white;
  }
  button:last-child {
    background-color: #f44336;
    color: white;
  }
`;

const MapLoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 300px;
`;

const MapErrorContainer = styled(MapLoadingContainer)`
  color: red;
`;


const RoleIconWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  display: flex;
  align-items: center;
  justify-content: center;

  max-width: 30%;
  max-height: 30%;
  z-index: 9;
  pointer-events: auto;
`;
const RoleTooltipTable = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  background: white;
  border: 1px solid #DFDFE5;
  border-radius: 6px;
  box-shadow: 0px 20px 20px 0px #00000014;
  padding: 8px;
  z-index: 99999;
  min-width: 180px;
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.2s ease;
  pointer-events: none;

  /* Show table when the Wrapper is hovered */
  ${RoleIconWrapper}:hover & {
    visibility: visible;
    opacity: 1;
  }
`;

const IconTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 11px;

  th {
    text-align: left;
    color: #1c988a;
    border-bottom: 1px solid #e6f4f2;
    padding-bottom: 4px;
  }

  td {
    padding: 5px 0;
    border-bottom: 1px solid #f9f9f9;
    vertical-align: middle;
  }

  img {
    width: 18px;
    height: 18px;
    margin-right: 8px;
    object-fit: contain;
  }
`;
const TooltipWrapper = styled.div`
  position: absolute;
  top:100%;
left:-100%;
  //   top: ${({ $variant }) => ($variant === "meeting" ? "0" : "100%")};
//   left: ${({ $variant }) => ($variant === "meeting" ? "calc(100% + 12px)" : "50%")};
  transform: ${({ $variant }) => ($variant === "meeting" ? "none" : "translateX(-50%)")};
  background: white;
  border: 1px solid #DFDFE5;
  border-radius: 8px;
  box-shadow: 0px 20px 20px 0px #00000014;

  padding: ${({ $variant }) => ($variant === "meeting" ? "12px 14px" : "10px")};
  z-index: 999999; /* Ensure it's above everything */
//   min-width: ${({ $variant }) => ($variant === "meeting" ? "300px" : "300px")};
    min-width: max-content;
    width:100%;
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.2s ease-in-out;
  pointer-events: none;

  ${({ $variant }) =>
        $variant === "meeting"
            ? `
    ${SpotHoverContainer}:hover & {
      visibility: visible;
      opacity: 1;
    }
  `
            : `
    ${SpotBox}:hover & {
      visibility: visible;
      opacity: 1;
    }
  `}
`;

const TooltipTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 11px;
  
  th {
    text-align: left;
    color: #1c988a;
    border-bottom: 2px solid #e6f4f2;
    padding: 6px 10px;
  }

  td {
    padding: 6px 10px;
    border-bottom: 1px solid #eee;
    color: #333;
    vertical-align: top;
  }

  tr:last-child td {
    border-bottom: none;
  }
`;

const MeetingTitleText = styled.span`
  display: inline-block;
//   max-width: 180px;
//   white-space: nowrap;
//   overflow: hidden;
//   text-overflow: ellipsis;
//   vertical-align: top;
`;


// import React, { useState } from "react";
// import styled from "styled-components";
// import Sidebar from "../Sidebar/Sidebar";
// import Header from "../Header/Header";
// import HeaderFilter from "../Header/HeaderFilter";

// export default function MapCanvasZone({ zoneData, selectedZone }) {
//     const [selectedSpot, setSelectedSpot] = useState(null);
//     const [showModal, setShowModal] = useState(false);

//     if (!zoneData)
//         return <div className="text-center mt-5">No Canvas Data Available</div>;

//     const handleSpotClick = (spot) => {
//         setSelectedSpot(spot);
//         setShowModal(true);
//     };

//     const closeModal = () => {
//         setShowModal(false);
//         setSelectedSpot(null);
//     };

//     const isSpotClickable = (spot) =>
//         spot.SpotType === 3 || spot.HourlySpot === 1 || spot.IsHourlySpotAvailable === 1;

//     return (
//         <div className="content-area">
//             {/* <Header /> */}
//             <div className="component-area">
//                 {/* <Sidebar /> */}
//                 <div className="pt-96 pb-96 my-container active-cont">
//                     <div className="container">
//                         {/* <HeaderFilter /> */}

//                         <CanvasContainer
//                             width={zoneData.ZoneImageWidth}
//                             height={zoneData.ZoneImageHeight}
//                             backgroundImage={zoneData.ZoneImage}
//                         >
//                             {zoneData?.Layout?.length ? (
//                                 zoneData.Layout.map((spot, index) => {
//                                     if (spot.ViewFlag !== 1) return null;

//                                     const displayName =
//                                         spot.FullName || spot.SpotName || `Spot ${index + 1}`;

//                                     return (
//                                         <SpotBox
//                                             key={spot.SpotId || index}
//                                             onClick={() =>
//                                                 isSpotClickable(spot) && handleSpotClick(spot)
//                                             }
//                                             style={{
//                                                 left: `${spot.Xaxis}px`,
//                                                 top: `${spot.Yaxis}px`,
//                                                 width: `${spot.Width}px`,
//                                                 height: `${spot.Height}px`,
//                                                 backgroundColor:
//                                                     spot.BackgroundColorForWeb ||
//                                                     spot.BackgroundColor,
//                                                 borderColor:
//                                                     spot.BorderColor ||
//                                                     spot.BackgroundColor ||
//                                                     "#333",
//                                                 transform: `rotate(${spot.Angle}deg)`,
//                                                 cursor: isSpotClickable(spot)
//                                                     ? "pointer"
//                                                     : "default",
//                                             }}
//                                         >
//                                             <SpotLabel>
//                                                 {displayName}
//                                             </SpotLabel>
//                                         </SpotBox>
//                                     );
//                                 })
//                             ) : (
//                                 <div>No spots available</div>
//                             )}
//                         </CanvasContainer>
//                     </div>
//                 </div>
//             </div>

//             {/* ✅ Modal */}
//             {showModal && selectedSpot && (
//                 <Modal>
//                     <ModalContent>
//                         {selectedSpot.FacingStyle === "meeting_room" ? (
//                             <>
//                                 <h3>Meeting Room Booking</h3>
//                                 <p>
//                                     Do you want to book the meeting room:{" "}
//                                     <strong>{selectedSpot.SpotName}</strong>?
//                                 </p>
//                             </>
//                         ) : (
//                             <>
//                                 <h3>Confirm Booking</h3>
//                                 <p>
//                                     Are you sure you want to book the spot:{" "}
//                                     <strong>{selectedSpot.SpotName}</strong>?
//                                 </p>
//                             </>
//                         )}
//                         <div>
//                             <button onClick={closeModal}>Cancel</button>
//                             <button
//                                 onClick={() => {
//                                     console.log(`Booked: ${selectedSpot.SpotName}`);
//                                     closeModal();
//                                 }}
//                             >
//                                 Confirm
//                             </button>
//                         </div>
//                     </ModalContent>
//                 </Modal>
//             )}
//         </div>
//     );
// }

// /* Styled Components */
// const CanvasContainer = styled.div`
//     position: relative;
//     width: ${({ width }) => width}px;
//     height: ${({ height }) => height}px;
//     background-image: ${({ backgroundImage }) => `url(${backgroundImage})`};
//     background-size: cover;
//     background-position: center;
//     border: 1px solid #ccc;
//     overflow: hidden;
// `;

// const SpotBox = styled.div`
//     position: absolute;
//     border: 2px solid;
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     color: black;
//     overflow: hidden;
// `;

// const SpotLabel = styled.div`
//     font-size: 10px;
//     text-align: center;
//     user-select: none;
// `;

// const Modal = styled.div`
//     position: fixed;
//     top: 0;
//     left: 0;
//     width: 100%;
//     height: 100%;
//     background-color: rgba(0, 0, 0, 0.5);
//     display: flex;
//     justify-content: center;
//     align-items: center;
// `;

// const ModalContent = styled.div`
//     background-color: white;
//     padding: 20px;
//     border-radius: 5px;
//     text-align: center;
//     box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
//     h3 {
//         margin-bottom: 10px;
//     }
//     button {
//         margin: 5px;
//         padding: 10px 20px;
//         border: none;
//         border-radius: 5px;
//         cursor: pointer;
//     }
//     button:first-child {
//         background-color: #f44336;
//         color: white;
//     }
//     button:last-child {
//         background-color: #4caf50;
//         color: white;
//     }
// `;
